import React from "react"
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import Hammer from "hammerjs"
import * as cornerstone from "cornerstone-core"
import * as cornerstoneTools from "cornerstone-tools"
import * as cornerstoneMath from "cornerstone-math"
import * as cornerstoneFileImageLoader from "cornerstone-file-image-loader"
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader"
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader"
import * as dicomParser from 'dicom-parser'
import * as blobUtil from 'blob-util'
//import * as math from 'mathjs'
import {uids} from '../constants/uids'
import { resolveTransferSyntax } from '../utils/transferSyntax'
import { SETTINGS_SAVEAS } from '../constants/settings'
import OpenUrlDlg from './OpenUrlDlg'
import CinePlayer from './CinePlayer'
import { resolveSeriesTotalImages, resolveFileNumberOfFrames, stampNumberOfFramesOnFile } from '../utils/seriesImageCounts'
import { resolveCineFps } from '../utils/resolveCineFps'
import CinePanelShell, {
  loadCinePanelLayout,
  saveCinePanelLayout,
} from './CinePanelShell'
import LinkedPanelsGroup, {
  loadLinkedPanelsLayout,
  saveLinkedPanelsLayout,
} from './LinkedPanelsGroup'
import DsaCineHud, {
  loadDsaHudLayout,
  saveDsaHudLayout,
  normalizeDsaHudModality,
} from './DsaCineHud'
import ViewportCineScrollbar from './ViewportCineScrollbar'
import { isMobile, isTablet } from 'react-device-detect'
import db from '../db/db'
import fs from '../fs/fs'
//import { EPSILON } from '../LinearAlgebra/constants'
import Matrix from '../LinearAlgebra/Matrix'
import Point from '../LinearAlgebra/Point'
//import Vector from '../LinearAlgebra/Vector'
import Line from '../LinearAlgebra/Line'
import DicomGeometry from '../DicomGeometry/DicomGeometry'

// Importar el manager de líneas de referencia dual
import ReferenceLinesManager from '../managers/ReferenceLinesManager'
import {
  buildMprImagePlaneModule,
  buildMprObliqueImagePlaneModule,
  registerMprImagePlane,
  registerFileImagePlane,
  registerTargetSlicePlaneOnDisplay,
  buildNativeImagePlaneModule,
  shouldFlipMprZ,
  ensureMprStackGeometry,
} from '../utils/mprImagePlane'
import { computeZSpacingForVolume } from '../utils/mprVolume'
import {
  projectXzPlane,
  projectYzPlane,
  projectAxialPlane,
  slabHalfWidthFromMeta,
  slabModeLabel,
} from '../utils/mprSlab'
import { volumeIndicesToImagePixel } from '../utils/mprCrosshair'
import {
  buildObliqueOverlayModel,
  hitObliqueOverlayModel,
  lineSegmentViewportEdges,
} from '../utils/mprObliqueOverlay'
import { identityMatrix } from '../utils/mprOblique'
import {
  stampSliceGeometry,
  readFileIop,
  planeNormalFromIop,
  planeNameFromNormal,
} from '../utils/seriesLink'
import {
  applySpacingToImage,
  collectMeasurementsFromElement,
  computeUniformScaleFromLength,
  preserveMeasurementNotes,
  recalculateMeasurementData,
} from '../utils/pixelCalibration'
import {
  colorizePetImageData,
  nearestPetSliceIndex,
  petCornersInAnatomyPixels,
  sampleRoiOnPet,
  seriesLooksAnatomy,
  seriesLooksPet,
} from '../utils/petFusion'
import { suvStatsFromSamples } from '../utils/petSuv'
import {
  cloneMeasurement,
  indexGspsByReferencedSop,
  indexGspsVoiByReferencedSop,
  parseGspsFromFile,
  parsedFromImage,
} from '../utils/gspsIndex'

// Importar estilos para transiciones suaves
import './SmoothTransitions.css'

import { 
  areEqual, 
} from '../LinearAlgebra/utils'

import {
  clearStore, 
  dcmIsOpen, 
  activeDcm, 
  dcmTool, 
  activeMeasurements,
  doFsRefresh,
  setDcmEnableTool,
} from '../actions'

import {
  getDicomIpp,
  //getDicomFrameOfReferenceUID,
  capitalize,  
  getFileName,
  getSettingsOverlay,  
  getSettingsSaveInto,
  isFileImage,
  isFsFileImage,
  isLocalizer,  
  isUrlImage,
  //objectIsEmpty,
} from '../functions'

import Icon from '@mdi/react'
import { mdiImageMultipleOutline, mdiVectorLink } from '@mdi/js'
import {
  getWadoMaxWebWorkers,
  getCornerstoneImageCacheMaxBytes,
  describeDownloadProfile,
} from '../utils/mobileDownloadProfile'
import {
  ensureImageRender as ensureImageRenderUtil,
  canUseWebImageRender as canUseWebImageRenderUtil,
  isWebPreviewImage,
  previewWwwcCssFilter,
  logicalWwwcToCss,
  DEFAULT_CLINICAL_WW,
  DEFAULT_CLINICAL_WC,
  WEB_PREVIEW_DISPLAY_VOI,
  applyNeutralWebPreviewVoi,
} from '../utils/ensureImageRender'
import { lockCornerstoneCanvasContext } from '../utils/patchCanvasNoDesync'
import { RENDER_MODE } from '../utils/renderMode'
import {
  destroyMagnifyLoupe,
  hideMagnifyLoupe,
  paintMagnifyLoupe,
} from '../utils/magnifyLoupe'
import { loadPreviewFromCacheBySop } from '../utils/loadPreviewInstance'
import {
  getScrollWarmupPolicy,
  buildWarmupIndexOrder,
} from '../utils/scrollWarmupPolicy'
import { resolveScrollFeelTuning } from '../utils/scrollFeelPrefs'
import {
  markInteractionStart,
  markInteractionEnd,
} from '../utils/viewportInteractionDetector'
import {
  dsaBaseImageId,
  dsaDefaultBias,
  subtractFrame,
  ensureDsaOutBuffer,
  DSA_DEFAULTS,
} from '../utils/dsaSubtract'
import { createDsaGpuPipeline, hasWebGl2 } from '../utils/dsaGpuPipeline'
import {
  computeTemporalSynth,
  synthPixelsToDataUrl,
  defaultSynthMode,
} from '../utils/dsaTemporalMip'
import {
  suggestCardiacMask,
  meanSubsample,
} from '../utils/dsaCardiacGate'


const scrollToIndex = cornerstoneTools.import('util/scrollToIndex')

cornerstoneTools.external.cornerstone = cornerstone
cornerstoneTools.external.cornerstoneMath = cornerstoneMath
cornerstoneFileImageLoader.external.cornerstone = cornerstone
cornerstoneWebImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.cornerstone = cornerstone
cornerstoneWADOImageLoader.external.dicomParser = dicomParser
cornerstoneTools.external.Hammer = Hammer
cornerstoneTools.init({
  globalToolSyncEnabled: true,
  mouseEnabled: true,
  touchEnabled: true,
})

// Mediciones: verde activo al dibujar; asentadas con contraste sobre grises DICOM
// (default de cornerstone-tools: inactive=white → se pierde en la imagen).
try {
  if (cornerstoneTools.toolColors) {
    cornerstoneTools.toolColors.setActiveColor('#76FF03')
    cornerstoneTools.toolColors.setToolColor('#00E5A8')
  }
  if (cornerstoneTools.toolStyle && typeof cornerstoneTools.toolStyle.setToolWidth === 'function') {
    cornerstoneTools.toolStyle.setToolWidth(2)
  }
} catch (e) {
  console.warn('DicomViewer - toolColors config:', e)
}

// Web workers WADO: perfil mobile download (pocos workers en phone).
if (!window.__cornerstoneWebWorkerManagerInitialized) {
  try {
    let baseUrl = process.env.PUBLIC_URL || ''
    if (!baseUrl || baseUrl === '/') {
      const pathname = window.location.pathname
      const hostname = window.location.hostname
      const port = window.location.port
      if (pathname.includes('/u-dicom-viewer')) {
        const match = pathname.match(/^(\/u-dicom-viewer)/)
        baseUrl = match ? match[1] : '/u-dicom-viewer'
      } else if (hostname === 'localhost' || hostname === '127.0.0.1' || port === '3000') {
        baseUrl = ''
      } else {
        baseUrl = ''
      }
    }
    const webWorkerPath = `${baseUrl}/cornerstoneWADOImageLoaderWebWorker.js`
    const maxWebWorkersForWado = getWadoMaxWebWorkers()
    try {
      // eslint-disable-next-line no-console
      console.info('[UDV] WADO workers=', maxWebWorkersForWado, describeDownloadProfile())
    } catch (e) {
      /* ignore */
    }
    cornerstoneWADOImageLoader.webWorkerManager.initialize({
      maxWebWorkers: maxWebWorkersForWado,
      startWebWorkersOnDemand: true,
      webWorkerPath: webWorkerPath,
      taskConfiguration: {
        decodeTask: {
          initializeCodecsOnStartup: true,
          usePDFJS: false,
          strict: false,
        },
      },
    })
    window.__cornerstoneWebWorkerManagerInitialized = true
    try {
      if (cornerstone.imageCache && typeof cornerstone.imageCache.setMaximumSizeBytes === 'function') {
        cornerstone.imageCache.setMaximumSizeBytes(getCornerstoneImageCacheMaxBytes())
      }
    } catch (cacheErr) {
      console.warn('imageCache setMaximumSizeBytes:', cacheErr)
    }
  } catch (e) {
    console.warn('WADO webWorkerManager init:', e)
  }
}

class DicomViewer extends React.Component {
    /** Tools cornerstone registradas una sola vez en la app (no por viewport/slice). */
    static _globalToolsAdded = false

    constructor(props) {
      super(props)
      this.files = null
      this.filename = ''
      this.localfile = null
      this.localurl = null
      this.fsItem = null
      this.dicomImage = null
      this.explorerIndex = 0
      this.imageId = null
      this.image = null
      this.isDicom = false
      this.isChangingSeries = false
      this.layoutIndex = 0
      this.numberOfFrames = 1
      this.measurements = []
      this.xSize = 0
      this.ySize = 0
      this.zSize = 0
      this.volume = null
      this.originImage = null
      this.mprPlane = ''
      this.sliceMax = 0
      this.sliceIndex = 0
      this.mpr = {}      
      this.referenceLines = {}
      this.shouldScroll = false
      this.savedViewport = null
      this.toolState = {} // { [seriesInstanceUID]: { ww, wc, zoom } }
      this.imageCache = new Map() // Cache por imageId (no por índice: el stack se reordena en descarga)
      this._imageCacheOrder = [] // FIFO/LRU ligero para no retener 3k WebP
      this._previewPrefetchInFlight = 0
      this._previewPrefetchTimer = null
      this._pendingScrollHydrateIndex = null
      this._postScrollHydrateTimer = null
      this._postScrollHydrateIdle = null
      this._warmScrollGen = 0
      this._warmScrollTimer = null
      this._imageCacheMaxEntries = 120
      this._warmStudyFiles = null
      this._scrollDirection = 1
      this._neighborWarmInFlight = false
      this.preloadQueue = [] // Cola de imágenes para pre-cargar
      this._wheelResidual = 0
      this._wheelLastTs = 0
      this._wheelBurst = 0
      this._wheelUiSyncTimer = null
      this._petFusionRaf = null
      this._petFusionLoadGen = 0
      this._petFusionLastKey = ''
      this._gspsBySop = {}
      this._gspsVoiBySop = {}
      this._gspsIndexGen = 0
      this._gspsAppliedSop = null
      this._gspsFilesKey = ''
      this._mouseDragResidual = 0
      this._preloadDeferTimer = null
      this._seekTarget = null
      this._pendingSeek = null
      this._seekRaf = null
      this._dragOriginIndex = 0
      this._dragOriginY = 0
      this._inertiaLastTs = 0
      this._inertiaPps = 8
      this._stackPanActive = false
      this.updateTimeout = null // Timeout para debounce de actualizaciones
      this.isUpdating = false // Flag para evitar actualizaciones concurrentes
      this.isNavigating = false // Flag para evitar navegación concurrente
      this._displayGen = 0 // Descarta pintados async obsoletos al scrollear rápido
      this._stackCineTimer = null
      this._stackCineRaf = null
      this._cineLastTs = 0
      this._cineAccMs = 0
      this._cinePaintBusy = false
      this._cineUserClosed = false // si el usuario ocultó el cine, no reabrir auto hasta cambiar serie
      this._cineFpsUserSet = false // slider manual: no pisar con tags al scrollear
      this._cineFpsSource = 'default'
      // XA / multi-frame: scroll navega frames del SOP (no solo files.length)
      this._multiFrameStackActive = false
      this._cineScrollRef = React.createRef()
      /** DSA: máscara cacheada + buffer de salida reutilizado (cine) */
      this._dsa = {
        enabled: false,
        maskMode: null,
        maskFrameIndex: null,
        maskLoadedFrameIndex: null,
        pixelShift: { x: 0, y: 0 },
        invertDSA: DSA_DEFAULTS.invertDSA,
        gain: DSA_DEFAULTS.gain,
        offset: null,
        noiseFloor: DSA_DEFAULTS.noiseFloor,
        maskPixels: null,
        outBuffer: null,
        /** Cache de frame sustraído: evita re-subtract en LUT+paint del mismo imageId */
        outCacheKey: null,
        sourceImageId: null,
        bias: null,
        loadGen: 0,
        /** DSA 2.0 */
        engineMode: 'auto',
        engine: 'cpu',
        gpu: null,
        gpuFailed: false,
        roadmapOn: false,
        roadmapAlpha: 0.45,
        roadmapLut: 1,
        roadmapPixels: null,
        gateMethod: null,
        lastSynth: null,
      }
      // App actualiza vía reconfigureWwwcForRenderMode; evitar prop congelada
      this._appRenderMode =
        props.renderMode === RENDER_MODE.PREVIEW ||
        props.renderMode === RENDER_MODE.DIAGNOSTIC
          ? props.renderMode
          : null
    }

    state = {
      visibleOpenUrlDlg: false,
      progress: null,
      visibleCinePlayer: false,
      errorOnOpenImage: null,
      errorOnCors: false,
      frame: 1,
      inPlay: false,
      cineFps: 30,
      cineLoop: true,
      viewport: null,
      /** Snapshot UI del HUD DSA (cine); no usar props congeladas del constructor. */
      dsaHud: {
        enabled: false,
        maskFrameIndex: null,
        invertDSA: false,
        gain: 1,
        offset: null,
        noiseFloor: 8,
        pixelShift: { x: 0, y: 0 },
      },
      /** left | right | free + coords (localStorage) */
      dsaHudLayout: loadDsaHudLayout(),
      /** bottom | left | right | free — panel de cine flotante */
      cinePanelLayout: loadCinePanelLayout(),
      /** Grupo cine+DSA dockeados: bottom | free */
      linkedPanelsLayout: loadLinkedPanelsLayout(),
      /** Overlay SVG MPR oblicuo (líneas coloreadas + handles) */
      obliqueOverlay: null,
    }

    componentDidMount() {
      //console.log('dicomviewer - componentDidMount: ')
      this.props.runTool(this)
      this.props.changeTool(this)
      cornerstone.events.addEventListener('cornerstoneimageloaded', this.onImageLoaded)
      const { dcmRef } = this.props
      dcmRef(this)          
      this.layoutIndex = this.props.index

      // Configurar el gestor de eventos del mouse wheel con { passive: false }
      const element = document.getElementById(`viewer-${this.props.index}`)
      if (element) {
        element.addEventListener("wheel", this.handlerMouseScroll, { passive: false })
        
        // Agregar soporte para mouse drag en desktop
        element.addEventListener("mousedown", this.handlerMouseDown, { passive: false, capture: true })
        element.addEventListener("mousemove", this.handlerMouseMove, { passive: false, capture: true })
        element.addEventListener("mouseup", this.handlerMouseUp, { passive: false, capture: true })
        element.addEventListener("mouseleave", this.handlerMouseUp, { passive: false, capture: true })
        element.addEventListener("mousedown", this.handlerCrosshairPointerDown, { passive: true, capture: true })
        element.addEventListener("mouseup", this.handlerCrosshairPointerUp, { passive: false, capture: true })
        // WW/WC táctil: al soltar, si se aplicó, volver a notool
        element.addEventListener("touchstart", this.handlerWwwcTouchStart, { passive: true, capture: true })
        element.addEventListener("touchmove", this.handlerWwwcTouchMove, { passive: false, capture: true })
        element.addEventListener("touchend", this.handlerWwwcTouchEnd, { passive: true, capture: true })
        element.addEventListener("touchcancel", this.handlerWwwcTouchEnd, { passive: true, capture: true })
        element.addEventListener("touchstart", this.handlerCrosshairPointerDown, { passive: true, capture: true })
        element.addEventListener("touchend", this.handlerCrosshairPointerUp, { passive: false, capture: true })
        element.addEventListener("touchcancel", this.handlerCrosshairPointerCancel, { passive: true, capture: true })
        // Suavizar Wwwc nativo táctil (DIAGNOSTIC)
        element.addEventListener(
          'cornerstonetoolstouchdrag',
          this.softenNativeWwwcTouchDelta,
          true
        )
        element.addEventListener('contextmenu', this.handlerJoystickContextMenu, {
          passive: false,
          capture: true,
        })
        element.addEventListener('touchstart', this.handlerJoystickTouchStart, {
          passive: true,
          capture: true,
        })
        element.addEventListener('touchmove', this.handlerJoystickTouchMove, {
          passive: false,
          capture: true,
        })
        element.addEventListener('touchend', this.handlerJoystickTouchEnd, {
          passive: true,
          capture: true,
        })
        element.addEventListener('touchcancel', this.handlerJoystickTouchEnd, {
          passive: true,
          capture: true,
        })
      }

      // Agregar listener para cambios de orientación en móviles
      window.addEventListener('orientationchange', this.handleOrientationChange)
      window.addEventListener('resize', this.handleResize)

      // Configurar Hammer.js para gestos táctiles
      // Detectar el tipo de dispositivo
      const isTabletDevice = isTablet || (window.innerWidth >= 768 && window.innerWidth <= 1024)
      const isPhoneDevice = isMobile && !isTabletDevice
      
      // Detectar Samsung S24 FE específicamente
      const isSamsungS24FE = /SM-S721B|SM-S721N|SM-S721U|SM-S721W/.test(navigator.userAgent) || 
                            (navigator.userAgent.includes('Samsung') && 
                             navigator.userAgent.includes('SM-S721'))
      
      // Usar el método centralizado para configurar Hammer.js
      this.setupHammerJS(element, isPhoneDevice, isSamsungS24FE)
      if (this.props.gsps && this.props.gsps.files && this.props.gsps.files.length) {
        this.ensureGspsIndex()
      }
    }

    componentWillUnmount() {
      this.props.runTool(undefined)
      this.props.changeTool(undefined)
      const { dcmRef } = this.props
      dcmRef(undefined)

      try {
        this.teardownDsaGpu && this.teardownDsaGpu()
      } catch (e) {
        /* ignore */
      }

      if (this._resetFitRaf != null) {
        cancelAnimationFrame(this._resetFitRaf)
        this._resetFitRaf = null
      }
      if (typeof this._unbindDoubleTap === 'function') {
        this._unbindDoubleTap()
        this._unbindDoubleTap = null
      }

      this.unbindCrosshairWindow()
      this.unbindMagnifyPointers()
      destroyMagnifyLoupe()

      // Limpiar el gestor de eventos del mouse wheel y drag
      const element = document.getElementById(`viewer-${this.props.index}`)
      if (element) {
        element.removeEventListener("wheel", this.handlerMouseScroll)
        element.removeEventListener("mousedown", this.handlerMouseDown)
        element.removeEventListener("mousemove", this.handlerMouseMove)
        element.removeEventListener("mouseup", this.handlerMouseUp)
        element.removeEventListener("mouseleave", this.handlerMouseUp)
        element.removeEventListener("mousedown", this.handlerCrosshairPointerDown, true)
        element.removeEventListener("mouseup", this.handlerCrosshairPointerUp, true)
        element.removeEventListener("touchstart", this.handlerWwwcTouchStart)
        element.removeEventListener("touchmove", this.handlerWwwcTouchMove)
        element.removeEventListener("touchend", this.handlerWwwcTouchEnd)
        element.removeEventListener("touchcancel", this.handlerWwwcTouchEnd)
        element.removeEventListener("touchstart", this.handlerCrosshairPointerDown, true)
        element.removeEventListener("touchend", this.handlerCrosshairPointerUp, true)
        element.removeEventListener("touchcancel", this.handlerCrosshairPointerCancel, true)
        element.removeEventListener(
          'cornerstonetoolstouchdrag',
          this.softenNativeWwwcTouchDelta,
          true
        )
        element.removeEventListener(
          'contextmenu',
          this.handlerJoystickContextMenu,
          true
        )
        element.removeEventListener('touchstart', this.handlerJoystickTouchStart, true)
        element.removeEventListener('touchmove', this.handlerJoystickTouchMove, true)
        element.removeEventListener('touchend', this.handlerJoystickTouchEnd, true)
        element.removeEventListener('touchcancel', this.handlerJoystickTouchEnd, true)
      }
      
      // Limpiar Hammer.js custom (no destruir element.hammer de cornerstone-tools)
      if (this._customHammer) {
        this._customHammer.destroy()
        this._customHammer = null
      }
      this.cancelStackInertia()
      if (this._stackRaf) {
        cancelAnimationFrame(this._stackRaf)
        this._stackRaf = null
      }
      this._stackQueue = 0
      if (this._seekRaf) {
        cancelAnimationFrame(this._seekRaf)
        this._seekRaf = null
      }
      this._pendingSeek = null
      if (this._wheelUiSyncTimer) {
        clearTimeout(this._wheelUiSyncTimer)
        this._wheelUiSyncTimer = null
      }
      if (this._preloadDeferTimer) {
        clearTimeout(this._preloadDeferTimer)
        this._preloadDeferTimer = null
      }

      // Remover listeners de orientación y resize
      window.removeEventListener('orientationchange', this.handleOrientationChange)
      window.removeEventListener('resize', this.handleResize)

      // Limpiar timeouts y cache
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout)
        this.updateTimeout = null
      }
      this.imageCache.clear()
      this._imageCacheOrder = []
      this.preloadQueue = []
      this.isUpdating = false
      this.stopStackCineTimer()
      if (this._petFusionRaf) {
        cancelAnimationFrame(this._petFusionRaf)
        this._petFusionRaf = null
      }
    }

    componentDidUpdate(previousProps) {
      //console.log('dicomviewer - componentDidUpdate: ')
      // Resetear estado de doble tap al cambiar de serie/archivos
      if (previousProps.files !== this.props.files) {
        this._doubleTapZoomed = false
      }
      if (
        previousProps.renderMode !== this.props.renderMode &&
        this.props.renderMode
      ) {
        try {
          this._appRenderMode = this.props.renderMode
          this.reconfigureWwwcForRenderMode(this.props.renderMode)
        } catch (e) {
          console.warn('DicomViewer - reconfigureWwwcForRenderMode:', e)
        }
      }
      if (
        previousProps.mprCrosshairPoint !== this.props.mprCrosshairPoint ||
        previousProps.mprCrosshairActive !== this.props.mprCrosshairActive ||
        previousProps.mprObliqueActive !== this.props.mprObliqueActive ||
        previousProps.mprObliqueMatrix !== this.props.mprObliqueMatrix ||
        previousProps.visibleReferenceLines !== this.props.visibleReferenceLines ||
        previousProps.mprLayoutActive !== this.props.mprLayoutActive
      ) {
        if (this.props.mprCrosshairActive && !previousProps.mprCrosshairActive) {
          this.suspendStackDrag()
        } else if (!this.props.mprCrosshairActive && previousProps.mprCrosshairActive) {
          this.releaseCrosshairCapture()
        }
        this.updateCrosshairOverlay()
        this.updateObliqueOverlay()
      }
      const fusion = this.props.petFusion
      const prevFusion = previousProps.petFusion
      if (
        fusion &&
        (!prevFusion ||
          prevFusion.on !== fusion.on ||
          prevFusion.opacity !== fusion.opacity ||
          prevFusion.clut !== fusion.clut ||
          prevFusion.windowMax !== fusion.windowMax ||
          prevFusion.files !== fusion.files)
      ) {
        this.schedulePetFusionPaint()
      }
      this.syncGspsFromProps(previousProps.gsps, this.props.gsps)
      const isOpen = this.props.isOpen[this.props.index]
      if (this.props.layout !== previousProps.layout && isOpen && this.dicomImage) {
        try {
            // Verificar si el elemento está habilitado antes de hacer resize
            const enabledElement = cornerstone.getEnabledElement(this.dicomImage)
            if (enabledElement) {
                cornerstone.resize(this.dicomImage)
            }
        } catch (error) {
            console.warn('DicomViewer - Element not enabled for resize:', error)
        }
      }
      // Tras re-render Redux (isOpen, tools...), React resetea nodos vacíos:
      // re-pintar contador/overlays ligeros si hay stack.
      const wasOpen =
        previousProps.isOpen && previousProps.isOpen[this.props.index]
      if (
        isOpen !== wasOpen ||
        previousProps.dcmEnableTool !== this.props.dcmEnableTool
      ) {
        if (this.files && this.files.length > 0) {
          try {
            this.updateImageInfoDisplay({
              light: this.isDicom === false || this.isPreviewImage(this.image, this.files[this.sliceIndex]),
            })
          } catch (e) {
            /* ignore */
          }
        }
      }
    }

    // Manejar cambios de orientación en móviles
    handleOrientationChange = () => {
      // Usar timeout para esperar a que termine la animación de rotación
      setTimeout(() => {
        this.handleResize()
        // Reconfigurar Hammer.js después del cambio de orientación
        this.reconfigureHammerJS()
        
        // Log adicional para debugging
        console.log(`DicomViewer - Orientación cambiada para viewport ${this.props.index}, shouldScroll: ${this.shouldScroll}`)
      }, 1200) // Aumentar a 1200ms para dar más tiempo al layout en viewports múltiples
    }

    // Manejar cambios de tamaño de ventana
    handleResize = () => {
      const isOpen = this.props.isOpen[this.props.index]
      if (isOpen && this.dicomImage) {
        try {
          // Verificar si el elemento está habilitado antes de hacer resize
          const enabledElement = cornerstone.getEnabledElement(this.dicomImage)
          if (enabledElement) {
            // Usar debounce para evitar múltiples llamadas
            if (this.updateTimeout) {
              clearTimeout(this.updateTimeout)
            }

            // Móvil/FS: debounce más largo para absorber tormenta de resize immersive
            const debounceMs = isMobile ? 180 : 100

            this.updateTimeout = setTimeout(() => {
              const el = this.dicomImage
              if (!el) return
              const w = el.clientWidth || 0
              const h = el.clientHeight || 0
              const prev = this._lastViewerSize || { w: -1, h: -1 }
              const sizeChanged =
                Math.abs(w - prev.w) >= 2 || Math.abs(h - prev.h) >= 2
              if (!sizeChanged) {
                return
              }
              this._lastViewerSize = { w, h }

              cornerstone.resize(this.dicomImage)
              // Tras resize el contexto se reinicia; bloquear desynchronized otra vez
              lockCornerstoneCanvasContext(this.dicomImage)
              // Forzar re-render de la imagen actual
              if (this.image) {
                cornerstone.updateImage(this.dicomImage)
              }

              // Reconfigurar Hammer solo si el tamaño cambió de verdad
              if (isMobile) {
                this.reconfigureHammerJS()
              }
            }, debounceMs)
          }
        } catch (error) {
          console.warn('DicomViewer - Error during resize:', error)
        }
      }
    }

    // Reconfigurar Hammer.js después de cambios de orientación
    reconfigureHammerJS = () => {
      const element = document.getElementById(`viewer-${this.props.index}`)
      if (!element) {
        console.warn(`DicomViewer - Elemento no encontrado para viewport ${this.props.index}`)
        return
      }

      try {
        // Detectar el tipo de dispositivo
        const isTabletDevice = isTablet || (window.innerWidth >= 768 && window.innerWidth <= 1024)
        const isPhoneDevice = isMobile && !isTabletDevice
        
        // Detectar Samsung S24 FE específicamente
        const isSamsungS24FE = /SM-S721B|SM-S721N|SM-S721U|SM-S721W/.test(navigator.userAgent) || 
                              (navigator.userAgent.includes('Samsung') && 
                               navigator.userAgent.includes('SM-S721'))
        
        console.log(`DicomViewer - Dispositivo detectado: ${isTabletDevice ? 'TABLET' : isPhoneDevice ? 'TELÉFONO' : 'DESKTOP'}`)
        if (isSamsungS24FE) {
          console.log('DicomViewer - Samsung S24 FE detectado - aplicando configuración específica')
        }
        
        // Multi-SOP o multi-frame (XA): ambos deben scrollear
        this.refreshScrollFlags()
        console.log(
          `DicomViewer - shouldScroll viewport ${this.props.index}: ${this.shouldScroll} ` +
            `(files=${(this.files && this.files.length) || 0}, frames=${this.numberOfFrames || 1})`
        )
        console.log(
          `DicomViewer - Dispositivo detectado: ${isTabletDevice ? 'TABLET' : isPhoneDevice ? 'TELÉFONO' : 'DESKTOP'}`
        )

        // Destruir el Hammer custom propio (no tocar element.hammer de cornerstone-tools)
        if (this._customHammer) {
          console.log(`DicomViewer - Destruyendo Hammer custom para viewport ${this.props.index}`)
          this._customHammer.destroy()
          this._customHammer = null
        }

        // Verificar que el elemento esté visible y tenga dimensiones
        // Si no tiene dimensiones válidas, esperar y reintentar
        const checkDimensions = () => {
          const rect = element.getBoundingClientRect()
          console.log(`DicomViewer - Verificando dimensiones para viewport ${this.props.index}: ${rect.width}x${rect.height}`)
          
          if (rect.width === 0 || rect.height === 0) {
            console.warn(`DicomViewer - Elemento viewport ${this.props.index} no tiene dimensiones válidas: ${rect.width}x${rect.height}, reintentando...`)
            // Reintentar después de un breve delay para permitir que el layout se estabilice
            setTimeout(() => {
              const retryRect = element.getBoundingClientRect()
              console.log(`DicomViewer - Reintento de dimensiones para viewport ${this.props.index}: ${retryRect.width}x${retryRect.height}`)
              
              if (retryRect.width > 0 && retryRect.height > 0) {
                console.log(`DicomViewer - Dimensiones válidas obtenidas en reintento para viewport ${this.props.index}: ${retryRect.width}x${retryRect.height}`)
                this.setupHammerJS(element, isPhoneDevice)
              } else {
                console.error(`DicomViewer - No se pudieron obtener dimensiones válidas para viewport ${this.props.index} después del reintento`)
                // Intentar una vez más con un delay mayor
                setTimeout(() => {
                  const finalRect = element.getBoundingClientRect()
                  console.log(`DicomViewer - Segundo reintento para viewport ${this.props.index}: ${finalRect.width}x${finalRect.height}`)
                  
                  if (finalRect.width > 0 && finalRect.height > 0) {
                    console.log(`DicomViewer - Dimensiones válidas en segundo reintento para viewport ${this.props.index}`)
                    this.setupHammerJS(element, isPhoneDevice)
                  } else {
                    console.error(`DicomViewer - Fallo definitivo al obtener dimensiones para viewport ${this.props.index}`)
                  }
                }, 500)
              }
            }, 300) // Aumentar delay del primer reintento
            return false
          }
          return true
        }

        if (!checkDimensions()) {
          return
        }

        // Configurar Hammer.js
        this.setupHammerJS(element, isPhoneDevice, isSamsungS24FE)
      } catch (error) {
        console.warn(`DicomViewer - Error reconfigurando Hammer.js para viewport ${this.props.index}:`, error)
      }
    }

    // Método para configurar Hammer.js (extraído para reutilización)
    setupHammerJS = (element, isPhoneDevice, isSamsungS24FE = false) => {
      // Destruir instancia custom previa si existe
      if (this._customHammer) {
        this._customHammer.destroy()
        this._customHammer = null
      }

      const hammer = new Hammer.Manager(element)
      this._customHammer = hammer
      
      // Configurar reconocedores de gestos
      const pinch = new Hammer.Pinch({
        enable: true,
        threshold: 0,
        pointers: 2,
      })

      // Pan con 2 dedos → pan de imagen (evento propio, no mixto con scroll)
      const pan2 = new Hammer.Pan({
        event: 'pan2',
        direction: Hammer.DIRECTION_ALL,
        threshold: 0,
        enable: true,
        pointers: 2
      })

      // 1 dedo: solo stack-scroll cuando no hay tool de Cornerstone activa.
      // Si queda enable:true, Hammer se come Magnify/Length/Angle.
      const panScroll = new Hammer.Pan({
        event: 'pan',
        direction: Hammer.DIRECTION_ALL,
        threshold: 0,
        pointers: 1,
        enable: () => {
          if (this._magnifyMode) return false
          const tool = this.props.tool
          return !tool || tool === 'notool' || tool === 'Invert'
        },
      })
      this._hammerPanScroll = panScroll

      hammer.add([pinch, pan2, panScroll])

      // Pinch y pan de 2 dedos se reconocen juntos (zoom + desplazamiento)
      pinch.recognizeWith(pan2)

      // Detector de doble tap manual via touchstart nativo (evita conflicto con Pan threshold:0)
      let _lastTapTs = 0
      let _lastTapX = 0
      let _lastTapY = 0
      const DOUBLE_TAP_MS = 300
      const DOUBLE_TAP_PX = 40
      const onNativeDoubleTap = (e) => {
        if (e.touches && e.touches.length > 1) return // ignorar multitáctil
        const now = Date.now()
        const touch = e.touches ? e.touches[0] : e
        const dx = touch.clientX - _lastTapX
        const dy = touch.clientY - _lastTapY
        const dist = Math.sqrt(dx * dx + dy * dy)
        if (now - _lastTapTs < DOUBLE_TAP_MS && dist < DOUBLE_TAP_PX) {
          // Doble tap detectado — toggle zoom/fit centrado en el punto tocado
          isZooming = false
          lastPan2Center = null
          this._stackPanActive = false
          this.cancelStackInertia()
          this.toggleDoubleTapZoom(touch.clientX, touch.clientY)
          _lastTapTs = 0 // reset para no disparar triples
          e.preventDefault()
        } else {
          _lastTapTs = now
          _lastTapX = touch.clientX
          _lastTapY = touch.clientY
        }
      }
      element.addEventListener('touchstart', onNativeDoubleTap, { passive: false })
      this._unbindDoubleTap = () => element.removeEventListener('touchstart', onNativeDoubleTap)

      // Estado para controlar el modo actual
      let isZooming = false
      let lastPan2Center = null

      // Stack scroll 1 dedo: mapa absoluto (como el slider) + inercia al soltar
      let lastPanVelocityY = 0
      let sampleVelY = 0
      let lastMoveTs = 0
      let lastSampleDeltaY = 0

      const isSinglePointer = (e) => {
        const maxPointers = e.maxPointers != null ? e.maxPointers : (e.pointers ? e.pointers.length : 1)
        return maxPointers < 2
      }

      const canStackScroll = (e) => {
        if (isZooming || !isSinglePointer(e)) return false
        if (this.props.tool !== 'notool') return false
        if (this.isCrosshairAiming()) return false
        this.refreshScrollFlags()
        return this.getStackNavMax() > 1
      }

      const beginStackPan = (e) => {
        this.notifyViewportInteraction('drag')
        if (this.state.inPlay) {
          try {
            this.runCinePlayer('pause')
          } catch (err) {
            /* ignore */
          }
        }
        this.cancelStackInertia()
        this._stackPanActive = true
        lastPanVelocityY = 0
        sampleVelY = 0
        lastMoveTs = performance.now()
        lastSampleDeltaY = e.deltaY || 0
        this.ensureScrollStackReady()
        this._scrollSeriesUid =
          this.fileSeriesUid(this.files && this.files[this.sliceIndex]) ||
          this.fileSeriesUid(this.files && this.files[0]) ||
          this._scrollSeriesUid
        this._dragOriginIndex = this.getStackNavIndex()
        this._seekTarget = this._dragOriginIndex
        this._inertiaPps = this.pxPerSliceSlider()
      }

      // Aplica traslación de imagen (misma lógica que PanMultiTouchTool de cornerstone-tools)
      const applyTwoFingerPan = (dx, dy) => {
        if (!element || (Math.abs(dx) < 0.01 && Math.abs(dy) < 0.01)) return
        try {
          const viewport = cornerstone.getViewport(element)
          if (!viewport) return
          const image = cornerstone.getImage(element)
          if (!image) return

          let widthScale = viewport.scale
          let heightScale = viewport.scale
          const rowSpacing = image.rowPixelSpacing
          const colSpacing = image.columnPixelSpacing

          if (rowSpacing && colSpacing) {
            if (rowSpacing < colSpacing) {
              widthScale *= colSpacing / rowSpacing
            } else if (colSpacing < rowSpacing) {
              heightScale *= rowSpacing / colSpacing
            }
          }

          viewport.translation.x += dx / widthScale
          viewport.translation.y += dy / heightScale
          cornerstone.setViewport(element, viewport)
        } catch (error) {
          console.debug('DicomViewer - Error applying two-finger pan:', error)
        }
      }

      // Manejar el gesto de pinch (zoom)
      hammer.on('pinchstart', () => {
        if (this.isObliqueGestureBlocking()) return
        isZooming = true
        this._stackPanActive = false
        this.cancelStackInertia()
        // El usuario hizo zoom manual: el siguiente doble tap ofrecerá zoom-in
        this._doubleTapZoomed = false
        cornerstoneTools.setToolActive('ZoomTouchPinch', { mouseButtonMask: 1 })
      })

      hammer.on('pinchmove', () => {
        if (this.isObliqueGestureBlocking()) return
        if (isZooming) {
          cornerstoneTools.setToolActive('ZoomTouchPinch', { mouseButtonMask: 1 })
        }
      })

      hammer.on('pinchend', () => {
        isZooming = false
      })

      // Pan de imagen con 2 dedos (desplazamiento conjunto)
      hammer.on('pan2start', (e) => {
        if (this.isObliqueGestureBlocking()) {
          lastPan2Center = null
          return
        }
        lastPan2Center = { x: e.center.x, y: e.center.y }
        this._stackPanActive = false
        this.cancelStackInertia()
      })

      hammer.on('pan2move', (e) => {
        if (this.isObliqueGestureBlocking()) return
        if (!lastPan2Center) {
          lastPan2Center = { x: e.center.x, y: e.center.y }
          return
        }
        const dx = e.center.x - lastPan2Center.x
        const dy = e.center.y - lastPan2Center.y
        lastPan2Center = { x: e.center.x, y: e.center.y }
        applyTwoFingerPan(dx, dy)
      })

      hammer.on('pan2end pan2cancel', () => {
        lastPan2Center = null
      })

      // Stack scroll: el dedo mapea como el slider (posición → corte) y coalesced rAF
      hammer.on('panstart', (e) => {
        if (!canStackScroll(e)) {
          this._stackPanActive = false
          return
        }
        beginStackPan(e)
      })

      hammer.on('panmove', (e) => {
        if (!canStackScroll(e)) return
        // Si panstart se perdió (cambio de serie / Hammer), enganchar en el primer move
        if (!this._stackPanActive) beginStackPan(e)
        const now = performance.now()
        const dt = now - lastMoveTs
        const ddy = e.deltaY - lastSampleDeltaY
        if (dt > 0 && dt < 90) sampleVelY = ddy / dt
        lastMoveTs = now
        lastSampleDeltaY = e.deltaY
        lastPanVelocityY = e.velocityY != null ? e.velocityY : lastPanVelocityY
        const pps = this._inertiaPps || this.pxPerSliceSlider()
        this._seekTarget = this._dragOriginIndex + e.deltaY / pps
        this.seekStackTo(this._seekTarget)
      })

      hammer.on('panend pancancel', (e) => {
        if (!this._stackPanActive) return
        this._stackPanActive = false
        if (!canStackScroll(e) && this.props.tool !== 'notool') return
        this.refreshScrollFlags()
        if (this.getStackNavMax() <= 1 || isZooming || this.isCrosshairAiming()) return
        const hammerVel = e.velocityY != null ? e.velocityY : lastPanVelocityY
        const vel = Math.abs(sampleVelY) > 0.04 ? sampleVelY : hammerVel
        // Inercia solo en touch y con umbral alto; desktop: frena al soltar.
        const feel = this.getStackScrollFeel()
        if (feel.allowTouchInertia && Math.abs(vel) > 0.45) {
          this.startStackInertia(vel)
        } else {
          this.stopDesktopStackCoast()
          this.flushWheelUiSync()
        }
        lastPanVelocityY = 0
        sampleVelY = 0
      })


      console.log(`DicomViewer - Hammer.js configurado para viewport ${this.props.index}, shouldScroll: ${this.shouldScroll}, tool: ${this.props.tool}${isSamsungS24FE ? ', Samsung S24 FE optimizado' : ''}`)
    }

    // --- Stack scroll: seek absoluto coalesced (como el slider) + inercia ---
    _stackQueue = 0
    _stackRaf = null
    _inertiaRaf = null
    _inertiaVel = 0

    getStackNavMax = () => {
      try {
        if (typeof this.isMultiFrameCine === 'function' && this.isMultiFrameCine() && this.numberOfFrames > 1) {
          return this.numberOfFrames
        }
      } catch (e) {
        /* ignore */
      }
      if (this.isMprGenerated && this.sliceMax > 1) return this.sliceMax
      const fileLen = (this.files && this.files.length) || 0
      const sliceMax = Number(this.sliceMax) || 0
      // Navegar solo dentro del buffer real (stubs R2/local cuentan).
      // sliceMax se setea al abrir serie con el stack completo.
      return Math.max(1, fileLen, sliceMax)
    }

    getStackNavIndex = () => {
      if (this._pendingSeek != null && Number.isFinite(this._pendingSeek)) {
        return this._pendingSeek
      }
      try {
        if (typeof this.isMultiFrameCine === 'function' && this.isMultiFrameCine()) {
          // XA: sliceIndex es el SOP (casi siempre 0); el índice real es el frame del stack
          if (typeof this.getMultiFrameIndex0 === 'function') {
            return this.getMultiFrameIndex0()
          }
          return Math.max(0, (this.state.frame || 1) - 1)
        }
      } catch (e) {
        /* ignore */
      }
      return this.sliceIndex || 0
    }

    /**
     * Perfil de stack-scroll según N.
     * Largas (≥100): slider (alto del viewport → stack), clamp [1.6, 18].
     * Cortas (<40): ganancia tipo cinta (~6 px/corte) para no “trabar y saltar”.
     * 40–100: interpolación.
     */
    getStackScrollFeel = () => {
      const n = this.getStackNavMax()
      const el = this.dicomImage
      const h =
        (el && (el.clientHeight || el.offsetHeight)) ||
        (typeof window !== 'undefined' ? window.innerHeight : 600) ||
        600
      const mapped = n <= 1 ? 12 : h / Math.max(1, n - 1)
      const sliderPps = Math.max(1.6, Math.min(18, mapped))
      // Series cortas: más px/corte en desktop evita “temblor” al arrastrar lento
      // (el target flotante no cruza el umbral por ruido de 1–2 px).
      const filmPps = isMobile || isTablet ? 8.5 : 14
      const SHORT_N = 40
      const LONG_N = 100
      let t = 1
      if (n <= 1 || n < SHORT_N) t = 0
      else if (n < LONG_N) t = (n - SHORT_N) / (LONG_N - SHORT_N)
      const pps = t >= 1 ? sliderPps : filmPps * (1 - t) + sliderPps * t
      const short = n < 80
      const long = n >= LONG_N
      const mpr = this.isMprScrollRoute && this.isMprScrollRoute()
      const tuning = resolveScrollFeelTuning({ mpr })
      const touchy = !!(isMobile || isTablet)
      const wheelScale = Number(tuning.wheelScale) > 0 ? tuning.wheelScale : 1
      return {
        n,
        short,
        long,
        touchy,
        mpr,
        pps: n <= 1 ? 12 : pps,
        dragHysteresis: short ? 0.62 : 0.55,
        inertiaDecay: tuning.inertiaDecay,
        inertiaVelScale: tuning.inertiaVelScale,
        inertiaMaxSlices: touchy
          ? Math.max(1, Math.min(tuning.inertiaMaxSlicesCap || 4, Math.round(n * 0.04)))
          : Math.max(1, Math.min(2, Math.round(n * 0.015))),
        allowTouchInertia: !!(tuning.allowTouchInertia && touchy),
        wheelPx: (short
          ? Math.min(36, Math.max(22, pps * 2.4))
          : Math.min(48, Math.max(28, sliderPps * 1.6))) * wheelScale,
        wheelBurstCap: 1,
        wheelEventCap: 1,
        allowWheelCoast: false,
        wheelCoastCap: 0,
        wheelLiveMs: tuning.wheelLiveMs || 80,
        mprMinIntervalMs: tuning.mprMinIntervalMs || 0,
        filmStep: short,
      }
    }

    /** px por corte (drag / inercia). */
    pxPerSliceSlider = () => this.getStackScrollFeel().pps

    /**
     * UID de serie de un item del stack (sin mezclar otras series).
     */
    fileSeriesUid = (fileData) => {
      if (!fileData) return null
      const uid =
        fileData.seriesInstanceUID ||
        (fileData.series && fileData.series.seriesInstanceUID) ||
        null
      return uid ? String(uid) : null
    }

    /**
     * Recorta el stack a la serie activa. Nunca incorporar props.files (estudio entero).
     */
    ensureScrollStackReady = () => {
      this.refreshScrollFlags()
      if (this.isMprGenerated && this.sliceMax > 1) return
      if (this.numberOfFrames > 1 && this._multiFrameStackActive) return
      if (!Array.isArray(this.files) || this.files.length === 0) return

      const fromCurrent =
        this.fileSeriesUid(this.files[this.sliceIndex]) ||
        this.fileSeriesUid(this.files[0])
      const uid = this._scrollSeriesUid || fromCurrent
      if (uid) this._scrollSeriesUid = uid

      // Evitar filter O(n) en cada rAF de scroll (estudios 3k+ se traban).
      // Solo refiltrar si cambió la referencia del stack o el UID de serie.
      if (uid) {
        const sameRef =
          this._scrollStackRef === this.files &&
          this._scrollStackUid === uid &&
          this._scrollStackLen === this.files.length
        if (!sameRef) {
          const headUid = this.fileSeriesUid(this.files[0])
          const midUid = this.fileSeriesUid(
            this.files[Math.floor(this.files.length / 2)]
          )
          const tailUid = this.fileSeriesUid(this.files[this.files.length - 1])
          const alreadyOnly =
            headUid === uid && midUid === uid && tailUid === uid
          if (!alreadyOnly) {
            const only = this.files.filter((f) => this.fileSeriesUid(f) === uid)
            if (only.length > 0 && only.length !== this.files.length) {
              this.files = only
            }
          }
          this._scrollStackRef = this.files
          this._scrollStackUid = uid
          this._scrollStackLen = this.files.length
        }
      }

      const n = this.files.length
      if (n > 0) {
        this.sliceMax = n
        if (this.sliceIndex > n - 1) this.sliceIndex = n - 1
        if (this.sliceIndex < 0) this.sliceIndex = 0
      }
      this.refreshScrollFlags()
    }

    seekStackTo = (index) => {
      this.ensureScrollStackReady()
      const max = this.getStackNavMax()
      if (max <= 1) return
      const n = Number(index)
      this._seekTarget = Number.isFinite(n) ? n : 0
      if (this._seekTarget < 0) this._seekTarget = 0
      if (this._seekTarget > max - 1) this._seekTarget = max - 1
      this._pendingSeek = Math.round(this._seekTarget)
      if (!this._seekRaf) {
        this._seekRaf = requestAnimationFrame(this._flushSeek)
      }
    }

    _flushSeek = (now) => {
      this._seekRaf = null
      this.ensureScrollStackReady()
      const maxI = Math.max(0, this.getStackNavMax() - 1)
      if (this.getStackNavMax() <= 1) {
        this._inertiaVel = 0
        return
      }

      const feel = this.getStackScrollFeel()
      const tNow = typeof now === 'number' ? now : performance.now()
      if (this._inertiaVel) {
        const dt = Math.max(8, Math.min(34, tNow - (this._inertiaLastTs || tNow)))
        this._inertiaLastTs = tNow
        const navIdx = this.getStackNavIndex()
        this._seekTarget =
          (this._seekTarget != null ? this._seekTarget : navIdx) +
          this._inertiaVel * dt
        // Clamp distancia desde origen de inercia
        const origin =
          this._inertiaOriginIndex != null
            ? this._inertiaOriginIndex
            : navIdx
        const maxTravel = feel.inertiaMaxSlices || 2
        if (this._seekTarget > origin + maxTravel) {
          this._seekTarget = origin + maxTravel
          this._inertiaVel = 0
        } else if (this._seekTarget < origin - maxTravel) {
          this._seekTarget = origin - maxTravel
          this._inertiaVel = 0
        }
        this._inertiaVel *= feel.inertiaDecay
        if (this._seekTarget <= 0) {
          this._seekTarget = 0
          this._inertiaVel = 0
        } else if (this._seekTarget >= maxI) {
          this._seekTarget = maxI
          this._inertiaVel = 0
        }
        if (Math.abs(this._inertiaVel) < 0.001) this._inertiaVel = 0
      }

      if (this._seekTarget == null) return
      let target = this._seekTarget
      if (target < 0) target = 0
      if (target > maxI) target = maxI

      // Índice realmente mostrado (no el pending del coalesce, que bloqueaba el paint)
      this._pendingSeek = null
      // Crítico en XA multi-frame: no usar sliceIndex (es el SOP, casi siempre 0)
      const current = this.getStackNavIndex()
      const diff = target - current
      const ad = Math.abs(diff)
      const sign = diff > 0 ? 1 : -1
      if (ad >= 0.35) this._scrollDirection = sign
      const wheelLive = this.isWheelGestureLive()
      const pointerLive = this.isPointerStackDragLive()
      const live = wheelLive || pointerLive || !!this._inertiaVel
      const dragHyst =
        Number(feel.dragHysteresis) > 0
          ? feel.dragHysteresis
          : feel.short
            ? 0.62
            : 0.55
      let next
      if (pointerLive && !this._inertiaVel) {
        if (target >= current + dragHyst) next = current + 1
        else if (target <= current - dragHyst) next = current - 1
        else next = current
      } else if (ad < 0.35) {
        next = Math.round(target)
      } else if (live) {
        next = current + sign
      } else if (ad <= 1.35) {
        next = current + sign
      } else {
        // Solo fuera de gesto (p.ej. seek programático): avanzar de a 1–2
        next = current + sign * Math.min(2, Math.ceil(ad * 0.2))
      }
      next = Math.max(0, Math.min(maxI, Math.round(next)))
      if (
        next === current &&
        ad >= 0.45 &&
        !(pointerLive && !this._inertiaVel)
      ) {
        next = Math.max(0, Math.min(maxI, current + sign))
      }
      if (next !== current && live && !(pointerLive && !this._inertiaVel)) {
        next = this.pickScrollPaintIndex(current, next, sign, maxI)
      }

      if (next !== current) {
        // Paint local + sync UI diferido (igual que rueda); evita setState/App por frame.
        if (wheelLive || pointerLive || this._inertiaVel) this.paintWheelSeek(next)
        else this.handleCineScrollbarSeek(next)
      }

      const painted = this.getStackNavIndex()
      const remaining = Math.abs(target - painted)
      if (Math.abs(this._inertiaVel || 0) > 0) {
        this._seekRaf = requestAnimationFrame(this._flushSeek)
      } else if (pointerLive) {
        // Tirón: seguir alcanzando. Banda de histéresis: esperar próximo mousemove.
        if (remaining >= dragHyst) {
          this._seekRaf = requestAnimationFrame(this._flushSeek)
        }
      } else if (remaining >= 0.5) {
        this._seekRaf = requestAnimationFrame(this._flushSeek)
      } else {
        this.flushWheelUiSync()
      }
    }

    /** Arrastre de stack (touch 1 dedo o mouse en notool). */
    isPointerStackDragLive = () => !!(this._stackPanActive || this.isMouseDown)

    /**
     * Scroll “en vivo”: rueda, drag o inercia reciente → paint ligero sin setState por frame.
     */
    isStackScrollLive = () => {
      if (this.isPointerStackDragLive()) return true
      if (Math.abs(this._inertiaVel || 0) > 0) return true
      return this.isWheelGestureLive()
    }

    isWheelGestureLive = () => {
      const now = performance.now()
      if (this._wheelCoastTimer) return true
      const feel =
        typeof this.getStackScrollFeel === 'function'
          ? this.getStackScrollFeel()
          : null
      const liveMs = Math.max(40, Number(feel && feel.wheelLiveMs) || 80)
      if (now - (this._wheelLastTs || 0) < liveMs) return true
      if (this._inertiaVel && now - (this._wheelLastTs || 0) < 900) return true
      return false
    }

    /**
     * Paint local de scroll (rueda / drag / inercia): canvas + overlay,
     * sin setState de App en cada frame.
     */
    /** MPR (nativo o reconstruido): reproyectar vía App, no stack nativo en canvas. */
    isMprScrollRoute = () => {
      if (this.isMprGenerated) return true
      return (
        !!this.props.mprLayoutActive &&
        typeof this.props.onSliceSeek === 'function'
      )
    }

    scheduleMprLiveSliceSeek = (clamped) => {
      this._mprLiveSeekPending = clamped
      if (this._mprLiveSeekTimer) return
      this._mprLiveSeekTimer = setTimeout(() => {
        this._mprLiveSeekTimer = null
        const idx = this._mprLiveSeekPending
        this._mprLiveSeekPending = null
        if (idx == null || typeof this.props.onSliceSeek !== 'function') return
        this.props.onSliceSeek(this.props.index, idx)
      }, 24)
    }

    seekMprLiveSlice = (index) => {
      const max = this.getStackNavMax()
      const clamped = Math.max(
        0,
        Math.min(Math.max(0, max - 1), Math.round(Number(index) || 0))
      )
      this._wheelLastTs = performance.now()
      this.sliceIndex = clamped
      try {
        this.updateImageInfoDisplay({ light: true })
      } catch (e) {
        /* ignore */
      }
      this.syncCineScrollbar()
      this.scheduleMprLiveSliceSeek(clamped)
      this.scheduleScrollSliceNotify()
    }

    /**
     * Avisa al loader (Redux/IDB/workers) que el viewport está en gestos vivos.
     */
    notifyViewportInteraction = (type = 'scroll') => {
      try {
        markInteractionStart(type)
        markInteractionEnd(320)
      } catch (e) {
        /* ignore */
      }
    }

    paintWheelSeek = (index) => {
      this.notifyViewportInteraction('scroll')
      if (this.isMprScrollRoute()) {
        this.seekMprLiveSlice(index)
        return
      }
      // XA multi-frame: seek directo al stack (no pasar por App cada tick)
      if (this.numberOfFrames > 1 && this._multiFrameStackActive) {
        if (this.state.inPlay) {
          try {
            this.runCinePlayer('pause')
          } catch (e) {
            /* ignore */
          }
        }
        const max = this.numberOfFrames
        const clamped = Math.max(0, Math.min(max - 1, Math.round(index)))
        const element = this.dicomImage
        if (element) {
          try {
            scrollToIndex(element, clamped)
          } catch (err) {
            console.warn('DicomViewer - paintWheelSeek multi-frame:', err)
            return
          }
        }
        this._wheelMultiFrameIndex = clamped
        try {
          this.paintFrameCountersDom(clamped + 1, max)
        } catch (e) {
          /* ignore */
        }
        this.syncCineScrollbar()
        this.scheduleWheelUiSync()
        return
      }
      const max = this.getStackNavMax()
      const clamped = Math.max(0, Math.min(Math.max(0, max - 1), Math.round(index)))
      const prevIdx = this.sliceIndex || 0
      if (!this.smoothImageTransition(clamped)) {
        this.displayImageFromFiles(clamped)
      }
      // Asegurar sync del slider aunque updateImageInfoDisplay falle/early-return
      this.syncCineScrollbar()
      this.scheduleWheelUiSync()
      this.scheduleScrollSliceNotify()
      // Calentar el siguiente corte en la dirección del gesto (1 in-flight, idle)
      const dir = clamped >= prevIdx ? 1 : -1
      this.kickScrollNeighborWarm(clamped, dir)
    }

    /**
     * Notifica a App el corte actual durante scroll (rAF coalesced).
     * Mueve líneas de referencia / scout sin setState por frame.
     */
    scheduleScrollSliceNotify = () => {
      // Slave conducido por Link Series: no re-notificar (evita ping-pong / lag)
      if (this._seriesLinkDriven) return
      if (typeof this.props.onScrollSlicePaint !== 'function') return
      if (this._scrollSliceNotifyRaf) return
      this._scrollSliceNotifyRaf = requestAnimationFrame(() => {
        this._scrollSliceNotifyRaf = null
        if (this._seriesLinkDriven) return
        if (typeof this.props.onScrollSlicePaint !== 'function') return
        let idx = this.sliceIndex || 0
        if (this.numberOfFrames > 1 && this._multiFrameStackActive) {
          idx =
            this._wheelMultiFrameIndex != null
              ? this._wheelMultiFrameIndex
              : this.getMultiFrameIndex0()
        }
        this.props.onScrollSlicePaint(this.props.index, idx)
      })
    }

    /**
     * Contador avanza de a 1 (current±1). El proxy visual está en smoothImageTransition.
     */
    pickScrollPaintIndex = (current, want, sign, maxI) => {
      const s = sign >= 0 ? 1 : -1
      const delta = Math.round(want) - current
      if (delta === 0) return Math.max(0, Math.min(maxI, current + s))
      // Mid-gesto: nunca más de ±1 (evita saltos visuales)
      if (Math.abs(delta) >= 1) {
        return Math.max(0, Math.min(maxI, current + s))
      }
      return Math.max(0, Math.min(maxI, current + s))
    }

    /**
     * Prefetch vecinos según policy (forward/back). Mid-scroll: solo sync store.
     */
    kickScrollNeighborWarm = (center, direction) => {
      const files = this.files === null ? this.props.files : this.files
      if (!Array.isArray(files) || !files.length) return
      const dir = direction >= 0 ? 1 : -1
      this._scrollDirection = dir
      const policy = getScrollWarmupPolicy({
        renderMode:
          this._appRenderMode ||
          (this.isPreviewStackFiles()
            ? RENDER_MODE.PREVIEW
            : RENDER_MODE.DIAGNOSTIC),
        seriesLength: files.length,
        studyLength: files.length,
      })
      const fwd = Math.max(1, policy.forwardRadius || 8)
      const back = Math.max(0, policy.backRadius || 3)
      const idxs = []
      for (let d = 1; d <= fwd; d++) idxs.push(center + dir * d)
      for (let d = 1; d <= back; d++) idxs.push(center - dir * d)
      const live = this.isStackScrollLive()
      for (let k = 0; k < idxs.length; k++) {
        const i = idxs[k]
        if (i < 0 || i >= files.length) continue
        const f = files[i]
        if (!f || !(f.imageId || f.sopInstanceUID)) continue
        if (this.getMemoryCachedImage(f)) continue
        if (live) {
          const mem = this.findStoreRamImage(f)
          if (mem && mem.image) {
            this.rememberDecodedImage(f, mem.image, mem.imageId)
          }
          continue
        }
        if (this._neighborWarmInFlight) return
        this._neighborWarmInFlight = true
        const run = () => {
          this.hydrateFileImagePreferringCache(f)
            .then((loaded) => {
              if (loaded && loaded.image) {
                this.rememberDecodedImage(f, loaded.image, loaded.imageId)
              }
            })
            .catch(() => {})
            .finally(() => {
              this._neighborWarmInFlight = false
            })
        }
        if (typeof requestIdleCallback === 'function') {
          requestIdleCallback(run, { timeout: 180 })
        } else {
          setTimeout(run, 0)
        }
        return
      }
    }

    scheduleWheelUiSync = () => {
      // Diferir setState de App hasta que el gesto termine. Con estudios grandes
      // (3k+ en Redux) un setState cada ~90 ms re-renderiza App y traba el scroll
      // en series grandes y chicas del mismo estudio.
      if (this._wheelUiSyncTimer) clearTimeout(this._wheelUiSyncTimer)
      this._wheelUiSyncTimer = setTimeout(() => {
        this._wheelUiSyncTimer = null
        if (this.isStackScrollLive()) {
          this.scheduleWheelUiSync()
          return
        }
        this.flushWheelUiSync()
      }, 140)
    }

    flushWheelUiSync = () => {
      if (this._wheelUiSyncTimer) {
        clearTimeout(this._wheelUiSyncTimer)
        this._wheelUiSyncTimer = null
      }
      if (this.isMprGenerated) {
        if (typeof this.props.onSliceSeek === 'function') {
          this.props.onSliceSeek(this.props.index, this.sliceIndex || 0)
        }
        return
      }
      if (typeof this.props.onSliceSeek !== 'function') {
        this.schedulePostScrollHydrate(this.sliceIndex)
        return
      }
      let idx = this.sliceIndex || 0
      if (this.numberOfFrames > 1 && this._multiFrameStackActive) {
        idx =
          this._wheelMultiFrameIndex != null
            ? this._wheelMultiFrameIndex
            : this.getMultiFrameIndex0()
        // Sincronizar state.frame una vez al soltar la rueda
        if (this.state.frame !== idx + 1) {
          this.setState({ frame: idx + 1 })
        }
      }
      this.props.onSliceSeek(this.props.index, idx)
      // Tras soltar: hidratar el corte actual + warmup direccional (idle)
      this.schedulePostScrollHydrate(idx)
      const boost =
        (this._wheelBurst || 0) >= 6
          ? Math.min(24, Math.round((this._wheelBurst || 0) * 1.5))
          : 0
      this.scheduleWarmScrollBuffer({
        centerIndex: idx,
        direction: this._scrollDirection || 1,
        boostForward: boost,
        renderMode:
          this._appRenderMode ||
          (this.isPreviewStackFiles()
            ? RENDER_MODE.PREVIEW
            : RENDER_MODE.DIAGNOSTIC),
      })
    }

    seekStackByDelta = (delta) => {
      if (!delta) return
      const cur =
        this._seekTarget != null ? this._seekTarget : this.getStackNavIndex()
      this.seekStackTo(cur + delta)
    }

    cancelStackInertia = () => {
      if (this._inertiaRaf) {
        cancelAnimationFrame(this._inertiaRaf)
        this._inertiaRaf = null
      }
      if (this._wheelCoastTimer) {
        clearTimeout(this._wheelCoastTimer)
        this._wheelCoastTimer = null
      }
      this._wheelPendingVel = 0
      this._inertiaVel = 0
    }

    /**
     * Desktop: al soltar el mouse, cortar chase/inercia y quedar en el corte
     * ya pintado (sin “patín” hasta el _seekTarget del tirón).
     */
    stopDesktopStackCoast = () => {
      if (this._seekRaf) {
        cancelAnimationFrame(this._seekRaf)
        this._seekRaf = null
      }
      if (this._mprLiveSeekTimer) {
        clearTimeout(this._mprLiveSeekTimer)
        this._mprLiveSeekTimer = null
      }
      this._mprLiveSeekPending = null
      this.cancelStackInertia()
      this._pendingSeek = null
      const cur = this.getStackNavIndex()
      this._seekTarget = cur
      this._wheelResidual = 0
    }

    isCrosshairAiming = () => {
      if (!this.props.mprCrosshairActive) return false
      // Oblicuo ON: bloquear stack-scroll / pan competidor con handles
      if (this.props.mprObliqueActive || this._mprObliqueGesture) return true
      const tool = this.props.tool
      return tool !== 'Wwwc' && tool !== 'Pan' && tool !== 'Zoom' && tool !== 'Magnify'
    }

    /** Pinch/pan2 no deben mover el canvas mientras hay MPR oblicuo activo. */
    isObliqueGestureBlocking = () =>
      !!(this.props.mprObliqueActive && this.props.mprCrosshairActive)

    /** Corta scroll por arrastre/inercia para que la mira no cambie de corte. */
    suspendStackDrag = () => {
      this.isMouseDown = false
      this.mouseHasNavigated = false
      this._stackPanActive = false
      this._stackQueue = 0
      this.stopDesktopStackCoast()
    }

    /**
     * Compat: deltas de rueda/cine → seek coalesced (un paint por frame).
     */
    enqueueStackSteps = (deltaSteps) => {
      if (!deltaSteps) return
      this.refreshScrollFlags()
      if (this.getStackNavMax() <= 1) return
      this.seekStackByDelta(deltaSteps)
    }

    /**
     * Inercia al soltar: velocidad en px/ms → cortes; el chase de _flushSeek pinta.
     */
    startStackInertia = (velocityY) => {
      this.refreshScrollFlags()
      if (this.getStackNavMax() <= 1 || this.props.tool !== 'notool') return
      const feel = this.getStackScrollFeel()
      if (!feel.allowTouchInertia) return
      const pps = this._inertiaPps || feel.pps
      if (!(pps > 0)) return
      let vel = (velocityY / pps) * (feel.inertiaVelScale || 1)
      const maxSlices = feel.inertiaMaxSlices || 2
      const maxVel = maxSlices / 400
      if (vel > maxVel) vel = maxVel
      if (vel < -maxVel) vel = -maxVel
      if (Math.abs(vel) < 0.002) return
      this._inertiaVel = vel
      this._inertiaOriginIndex =
        this._seekTarget != null ? this._seekTarget : this.getStackNavIndex()
      if (this._seekTarget == null) {
        this._seekTarget = this.getStackNavIndex()
      }
      this._inertiaLastTs = performance.now()
      if (!this._seekRaf) {
        this._seekRaf = requestAnimationFrame(this._flushSeek)
      }
    }

    /** Wheel / cine de stack: notool, o mira activa (el drag de mira no usa este path). */
    canWheelNavigate = () => {
      this.refreshScrollFlags()
      if (this.getStackNavMax() <= 1) return false
      const tool = this.props.tool
      return (
        !tool ||
        tool === 'notool' ||
        tool === 'Invert' ||
        tool === 'mprCrosshair' ||
        !!this.props.mprCrosshairActive
      )
    }

    smoothNavigate = (direction, frames) => {
      if (!this.canWheelNavigate()) return
      const n = Math.max(1, frames || 1)
      this.enqueueStackSteps(direction > 0 ? n : -n)
    }

    // Método para forzar reconfiguración de Hammer.js (llamado desde App.js)
    forceReconfigureHammerJS = () => {
      console.log(`DicomViewer - Forzando reconfiguración de Hammer.js para viewport ${this.props.index}`)
      this.reconfigureHammerJS()
    }
  
    isMeasurementOrDrawTool = (tool) => {
      return (
        tool === 'Length' ||
        tool === 'Angle' ||
        tool === 'CobbAngle' ||
        tool === 'EllipticalRoi' ||
        tool === 'RectangleRoi' ||
        tool === 'FreehandRoi' ||
        tool === 'Probe' ||
        tool === 'Magnify'
      )
    }

    /** Joystick siempre disponible; el gesto cambia según la tool. */
    canOpenJoystick = () => true

    openJoystickAt = (clientX, clientY) => {
      if (typeof this.props.onJoystickOpen !== 'function') return
      if (typeof this.props.onViewportActivate === 'function') {
        this.props.onViewportActivate(this.props.index)
      }
      this.props.onJoystickOpen({
        x: clientX,
        y: clientY,
        viewerIndex: this.props.index,
      })
    }

    handlerJoystickContextMenu = (e) => {
      // Con medición activa: el long-press táctil dibuja; el click derecho de mouse
      // sí debe abrir el joystick. (button 2 = derecho; touch LP suele ir con button 0)
      if (this.isMeasurementOrDrawTool(this.props.tool)) {
        const isMouseRight = e.button === 2 || e.which === 3
        if (!isMouseRight) return
      }
      e.preventDefault()
      e.stopPropagation()
      this.openJoystickAt(e.clientX, e.clientY)
    }

    handlerJoystickTouchStart = (e) => {
      const touches = e.touches
      if (!touches || !touches.length) {
        this.clearJoystickLongPress()
        return
      }

      const needTwoFingers = this.isMeasurementOrDrawTool(this.props.tool)

      if (needTwoFingers) {
        // 1 dedo = medición; joystick = 2 dedos quietos
        if (touches.length !== 2) {
          this.clearJoystickLongPress()
          return
        }
        const t0 = touches[0]
        const t1 = touches[1]
        this._joystickLP = {
          x: (t0.clientX + t1.clientX) / 2,
          y: (t0.clientY + t1.clientY) / 2,
          fired: false,
          twoFinger: true,
        }
      } else {
        if (touches.length !== 1) {
          this.clearJoystickLongPress()
          return
        }
        const t0 = touches[0]
        this._joystickLP = {
          x: t0.clientX,
          y: t0.clientY,
          fired: false,
          twoFinger: false,
        }
      }

      this.clearJoystickLongPress()
      const holdMs = needTwoFingers ? 400 : 450
      this._joystickLPTimer = setTimeout(() => {
        this._joystickLPTimer = null
        if (!this._joystickLP || this._joystickLP.fired) return
        this._joystickLP.fired = true
        // Evitar que el pinch/gesto nativo siga después de abrir el menú
        this._joystickSuppressPinchUntil = Date.now() + 600
        this.openJoystickAt(this._joystickLP.x, this._joystickLP.y)
      }, holdMs)
    }

    handlerJoystickTouchMove = (e) => {
      if (
        this._joystickSuppressPinchUntil &&
        Date.now() < this._joystickSuppressPinchUntil &&
        e.cancelable
      ) {
        try {
          e.preventDefault()
        } catch (err) {
          /* ignore */
        }
      }
      if (!this._joystickLP || !this._joystickLPTimer) return
      const touches = e.touches
      if (!touches || !touches.length) return

      if (this._joystickLP.twoFinger) {
        if (touches.length !== 2) {
          this.clearJoystickLongPress()
          return
        }
        const x = (touches[0].clientX + touches[1].clientX) / 2
        const y = (touches[0].clientY + touches[1].clientY) / 2
        const dx = x - this._joystickLP.x
        const dy = y - this._joystickLP.y
        // Umbral un poco más holgado: dos dedos tiemblan más
        if (dx * dx + dy * dy > 220) {
          this.clearJoystickLongPress()
        }
        return
      }

      const t0 = touches[0]
      if (!t0) return
      const dx = t0.clientX - this._joystickLP.x
      const dy = t0.clientY - this._joystickLP.y
      if (dx * dx + dy * dy > 144) {
        this.clearJoystickLongPress()
      }
    }

    handlerJoystickTouchEnd = (e) => {
      // Si queda 1 dedo tras un intento de 2, cancelar LP del joystick
      if (this._joystickLP && this._joystickLP.twoFinger) {
        const left = e.touches ? e.touches.length : 0
        if (left < 2) this.clearJoystickLongPress()
        return
      }
      this.clearJoystickLongPress()
    }

    clearJoystickLongPress = () => {
      if (this._joystickLPTimer) {
        clearTimeout(this._joystickLPTimer)
        this._joystickLPTimer = null
      }
    }

    handlerMouseScroll = (event) => {
        event.preventDefault()

        if (typeof this.props.onViewportActivate === 'function') {
          this.props.onViewportActivate(this.props.index)
        }

        if (!this.canWheelNavigate()) return

        if (this.state.inPlay) {
          try {
            this.runCinePlayer('pause')
          } catch (e) {
            /* ignore */
          }
        }

        const dyRaw = event.deltaY
        if (!dyRaw) return

        let slices = 0
        const feelPx = this.getStackScrollFeel()
        const mprWheel = this.isMprScrollRoute && this.isMprScrollRoute()
        const minGap = mprWheel ? Math.max(40, Number(feelPx.mprMinIntervalMs) || 70) : 0
        const now0 = performance.now()
        if (minGap && now0 - (this._wheelLastApplied || 0) < minGap) {
          return
        }

        if (event.deltaMode === 1) {
          this._wheelResidual = 0
          slices = dyRaw > 0 ? 1 : -1
        } else if (event.deltaMode === 2) {
          this._wheelResidual = 0
          slices = dyRaw > 0 ? 1 : -1
        } else {
          if ((this._wheelResidual > 0 && dyRaw < 0) || (this._wheelResidual < 0 && dyRaw > 0)) {
            this._wheelResidual = 0
          }
          const instantPx = mprWheel ? 220 : 100
          if (!mprWheel && Math.abs(dyRaw) >= instantPx) {
            this._wheelResidual = 0
            slices = dyRaw > 0 ? 1 : -1
          } else {
            this._wheelResidual += dyRaw
            const pxPerSlice = feelPx.wheelPx
            const eventCap = feelPx.wheelEventCap || 1
            while (Math.abs(this._wheelResidual) >= pxPerSlice) {
              const d = this._wheelResidual > 0 ? 1 : -1
              this._wheelResidual -= d * pxPerSlice
              slices += d
              if (Math.abs(slices) >= eventCap) break
            }
          }
        }
        if (!slices) return

        this._wheelLastApplied = now0
        const now = now0
        const sinceLast = now - (this._wheelLastTs || 0)
        this._wheelLastTs = now
        if (sinceLast > 140) this._wheelBurst = 0
        this._wheelBurst = (this._wheelBurst || 0) + 1

        // Sin coast inercial de rueda: cada notch es 1 corte y se corta al soltar.
        this.cancelStackInertia()
        if (Math.abs(slices) > 1) slices = slices > 0 ? 1 : -1
        this.seekStackByDelta(slices)
    }

    // Variables para manejo de mouse drag
    isMouseDown = false
    mouseStartY = 0
    mouseHasNavigated = false

    // WW/WC: tras aplicar en el viewport, volver a notool (scroll ágil)
    _wwwcPointerActive = false
    _wwwcDidModify = false
    _wwwcStartWW = null
    _wwwcStartWC = null

    // PREVIEW web: WW/WC vía CSS filter (cero setViewport / re-draw en drag)
    // Los valores clínicos viven en toolState[seriesUID].ww/wc; _previewWwwc es solo CSS.
    _previewWwwc = { brightness: 1, contrast: 1, invert: false }
    _wwwcRef = { ww: DEFAULT_CLINICAL_WW, wc: DEFAULT_CLINICAL_WC }
    _logicalWwwc = { ww: DEFAULT_CLINICAL_WW, wc: DEFAULT_CLINICAL_WC }
    _cssWwwcMode = false
    _cssWwwcDragging = false
    _cssWwwcLastX = 0
    _cssWwwcLastY = 0
    _cssWwwcPointerId = null

    isCurrentWebPreview = () => {
      try {
        if (this.canUseWebImageRender(this.image)) return true
        const f =
          Array.isArray(this.files) && this.files[this.sliceIndex]
            ? this.files[this.sliceIndex]
            : null
        return this.isPreviewImage(this.image, f)
      } catch (e) {
        return false
      }
    }

    /**
     * Ancla de ventana (look neutro del WebP / default estudio).
     */
    resolveWwwcAnchor = (image, fileData) => {
      // WebP/JPG ya ventaneado: ancla 8-bit (no HU clínico del manifest)
      try {
        if (
          this.canUseWebImageRender(image) ||
          this.isPreviewImage(image, fileData)
        ) {
          if (!(image && image.data)) {
            return {
              ww: WEB_PREVIEW_DISPLAY_VOI.windowWidth,
              wc: WEB_PREVIEW_DISPLAY_VOI.windowCenter,
            }
          }
        }
      } catch (e) {
        /* ignore */
      }
      let ww = DEFAULT_CLINICAL_WW
      let wc = DEFAULT_CLINICAL_WC
      try {
        // DIAG: tags DICOM por instancia (no manifest uniforme en scouts .Ref)
        if (image && image.data && typeof image.data.string === 'function') {
          try {
            const tWw = parseFloat(
              String(image.data.string('x00281051') || '').split('\\')[0]
            )
            const tWc = parseFloat(
              String(image.data.string('x00281050') || '').split('\\')[0]
            )
            if (Number.isFinite(tWw) && tWw > 0) {
              ww = tWw
              if (Number.isFinite(tWc)) wc = tWc
              return { ww, wc }
            }
          } catch (e) {
            /* ignore */
          }
        }
        const fd = fileData && typeof fileData === 'object' ? fileData : null
        if (fd) {
          const mWw = fd.windowWidth != null ? Number(fd.windowWidth) : NaN
          const mWc = fd.windowCenter != null ? Number(fd.windowCenter) : NaN
          if (Number.isFinite(mWw) && mWw > 0) {
            ww = mWw
            if (Number.isFinite(mWc)) wc = mWc
            return { ww, wc }
          }
        }
        const rawWw =
          image && image.windowWidth != null ? Number(image.windowWidth) : NaN
        const rawWc =
          image && image.windowCenter != null ? Number(image.windowCenter) : NaN
        // 255/128 típicos del web-loader → no usar como ancla clínica
        if (Number.isFinite(rawWw) && rawWw > 1 && rawWw !== 255) {
          ww = rawWw
          if (Number.isFinite(rawWc)) wc = rawWc
        }
      } catch (e) {
        /* ignore */
      }
      return { ww, wc }
    }

    isDiagnosticDicomImage = (image, fileData) => {
      try {
        return (
          !this.shouldUseCssWwwc() &&
          !this.isPreviewImage(image, fileData) &&
          !!(image && image.data)
        )
      } catch (e) {
        return false
      }
    }

    isSeriesWwwcUserSet = (seriesUID) => {
      const st = seriesUID && this.toolState ? this.toolState[seriesUID] : null
      return !!(st && st.wwwcUserSet)
    }

    markSeriesWwwcUserSet = (seriesUID) => {
      if (!seriesUID) return
      try {
        if (this.isActiveLocalWwwcFrame()) return
      } catch (e) {
        /* ignore */
      }
      this.toolState[seriesUID] = {
        ...(this.toolState[seriesUID] || {}),
        wwwcUserSet: true,
      }
    }

    /**
     * Estado de vista para scroll: zoom/pan siempre; WW/WC solo si el usuario ventaneó.
     */
    buildPreferredViewStateForScroll = (seriesUID, currentViewport, seriesChanged) => {
      const st = seriesUID && this.toolState ? this.toolState[seriesUID] : null
      if (st) {
        const preferred = {
          zoom: st.zoom,
          translation: st.translation,
          rotation: st.rotation,
        }
        if (st.wwwcUserSet && st.ww != null && st.wc != null) {
          preferred.ww = st.ww
          preferred.wc = st.wc
          preferred.wwwcUserSet = true
        }
        return preferred
      }
      if (seriesChanged) return null
      const cloned = this.cloneViewportViewState(currentViewport)
      if (!cloned) return null
      cloned.ww = null
      cloned.wc = null
      return cloned
    }

    /**
     * Series key para toolState / VOI lógico.
     */
    getActiveSeriesUidKey = () => {
      try {
        const f =
          Array.isArray(this.files) && this.files[this.sliceIndex]
            ? this.files[this.sliceIndex]
            : null
        return this.getSeriesUidFrom(this.image, f)
      } catch (e) {
        return `stack:v${this.props.index}`
      }
    }

    /**
     * Lee ww/wc clínicos de toolState o defaults.
     * @returns {{ ww: number, wc: number }}
     */
    getLogicalWwwc = () => {
      // PREVIEW web: el VOI vivo es _logicalWwwc (255/128 + ajustes CSS).
      // No reusar toolState clínico de DIAG (deja el filtro “quemado”).
      if (typeof this.shouldUseCssWwwc === 'function' && this.shouldUseCssWwwc()) {
        return {
          ww:
            this._logicalWwwc.ww != null
              ? this._logicalWwwc.ww
              : WEB_PREVIEW_DISPLAY_VOI.windowWidth,
          wc:
            this._logicalWwwc.wc != null
              ? this._logicalWwwc.wc
              : WEB_PREVIEW_DISPLAY_VOI.windowCenter,
        }
      }
      // SC / preview en stack mixto (.Ref): no devolver VOI clínico de la serie
      try {
        if (this.isActiveLocalWwwcFrame()) {
          return {
            ww:
              this._logicalWwwc.ww != null
                ? this._logicalWwwc.ww
                : WEB_PREVIEW_DISPLAY_VOI.windowWidth,
            wc:
              this._logicalWwwc.wc != null
                ? this._logicalWwwc.wc
                : WEB_PREVIEW_DISPLAY_VOI.windowCenter,
          }
        }
      } catch (eLoc) {
        /* ignore */
      }
      const seriesUID = this.getActiveSeriesUidKey()
      const st = seriesUID && this.toolState ? this.toolState[seriesUID] : null
      if (st && st.wwwcUserSet && st.ww != null && st.wc != null) {
        return { ww: Number(st.ww), wc: Number(st.wc) }
      }
      return {
        ww: this._logicalWwwc.ww != null ? this._logicalWwwc.ww : DEFAULT_CLINICAL_WW,
        wc: this._logicalWwwc.wc != null ? this._logicalWwwc.wc : DEFAULT_CLINICAL_WC,
      }
    }

    /**
     * Escribe ww/wc clínicos en toolState de la serie + memoria local.
     * En frames SC/preview solo actualiza _logicalWwwc (no contamina la serie).
     * @param {number} ww
     * @param {number} wc
     * @param {{ applyCss?: boolean, markUserSet?: boolean }} [opts]
     */
    setLogicalWwwc = (ww, wc, opts = {}) => {
      const w = Math.max(1, Number(ww) || DEFAULT_CLINICAL_WW)
      const c = Number.isFinite(Number(wc)) ? Number(wc) : DEFAULT_CLINICAL_WC
      this._logicalWwwc = { ww: w, wc: c }
      // PREVIEW: no escribir toolState clínico (255/128 o drag CSS contaminaba DIAG → “carbón”)
      if (typeof this.shouldUseCssWwwc === 'function' && this.shouldUseCssWwwc()) {
        if (opts.applyCss !== false) {
          try {
            this.syncPreviewCssFromLogical()
          } catch (e) {
            /* ignore */
          }
        }
        return
      }
      // Secondary Capture / preview en .Ref: ventaneo solo local a este frame
      try {
        if (this.isActiveLocalWwwcFrame()) {
          return
        }
      } catch (eLoc) {
        /* ignore */
      }
      const seriesUID = this.getActiveSeriesUidKey()
      if (seriesUID) {
        const prev = this.toolState[seriesUID] || {}
        const next = {
          ...prev,
          ww: w,
          wc: c,
        }
        if (opts.markUserSet) next.wwwcUserSet = true
        this.toolState[seriesUID] = next
      }
      if (opts.applyCss !== false && this.shouldUseCssWwwc()) {
        this.syncPreviewCssFromLogical()
      }
    }

    /**
     * Inicializa ancla + lógicos si no hay toolState (primera imagen).
     * @param {object} image
     * @param {object} fileData
     * @param {{ forceRefresh?: boolean }} [opts]
     */
    ensureLogicalWwwcInitialized = (image, fileData, opts = {}) => {
      const forceRefresh = !!(opts && opts.forceRefresh)
      const anchor = this.resolveWwwcAnchor(image, fileData)
      this._wwwcRef = { ww: anchor.ww, wc: anchor.wc }
      const seriesUID = this.getSeriesUidFrom(image, fileData)
      const st = seriesUID && this.toolState ? this.toolState[seriesUID] : null

      const seedFromCornerstoneDefault = () => {
        if (this.shouldUseCssWwwc() || !image || !image.data) return false
        try {
          const el =
            this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
          if (!el) return false
          const defVp = cornerstone.getDefaultViewportForImage(el, image)
          if (
            !defVp ||
            !defVp.voi ||
            !Number.isFinite(Number(defVp.voi.windowWidth)) ||
            Number(defVp.voi.windowWidth) <= 0
          ) {
            return false
          }
          const ww = Number(defVp.voi.windowWidth)
          const wc = Number.isFinite(Number(defVp.voi.windowCenter))
            ? Number(defVp.voi.windowCenter)
            : anchor.wc
          this._logicalWwwc = { ww, wc }
          return true
        } catch (e) {
          return false
        }
      }

      if (forceRefresh && seedFromCornerstoneDefault()) {
        /* VOI clínico desde tags DICOM / cornerstone */
      } else if (
        this.shouldUseCssWwwc() &&
        (this.canUseWebImageRender(image) || this.isPreviewImage(image, fileData))
      ) {
        // PREVIEW: look neutro (no mapear VOI clínico → CSS)
        this.applyPreviewLookIdentity({ clearInvert: false })
        return
      } else if (this.isLocalWwwcFrame(image, fileData)) {
        // SC / preview en stack mixto: default local, no VOI de serie
        if (seedFromCornerstoneDefault()) {
          /* default del SC */
        } else {
          this._logicalWwwc = {
            ww: WEB_PREVIEW_DISPLAY_VOI.windowWidth,
            wc: WEB_PREVIEW_DISPLAY_VOI.windowCenter,
          }
        }
      } else if (st && st.wwwcUserSet && st.ww != null && st.wc != null) {
        // Ignorar toolState si parece VOI 8-bit de una sesión PREVIEW previa
        const wwN = Number(st.ww)
        const wcN = Number(st.wc)
        const looksLikeWebVoi =
          Math.abs(wwN - WEB_PREVIEW_DISPLAY_VOI.windowWidth) < 1.5 &&
          Math.abs(wcN - WEB_PREVIEW_DISPLAY_VOI.windowCenter) < 1.5
        if (looksLikeWebVoi && image && image.data && !forceRefresh) {
          if (seedFromCornerstoneDefault()) {
            /* DICOM default */
          } else {
            this._logicalWwwc = { ww: anchor.ww, wc: anchor.wc }
          }
        } else {
          this._logicalWwwc = { ww: wwN, wc: wcN }
        }
      } else if (!forceRefresh && seedFromCornerstoneDefault()) {
        /* primera apertura DICOM: preferir default del estudio */
      } else {
        this._logicalWwwc = { ww: anchor.ww, wc: anchor.wc }
      }
    }

    /**
     * Deriva filtro preview desde lógicos clínicos + ancla (horneado en paint).
     */
    syncPreviewCssFromLogical = () => {
      const { ww, wc } = this.getLogicalWwwc()
      const ref = this._wwwcRef || {
        ww: DEFAULT_CLINICAL_WW,
        wc: DEFAULT_CLINICAL_WC,
      }
      const css = logicalWwwcToCss(ww, wc, ref.ww, ref.wc)
      this._previewWwwc.brightness = css.brightness
      this._previewWwwc.contrast = css.contrast
      // invert se conserva
      this.applyPreviewWwwcCss({ redraw: false })
    }

    /**
     * Exporta VOI clínico (bookmark / modo switch).
     */
    getClinicalVoiForBookmark = () => {
      const { ww, wc } = this.getLogicalWwwc()
      return { windowWidth: ww, windowCenter: wc }
    }

    /**
     * Aplica VOI clínico (p.ej. tras bookmark en DIAG o preset).
     * @param {number} ww
     * @param {number} wc
     * @param {{ fromBroadcast?: boolean }} [opts]
     */
    applyClinicalVoi = (ww, wc, opts = {}) => {
      const localFrame =
        !opts.fromBroadcast &&
        typeof this.isActiveLocalWwwcFrame === 'function' &&
        this.isActiveLocalWwwcFrame()
      this.setLogicalWwwc(ww, wc, {
        applyCss: this.shouldUseCssWwwc(),
        // En SC/preview no marcar VOI de serie
        markUserSet: opts.fromBroadcast !== true && !localFrame,
      })
      // WebP: NUNCA escribir WW/WC clínico en viewport.voi (Cornerstone
      // renderWebImage → color LUT → tinte rojo con WC≈0 del manifest).
      if (this.canUseWebImageRender(this.image) || this.shouldUseCssWwwc()) {
        try {
          const element =
            this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
          if (element && cornerstone.getEnabledElement(element)) {
            const vp = cornerstone.getViewport(element)
            if (vp) {
              applyNeutralWebPreviewVoi(vp)
              cornerstone.setViewport(element, vp)
            }
          }
        } catch (e) {
          /* ignore */
        }
        try {
          this.applyPreviewWwwcCss({ redraw: true })
        } catch (eCss) {
          /* ignore */
        }
      } else {
        try {
          const element =
            this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
          if (element && cornerstone.getEnabledElement(element)) {
            const vp = cornerstone.getViewport(element)
            if (vp && vp.voi) {
              vp.voi.windowWidth = Math.max(1, Number(ww))
              vp.voi.windowCenter = Number(wc)
              cornerstone.setViewport(element, vp)
              try {
                cornerstone.updateImage(element)
              } catch (e) {
                /* ignore */
              }
            }
          }
        } catch (e) {
          /* ignore */
        }
      }
      // Overlay local inmediato
      try {
        const mrbottomleft = document.getElementById(
          `mrbottomleft-${this.props.index}`
        )
        if (mrbottomleft) {
          mrbottomleft.textContent = `WW/WC: ${Math.round(Number(ww))}/${Math.round(Number(wc))}`
        }
      } catch (eOv) {
        /* ignore */
      }
      // No propagar a App/sesión/peers si es frame SC local
      if (
        !opts.fromBroadcast &&
        !localFrame &&
        typeof this.props.onVoiChange === 'function'
      ) {
        try {
          this.props.onVoiChange(ww, wc, this.props.index)
        } catch (eN) {
          /* ignore */
        }
      }
    }

    /**
     * Limpia estado CSS de PREVIEW (flags + filter).
     * NO borra toolState.ww/wc (continuidad clínica entre modos).
     */
    resetPreviewWwwcState = (opts = {}) => {
      const keepFilter = !!(opts && opts.keepFilter)
      this._cssWwwcDragging = false
      this._cssWwwcMode = false
      this._wwwcPointerActive = false
      this._wwwcDidModify = false
      if (this._cssWwwcRaf) {
        try {
          cancelAnimationFrame(this._cssWwwcRaf)
        } catch (e) {
          /* ignore */
        }
        this._cssWwwcRaf = null
      }
      try {
        window.removeEventListener('mousemove', this.handlerMouseMove, true)
        window.removeEventListener('mousemove', this.handlerNativeWwwcMove, true)
        window.removeEventListener('mouseup', this.handlerMouseUp, true)
      } catch (e) {
        /* ignore */
      }
      // No resetear _logicalWwwc ni toolState: solo CSS a neutro visual
      if (!opts.preserveCssFilterValues) {
        this._previewWwwc = {
          brightness: 1,
          contrast: 1,
          invert: this._previewWwwc && this._previewWwwc.invert ? this._previewWwwc.invert : false,
        }
      }
      if (!keepFilter) {
        try {
          this.clearPreviewWwwcCss()
        } catch (e) {
          /* ignore */
        }
      }
    }

    /**
     * Modo de app (PREVIEW | DIAGNOSTIC).
     * Preferir _appRenderMode (App lo actualiza al cambiar modo): la prop
     * renderMode de setDcmViewer queda congelada en el JSX del constructor.
     */
    getAppRenderMode = () => {
      if (
        this._appRenderMode === RENDER_MODE.PREVIEW ||
        this._appRenderMode === RENDER_MODE.DIAGNOSTIC
      ) {
        return this._appRenderMode
      }
      const m = this.props.renderMode
      if (m === RENDER_MODE.PREVIEW || m === RENDER_MODE.DIAGNOSTIC) return m
      return RENDER_MODE.DIAGNOSTIC
    }

    /**
     * Look PREVIEW neutro (como Reset Image): VOI 255/128 + filtro CSS identidad.
     * Evita “pintado al carbón” al mapear WW/WC clínico de DIAG sobre WebP.
     */
    applyPreviewLookIdentity = (opts = {}) => {
      const clearInvert = opts.clearInvert !== false
      this._wwwcRef = {
        ww: WEB_PREVIEW_DISPLAY_VOI.windowWidth,
        wc: WEB_PREVIEW_DISPLAY_VOI.windowCenter,
      }
      this._logicalWwwc = {
        ww: WEB_PREVIEW_DISPLAY_VOI.windowWidth,
        wc: WEB_PREVIEW_DISPLAY_VOI.windowCenter,
      }
      this._previewWwwc = {
        brightness: 1,
        contrast: 1,
        invert: clearInvert
          ? false
          : !!(this._previewWwwc && this._previewWwwc.invert),
      }
      this._cssWwwcDragging = false
      this._cssWwwcMode = false
      try {
        this.clearPreviewWwwcCss()
      } catch (e) {
        /* ignore */
      }
      try {
        const el =
          this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
        if (el && this.image) {
          const vp = cornerstone.getViewport(el)
          if (vp) {
            applyNeutralWebPreviewVoi(vp)
            if (clearInvert) vp.invert = false
            cornerstone.setViewport(el, vp)
          }
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const mrbottomleft = document.getElementById(
          `mrbottomleft-${this.props.index}`
        )
        if (mrbottomleft) {
          mrbottomleft.textContent = `WW/WC: ${WEB_PREVIEW_DISPLAY_VOI.windowWidth}/${WEB_PREVIEW_DISPLAY_VOI.windowCenter}`
        }
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * Reconfigura WW/WC tras cambiar de modo de render (App.setRenderMode).
     * PREVIEW → path CSS en web desde lógicos; DIAGNOSTIC → nativo limpio de CSS.
     * @param {'PREVIEW'|'DIAGNOSTIC'} mode
     */
    reconfigureWwwcForRenderMode = (mode) => {
      this._appRenderMode = mode
      // Cortar gestos y filtro residual; conservar toolState clínico
      this.resetPreviewWwwcState()
      try {
        this.disableAllTools()
      } catch (e) {
        /* ignore */
      }
      try {
        cornerstoneTools.setToolDisabled('Wwwc')
      } catch (e) {
        /* ignore */
      }
      if (mode === RENDER_MODE.DIAGNOSTIC) {
        try {
          this.clearPreviewWwwcCss()
        } catch (e) {
          /* ignore */
        }
        try {
          cornerstoneTools.setToolEnabled('Wwwc')
          cornerstoneTools.setToolPassive('Wwwc')
        } catch (e) {
          /* ignore */
        }
        // VOI desde tags DICOM / toolState clínico — no reusar 8-bit de PREVIEW
        try {
          const f =
            Array.isArray(this.files) && this.files[this.sliceIndex]
              ? this.files[this.sliceIndex]
              : null
          if (this.image && this.image.data) {
            const seriesUID = this.getSeriesUidFrom(this.image, f)
            const st =
              seriesUID && this.toolState ? this.toolState[seriesUID] : null
            const stWw = st && st.ww != null ? Number(st.ww) : NaN
            const stWc = st && st.wc != null ? Number(st.wc) : NaN
            const looksLikeWebVoi =
              st &&
              st.wwwcUserSet &&
              Math.abs(stWw - WEB_PREVIEW_DISPLAY_VOI.windowWidth) < 1.5 &&
              Math.abs(stWc - WEB_PREVIEW_DISPLAY_VOI.windowCenter) < 1.5
            if (st && st.wwwcUserSet && !looksLikeWebVoi && Number.isFinite(stWw)) {
              this._logicalWwwc = { ww: stWw, wc: stWc }
              this.applyClinicalVoi(stWw, stWc)
            } else {
              if (looksLikeWebVoi && seriesUID && this.toolState[seriesUID]) {
                const cleaned = { ...this.toolState[seriesUID] }
                delete cleaned.wwwcUserSet
                delete cleaned.ww
                delete cleaned.wc
                this.toolState[seriesUID] = cleaned
              }
              this.ensureLogicalWwwcInitialized(this.image, f, {
                forceRefresh: true,
              })
              const ww = this._logicalWwwc.ww
              const wc = this._logicalWwwc.wc
              this.applyClinicalVoi(ww, wc)
            }
          }
        } catch (e) {
          /* ignore */
        }
      } else if (mode === RENDER_MODE.PREVIEW) {
        this.applyPreviewLookIdentity({ clearInvert: true })
      }
      try {
        if (this.props.tool === 'Wwwc' && this.props.toolStore) {
          this.props.toolStore('notool')
        }
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * CSS WWWC SOLO en modo PREVIEW de app + imagen web.
     * En DIAGNOSTIC nunca, aunque quede image webp residual o _cssWwwcMode true.
     */
    shouldUseCssWwwc = () => {
      try {
        if (this.getAppRenderMode() !== RENDER_MODE.PREVIEW) {
          return false
        }
        // Imagen web (getImage) o slot PREVIEW sin dataset DICOM
        if (this.canUseWebImageRender(this.image)) return true
        const f =
          Array.isArray(this.files) && this.files[this.sliceIndex]
            ? this.files[this.sliceIndex]
            : null
        if (f && f.renderKind === 'preview') {
          if (this.image && this.image.data) return false
          return true
        }
        // App en PREVIEW y la imagen no es DICOM (sin data): CSS
        if (this.image && !this.image.data) return true
      } catch (e) {
        /* ignore */
      }
      return false
    }

    /**
     * Atenúa deltas táctiles de Wwwc nativo en móvil (basicLeveling Strategy
     * con range/1024 en pantallas táctiles se siente demasiado agresivo).
     */
    softenNativeWwwcTouchDelta = (e) => {
      if (this.props.tool !== 'Wwwc') return
      // Nunca suavizar path CSS; solo nativo
      if (this.shouldUseCssWwwc()) return
      if (!(isMobile || isTablet)) return
      try {
        const detail = e && e.detail
        if (!detail || !detail.deltaPoints || !detail.deltaPoints.page) return
        const f = 0.4
        detail.deltaPoints.page.x *= f
        detail.deltaPoints.page.y *= f
        if (detail.deltaPoints.image) {
          detail.deltaPoints.image.x *= f
          detail.deltaPoints.image.y *= f
        }
        if (detail.deltaPoints.client) {
          detail.deltaPoints.client.x *= f
          detail.deltaPoints.client.y *= f
        }
      } catch (err) {
        /* ignore */
      }
    }

    getViewerCanvas = () => {
      const el =
        this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
      if (!el) return null
      return (
        el.querySelector('canvas.cornerstone-canvas') ||
        el.querySelector('canvas') ||
        null
      )
    }

    applyPreviewWwwcCss = (opts = {}) => {
      // Nunca aplicar VOI preview fuera de PREVIEW real (evita residual en DIAG)
      if (!this.shouldUseCssWwwc()) return
      // Token en _udvPreviewFilter; el paint aplica filter en el HOST (no context.filter
      // ni canvas.style — eso teñía WebP de rojo en varios GPUs).
      const el =
        this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
      const canvas = this.getViewerCanvas()
      const filter = previewWwwcCssFilter(this._previewWwwc)
      const identity =
        Math.abs((this._previewWwwc && this._previewWwwc.brightness) - 1) < 0.02 &&
        Math.abs((this._previewWwwc && this._previewWwwc.contrast) - 1) < 0.02 &&
        !(this._previewWwwc && this._previewWwwc.invert)
      try {
        if (el) {
          el._udvPreviewFilter = identity ? 'none' : filter
          el.style.filter = identity ? '' : filter
          if (identity && el.style.willChange === 'filter') el.style.willChange = ''
        }
        if (canvas) {
          canvas._udvPreviewFilter = identity ? 'none' : filter
          canvas.style.filter = ''
          if (canvas.style.willChange) canvas.style.willChange = ''
        }
      } catch (e) {
        /* ignore */
      }

      // Drag WWWC: re-paint (host filter ya aplicado)
      const wantRedraw = opts.redraw === true || !!this._cssWwwcDragging
      if (wantRedraw && el) {
        try {
          if (cornerstone.getEnabledElement(el)) {
            cornerstone.updateImage(el)
          }
        } catch (e) {
          /* ignore */
        }
      }

      // Overlay: throttle duro (no en cada rAF de drag) — valores clínicos
      const now = Date.now()
      if (this._lastWwwcOverlayAt && now - this._lastWwwcOverlayAt < 80) return
      this._lastWwwcOverlayAt = now
      try {
        const { ww, wc } = this.getLogicalWwwc()
        const mrbottomleft = document.getElementById(
          `mrbottomleft-${this.props.index}`
        )
        if (mrbottomleft) {
          mrbottomleft.textContent = `WW/WC: ${Math.round(ww)}/${Math.round(wc)}`
        }
      } catch (e) {
        /* ignore */
      }
    }

    clearPreviewWwwcCss = () => {
      const el =
        this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
      if (el) {
        try {
          el._udvPreviewFilter = 'none'
          el.style.filter = ''
          el.style.willChange = ''
        } catch (e) {
          /* ignore */
        }
      }
      const canvas = this.getViewerCanvas()
      if (canvas) {
        try {
          canvas._udvPreviewFilter = 'none'
          canvas.style.filter = ''
          canvas.style.willChange = ''
        } catch (e) {
          /* ignore */
        }
      }
    }

    /** Durante CSS WWWC no tocar VOI del viewport (setViewport = re-draw = freeze). */
    lockWebPreviewVoi = (element, image) => {
      if (!element || !image || typeof image.getImage !== 'function') return
      if (this._cssWwwcDragging) return
      try {
        this.ensureImageRender(image)
        const vp = cornerstone.getViewport(element)
        if (!vp) return
        const baseWW = WEB_PREVIEW_DISPLAY_VOI.windowWidth
        const baseWC = WEB_PREVIEW_DISPLAY_VOI.windowCenter
        if (
          !vp.voi ||
          Math.abs(vp.voi.windowWidth - baseWW) > 0.5 ||
          Math.abs(vp.voi.windowCenter - baseWC) > 0.5 ||
          vp.invert
        ) {
          applyNeutralWebPreviewVoi(vp)
          // Solo si hace falta y fuera de drag
          cornerstone.setViewport(element, vp)
        }
      } catch (e) {
        /* ignore */
      }
    }

    beginWwwcInteraction = (evt) => {
        if (this.props.tool !== 'Wwwc') return
        this._wwwcPointerActive = true
        this._wwwcDidModify = false
        this._wwwcStartWW = null
        this._wwwcStartWC = null

        // Path CSS solo si el modo actual de app + imagen lo exigen
        // (NO usar _cssWwwcMode residual del cambio PREVIEW→DIAG)
        if (this.shouldUseCssWwwc()) {
          this._cssWwwcMode = true
          this._cssWwwcDragging = true
          const x =
            evt && evt.clientX != null
              ? evt.clientX
              : evt && evt.touches && evt.touches[0]
                ? evt.touches[0].clientX
                : 0
          const y =
            evt && evt.clientY != null
              ? evt.clientY
              : evt && evt.touches && evt.touches[0]
                ? evt.touches[0].clientY
                : 0
          this._cssWwwcLastX = x
          this._cssWwwcLastY = y
          try {
            window.addEventListener('mousemove', this.handlerMouseMove, true)
            window.addEventListener('mouseup', this.handlerMouseUp, true)
          } catch (e) {
            /* ignore */
          }
          return
        }

        // DIAGNOSTIC / nativo
        this._cssWwwcMode = false
        this._cssWwwcDragging = false
        try {
            const element = this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
            if (element && cornerstone.getEnabledElement(element)) {
                const vp = cornerstone.getViewport(element)
                if (vp && vp.voi) {
                    this._wwwcStartWW = vp.voi.windowWidth
                    this._wwwcStartWC = vp.voi.windowCenter
                }
            }
        } catch (err) {
            // ignore
        }
        // Broadcast en vivo durante el drag nativo (Cornerstone WWWC)
        try {
          window.addEventListener('mousemove', this.handlerNativeWwwcMove, true)
          window.addEventListener('mouseup', this.handlerMouseUp, true)
        } catch (e) {
          /* ignore */
        }
    }

    /**
     * Durante WWWC nativo (DIAG): leer VOI y notificar peers cada movimiento.
     */
    handlerNativeWwwcMove = () => {
      if (!this._wwwcPointerActive || this._cssWwwcDragging) return
      if (this.props.tool !== 'Wwwc') return
      if (this.shouldUseCssWwwc()) return
      try {
        const element =
          this.dicomImage ||
          document.getElementById(`viewer-${this.props.index}`)
        if (!element || !cornerstone.getEnabledElement(element)) return
        const vp = cornerstone.getViewport(element)
        if (!vp || !vp.voi) return
        this.markWwwcModifiedIfNeeded(vp)
        const localFrame =
          typeof this.isActiveLocalWwwcFrame === 'function' &&
          this.isActiveLocalWwwcFrame()
        try {
          if (typeof this.setLogicalWwwc === 'function') {
            this.setLogicalWwwc(vp.voi.windowWidth, vp.voi.windowCenter, {
              applyCss: false,
              markUserSet: !localFrame,
            })
          }
        } catch (eL) {
          /* ignore */
        }
        if (
          !localFrame &&
          typeof this.props.onVoiChange === 'function'
        ) {
          this.props.onVoiChange(
            vp.voi.windowWidth,
            vp.voi.windowCenter,
            this.props.index
          )
        }
      } catch (err) {
        /* ignore */
      }
    }

    applyCssWwwcDrag = (clientX, clientY) => {
      if (!this._cssWwwcDragging || this.props.tool !== 'Wwwc') return
      if (!this.shouldUseCssWwwc()) {
        this._cssWwwcDragging = false
        this._cssWwwcMode = false
        return
      }
      const dx = clientX - this._cssWwwcLastX
      const dy = clientY - this._cssWwwcLastY
      if (Math.abs(dx) < 0.5 && Math.abs(dy) < 0.5) return
      this._cssWwwcLastX = clientX
      this._cssWwwcLastY = clientY

      // Horizontal → WW, vertical → WC (clínico); luego se deriva CSS
      const cur = this.getLogicalWwwc()
      const ref = this._wwwcRef || {
        ww: DEFAULT_CLINICAL_WW,
        wc: DEFAULT_CLINICAL_WC,
      }
      // Sensibilidad relativa a la ancla (similar a leveling radiológico)
      const wwSens = Math.max(0.5, ref.ww / 256)
      const wcSens = Math.max(0.5, ref.ww / 256)
      const nextWw = Math.max(1, cur.ww + dx * wwSens * 2)
      const nextWc = cur.wc - dy * wcSens * 2

      if (
        Math.abs(nextWw - cur.ww) > 0.2 ||
        Math.abs(nextWc - cur.wc) > 0.2
      ) {
        // applyCss: false — sincronizamos a rAF una sola vez
        this.setLogicalWwwc(nextWw, nextWc, { applyCss: false })
        const css = logicalWwwcToCss(nextWw, nextWc, ref.ww, ref.wc)
        this._previewWwwc.contrast = css.contrast
        this._previewWwwc.brightness = css.brightness
        this._wwwcDidModify = true
        if (this._cssWwwcRaf) return
        this._cssWwwcRaf = requestAnimationFrame(() => {
          this._cssWwwcRaf = null
          this.applyPreviewWwwcCss()
          if (typeof this.props.onVoiChange === 'function') {
            try {
              const cur = this.getLogicalWwwc()
              this.props.onVoiChange(cur.ww, cur.wc, this.props.index)
            } catch (eN) {
              /* ignore */
            }
          }
        })
      }
    }

    markWwwcModifiedIfNeeded = (viewport) => {
        if (!this._wwwcPointerActive || this.props.tool !== 'Wwwc') return
        if (this._cssWwwcMode) return
        try {
            const voi = viewport && viewport.voi ? viewport.voi : null
            if (!voi) return
            if (this._wwwcStartWW == null || this._wwwcStartWC == null) {
                this._wwwcStartWW = voi.windowWidth
                this._wwwcStartWC = voi.windowCenter
                return
            }
            if (
                Math.abs(voi.windowWidth - this._wwwcStartWW) > 0.5 ||
                Math.abs(voi.windowCenter - this._wwwcStartWC) > 0.5
            ) {
                this._wwwcDidModify = true
            }
        } catch (err) {
            // ignore
        }
    }

    endWwwcInteraction = () => {
        this._cssWwwcDragging = false
        this._cssWwwcPointerId = null
        if (this._cssWwwcRaf) {
          try {
            cancelAnimationFrame(this._cssWwwcRaf)
          } catch (e) {
            /* ignore */
          }
          this._cssWwwcRaf = null
          try {
            if (this.shouldUseCssWwwc()) this.applyPreviewWwwcCss({ redraw: true })
          } catch (e) {
            /* ignore */
          }
        }
        // CSS filter ya no se usa en canvas visible; limpiar residual will-change
        try {
          const canvas = this.getViewerCanvas()
          if (canvas && canvas.style.willChange === 'filter') {
            canvas.style.willChange = ''
          }
        } catch (e) {
          /* ignore */
        }
        try {
          window.removeEventListener('mousemove', this.handlerMouseMove, true)
          window.removeEventListener('mousemove', this.handlerNativeWwwcMove, true)
          window.removeEventListener('mouseup', this.handlerMouseUp, true)
        } catch (e) {
          /* ignore */
        }
        const shouldExit = this._wwwcPointerActive && this._wwwcDidModify && this.props.tool === 'Wwwc'
        if (shouldExit) {
          const localFrame =
            typeof this.isActiveLocalWwwcFrame === 'function' &&
            this.isActiveLocalWwwcFrame()
          if (!localFrame) {
            try {
              const seriesUID = this.getActiveSeriesUidKey()
              if (seriesUID) this.markSeriesWwwcUserSet(seriesUID)
            } catch (e) {
              /* ignore */
            }
            // Notificar App para mapa de sesión (layout / reopen)
            try {
              const { ww, wc } = this.getLogicalWwwc()
              if (
                typeof this.props.onVoiChange === 'function' &&
                Number.isFinite(ww) &&
                Number.isFinite(wc)
              ) {
                this.props.onVoiChange(ww, wc, this.props.index)
              }
            } catch (eN) {
              /* ignore */
            }
          }
        }
        this._wwwcPointerActive = false
        this._wwwcDidModify = false
        this._wwwcStartWW = null
        this._wwwcStartWC = null
        // Quitar flag CSS si el modo ya no es PREVIEW
        if (!this.shouldUseCssWwwc()) {
          this._cssWwwcMode = false
        }
        if (!shouldExit) return
        // Mantener filtro CSS en PREVIEW (el ajuste debe verse); en DIAG no aplica
        this.props.toolStore('notool')
        this.runTool('notool')
    }

    recenterObliqueViewport = () => {
      const element = this.dicomImage
      if (!element) return
      try {
        const vp = cornerstone.getViewport(element)
        if (!vp) return
        vp.translation = { x: 0, y: 0 }
        cornerstone.setViewport(element, vp)
      } catch (e) {
        /* ignore */
      }
    }

    handlerCrosshairPointerDown = (event) => {
      if (!this.props.mprCrosshairActive) return
      // Click derecho / auxiliar: no apuntar (queda para menú joystick vía contextmenu)
      if (!event.touches && event.button != null && event.button !== 0) return
      const tool = this.props.tool
      if (tool === 'Wwwc' || tool === 'Pan' || tool === 'Zoom' || tool === 'Magnify') return
      const t = (event.touches && event.touches[0]) || event
      if (!t) return
      try {
        event.preventDefault()
        event.stopPropagation()
      } catch (e) { /* ignore */ }
      this.suspendStackDrag()
      this._chDragging = true
      this._chMoved = false
      this._chAim = { x: t.clientX, y: t.clientY, t: Date.now() }
      this._chRotate = false
      this._chLastAngle = null
      this._mprObliqueGesture = false
      if (this.props.mprObliqueActive) {
        const hit = this.hitObliqueOverlay(t)
        if (hit && hit.kind === 'rotate') {
          this._chRotate = true
          this._chRotateRole = hit.role
          this._chLastAngle = this.angleFromCrosshairCenter(t)
          this._mprObliqueGesture = true
        } else if (hit && hit.kind === 'center') {
          this._mprObliqueGesture = true
        } else if (this.isNearCrosshairArmTip(t)) {
          // Fallback v1 hasta SVG overlay
          this._chRotate = true
          this._chRotateRole = this.mprPlane || 'axial'
          this._chLastAngle = this.angleFromCrosshairCenter(t)
          this._mprObliqueGesture = true
        }
      }
      this.bindCrosshairWindow()
      // Aim inmediato en down; el up solo re-apunta si hubo drag (evita salto post-click)
      if (!this._chRotate) this.fireCrosshairAim(event)
    }

    getCrosshairCanvasCenter = () => {
      if (this._crosshairV && this._crosshairH) {
        const left = parseFloat(this._crosshairV.style.left)
        const top = parseFloat(this._crosshairH.style.top)
        if (Number.isFinite(left) && Number.isFinite(top)) {
          return { x: left, y: top }
        }
      }
      const el = this.dicomImage
      if (!el) return null
      const r = el.getBoundingClientRect()
      return { x: r.width / 2, y: r.height / 2 }
    }

    angleFromCrosshairCenter = (t) => {
      const el = this.dicomImage
      if (!el || !t) return 0
      const r = el.getBoundingClientRect()
      const c = this.getCrosshairCanvasCenter() || { x: r.width / 2, y: r.height / 2 }
      const x = (t.clientX || 0) - r.left - c.x
      const y = (t.clientY || 0) - r.top - c.y
      return Math.atan2(y, x)
    }

    isNearCrosshairArmTip = (t) => {
      const el = this.dicomImage
      if (!el || !t) return false
      const r = el.getBoundingClientRect()
      const c = this.getCrosshairCanvasCenter() || { x: r.width / 2, y: r.height / 2 }
      const x = (t.clientX || 0) - r.left - c.x
      const y = (t.clientY || 0) - r.top - c.y
      const dist = Math.sqrt(x * x + y * y)
      const minR = Math.min(r.width, r.height) * 0.22
      const maxR = Math.min(r.width, r.height) * 0.55
      if (dist < minR || dist > maxR) return false
      const alongH = Math.abs(y) < 14
      const alongV = Math.abs(x) < 14
      return alongH || alongV
    }

    fireCrosshairAim = (event) => {
      if (typeof this.props.onViewportActivate === 'function') {
        try {
          this.props.onViewportActivate(this.props.index)
        } catch (e) { /* ignore */ }
      }
      if (typeof this.props.onMprCrosshairAim === 'function') {
        try {
          this.props.onMprCrosshairAim(this.props.index, event)
        } catch (e2) { /* ignore */ }
      }
    }

    scheduleCrosshairAim = (event) => {
      this._chPendingEvent = event
      if (this._chRaf) return
      this._chRaf = requestAnimationFrame(() => {
        this._chRaf = null
        const ev = this._chPendingEvent
        this._chPendingEvent = null
        if (ev && this._chDragging) this.fireCrosshairAim(ev)
      })
    }

    bindCrosshairWindow = () => {
      if (this._chWinBound) return
      this._chWinBound = true
      window.addEventListener('mousemove', this.handlerCrosshairPointerMove, true)
      window.addEventListener('mouseup', this.handlerCrosshairPointerUp, true)
      window.addEventListener('touchmove', this.handlerCrosshairPointerMove, { capture: true, passive: false })
      window.addEventListener('touchend', this.handlerCrosshairPointerUp, true)
    }

    unbindCrosshairWindow = () => {
      if (!this._chWinBound) return
      this._chWinBound = false
      window.removeEventListener('mousemove', this.handlerCrosshairPointerMove, true)
      window.removeEventListener('mouseup', this.handlerCrosshairPointerUp, true)
      window.removeEventListener('touchmove', this.handlerCrosshairPointerMove, true)
      window.removeEventListener('touchend', this.handlerCrosshairPointerUp, true)
    }

    handlerCrosshairPointerMove = (event) => {
      if (!this._chDragging || !this.props.mprCrosshairActive) return
      try {
        event.preventDefault()
        event.stopPropagation()
      } catch (e) { /* ignore */ }
      const t = (event.touches && event.touches[0]) || event
      if (t && this._chAim) {
        const dx = (t.clientX || 0) - this._chAim.x
        const dy = (t.clientY || 0) - this._chAim.y
        if (dx * dx + dy * dy > 9) this._chMoved = true
      } else {
        this._chMoved = true
      }
      if (this._chRotate && this.props.mprObliqueActive) {
        this.scheduleCrosshairRotate(t)
        return
      }
      this.scheduleCrosshairAim(event)
    }

    scheduleCrosshairRotate = (t) => {
      this._chPendingRotate = t
      if (this._chRotRaf) return
      this._chRotRaf = requestAnimationFrame(() => {
        this._chRotRaf = null
        const pt = this._chPendingRotate
        this._chPendingRotate = null
        if (!pt || !this._chDragging || !this._chRotate) return
        const ang = this.angleFromCrosshairCenter(pt)
        if (this._chLastAngle == null) {
          this._chLastAngle = ang
          return
        }
        // atan2 en pantalla (Y↓): ang - last alinea axial/sagital con la mano.
        // Coronal: normal ey mira al revés respecto al canvas → invertir signo.
        let delta = ang - this._chLastAngle
        if (delta > Math.PI) delta -= Math.PI * 2
        if (delta < -Math.PI) delta += Math.PI * 2
        const viewRole = String(this.mprPlane || '').toLowerCase()
        if (viewRole === 'coronal') delta = -delta
        this._chLastAngle = ang
        if (typeof this.props.onMprObliqueRotate === 'function') {
          try {
            this.props.onMprObliqueRotate(
              this.props.index,
              delta,
              this._chRotateRole || this.mprPlane || 'axial'
            )
          } catch (e) { /* ignore */ }
        }
      })
    }

    /**
     * Hit-test overlay oblicuo (SVG). Fallback null → cruz v1.
     * @returns {{ kind: 'center'|'rotate', role?: string }|null}
     */
    hitObliqueOverlay = (t) => {
      if (!this.props.mprObliqueActive || !this.dicomImage || !t) return null
      // Hit en coords canvas (mismas que el SVG a tamaño viewport)
      const model = this.state.obliqueOverlay
      if (!model || !model.center) return null
      try {
        const r = this.dicomImage.getBoundingClientRect()
        const x = (t.clientX || 0) - r.left
        const y = (t.clientY || 0) - r.top
        return hitObliqueOverlayModel(model, { x, y }, {
          centerRadius: 16,
          handleRadius: 18,
          lineRadius: 12,
        })
      } catch (e) {
        return null
      }
    }

    updateObliqueOverlay = () => {
      if (!this.props.mprObliqueActive || !this.image || !this.dicomImage) {
        if (this.state.obliqueOverlay) {
          this.setState({ obliqueOverlay: null })
        }
        this._obliqueOverlayModel = null
        return
      }
      const matrix =
        this.props.mprObliqueMatrix ||
        this._mprObliqueMatrix ||
        identityMatrix()
      const role = this.mprPlane || 'axial'
      const outCols = this.image.columns || 1
      const outRows = this.image.rows || 1
      const model = buildObliqueOverlayModel({
        matrix,
        viewportRole: role,
        outCols,
        outRows,
      })
      // Dibujar a casi todo el viewport (no solo el rect de la imagen)
      let canvasModel = null
      try {
        const el = this.dicomImage
        const toCanvas = (x, y) => {
          const c = cornerstone.pixelToCanvas(el, { x, y })
          return { x: c.x, y: c.y }
        }
        const c0 = toCanvas(model.center.x, model.center.y)
        const vw = el.clientWidth || el.offsetWidth || 1
        const vh = el.clientHeight || el.offsetHeight || 1
        canvasModel = {
          ...model,
          center: c0,
          centerColor: model.centerColor,
          lines: (model.lines || []).map((ln) => {
            // Dirección en canvas a partir de un paso en espacio imagen
            const p1 = toCanvas(ln.cx, ln.cy)
            const p2 = toCanvas(ln.cx + ln.dir.dx, ln.cy + ln.dir.dy)
            let cdx = p2.x - p1.x
            let cdy = p2.y - p1.y
            const clen = Math.sqrt(cdx * cdx + cdy * cdy) || 1
            cdx /= clen
            cdy /= clen
            // Borde a borde del viewport (misma idea que reference lines H/V al 100%)
            const seg = lineSegmentViewportEdges(c0.x, c0.y, { dx: cdx, dy: cdy }, vw, vh)
            const handleDist = Math.max(24, (seg.halfLen || 0) * 0.55)
            const handles = [
              { x: c0.x + cdx * handleDist, y: c0.y + cdy * handleDist },
              { x: c0.x - cdx * handleDist, y: c0.y - cdy * handleDist },
            ]
            return {
              ...ln,
              dir: { dx: cdx, dy: cdy },
              cx: c0.x,
              cy: c0.y,
              x1: seg.x1,
              y1: seg.y1,
              x2: seg.x2,
              y2: seg.y2,
              handles,
            }
          }),
        }
      } catch (e) {
        canvasModel = null
      }
      this._obliqueOverlayModel = model
      this.setState({ obliqueOverlay: canvasModel })
    }

    handlerCrosshairPointerCancel = () => {
      this.releaseCrosshairCapture()
    }

    /** Al apagar No Tool / mira: soltar captura de window para no comer el drag. */
    releaseCrosshairCapture = () => {
      const wasOblique = !!this._mprObliqueGesture
      this._chDragging = false
      this._chMoved = false
      this._chAim = null
      this._chRotate = false
      this._chLastAngle = null
      this._chRotateRole = null
      this._mprObliqueGesture = false
      this.unbindCrosshairWindow()
      this.suspendStackDrag()
      if (wasOblique && this.props.mprObliqueActive) {
        this.recenterObliqueViewport()
      }
    }

    handlerCrosshairPointerUp = (event) => {
      if (!event.touches && event.button != null && event.button !== 0) return
      // Click puro: ya apuntó en down. Solo re-aim al soltar si hubo arrastre.
      if (
        this._chDragging &&
        this.props.mprCrosshairActive &&
        this._chMoved &&
        !this._chRotate
      ) {
        this.fireCrosshairAim(event)
      }
      this.handlerCrosshairPointerCancel()
    }

    getMprVolumeSizeForOverlay = () => {
      const files = this.files === null ? this.props.files : this.files
      const f0 = files && files[0]
      const cols =
        this.xSize ||
        (f0 && (f0.columns != null ? f0.columns : f0.image && f0.image.columns)) ||
        (this.image && this.image.columns) ||
        1
      const rows =
        this.ySize ||
        (f0 && (f0.rows != null ? f0.rows : f0.image && f0.image.rows)) ||
        (this.image && this.image.rows) ||
        1
      const zDim =
        this.zSize ||
        (this.mprData && this.mprData.zDim) ||
        (files && files.length) ||
        1
      return { cols: Number(cols) || 1, rows: Number(rows) || 1, zDim: Number(zDim) || 1 }
    }

    updateCrosshairOverlay = (pointOverride) => {
      const el = this._crosshairEl
      const hide = () => {
        if (el) el.style.display = 'none'
        if (this._crosshairH) this._crosshairH.style.display = 'none'
        if (this._crosshairV) this._crosshairV.style.display = 'none'
      }
      const point = pointOverride || this.props.mprCrosshairPoint
      const showLines = !!(
        this.props.mprLayoutActive &&
        point &&
        this.dicomImage &&
        this.image &&
        this.props.visibleReferenceLines !== false
      )
      // Oblicuo ON: SVG coloreado; ocultar cruz H/V amarilla
      if (this.props.mprObliqueActive) {
        hide()
        this.updateObliqueOverlay()
        return
      }
      // Cruz amarilla UDV = correlación MPR (CT ReferenceLines verdes se apagan en MPR).
      // @see docs/MANUAL-0.20.75-MPR-YELLOW-CORRELATION.md
      if (!showLines) {
        hide()
        if (this.state.obliqueOverlay) this.setState({ obliqueOverlay: null })
        return
      }
      try {
        const size = this.getMprVolumeSizeForOverlay()
        const plane = this.mprPlane || 'axial'
        const flipZ = !!(this.mprData && this.mprData.flipZ)
        const imgPt = volumeIndicesToImagePixel({
          plane,
          x: point.x,
          y: point.y,
          z: point.z,
          size,
          flipZ,
        })
        const canvasPt = cornerstone.pixelToCanvas(this.dicomImage, imgPt)
        const aim = !!this.props.mprCrosshairActive
        if (el) {
          el.style.display = aim ? 'block' : 'none'
          el.style.left = `${canvasPt.x}px`
          el.style.top = `${canvasPt.y}px`
        }
        if (this._crosshairH) {
          this._crosshairH.style.display = 'block'
          this._crosshairH.style.top = `${canvasPt.y}px`
          this._crosshairH.style.opacity = aim ? '1' : '0.9'
        }
        if (this._crosshairV) {
          this._crosshairV.style.display = 'block'
          this._crosshairV.style.left = `${canvasPt.x}px`
          this._crosshairV.style.opacity = aim ? '1' : '0.9'
        }
      } catch (e) {
        hide()
      }
    }

    handlerMouseDown = (event) => {
        // Click derecho: no interceptar (joystick / contextmenu)
        if (event.button != null && event.button !== 0) return
        // Activar viewport al interactuar (hover + drag/click)
        if (typeof this.props.onViewportActivate === 'function') {
          this.props.onViewportActivate(this.props.index)
        }
        // Punto mira: no iniciar scroll-drag; el arrastre apunta la cruz
        if (this.props.mprCrosshairActive) {
          this.suspendStackDrag()
          return
        }
        if (this.props.tool === 'Wwwc') {
            // Capture CSS drag solo si corresponds a PREVIEW web ahora
            if (this.shouldUseCssWwwc()) {
              try {
                event.preventDefault()
                event.stopPropagation()
              } catch (e) {
                /* ignore */
              }
              this.beginWwwcInteraction(event)
              return
            }
            // DIAG: dejar que cornerstone-tools maneje el drag; solo marcar sesión
            this.beginWwwcInteraction(event)
            return
        }
        // Solo activar scroll drag en desktop y cuando la herramienta es 'notool'
        if (!isMobile && this.props.tool === 'notool' && this.shouldScroll) {
            if (this.state.inPlay) {
              try {
                this.runCinePlayer('pause')
              } catch (e) {
                /* ignore */
              }
            }
            this.cancelStackInertia()
            this.isMouseDown = true
            this.mouseStartY = event.clientY
            this._dragOriginY = event.clientY
            this._dragOriginIndex = this.getStackNavIndex()
            this._seekTarget = this._dragOriginIndex
            this._inertiaPps = this.pxPerSliceSlider()
            this._mouseSampleVel = 0
            this._mouseSampleTs = performance.now()
            this._mouseSampleY = event.clientY
            this.mouseHasNavigated = false
            event.preventDefault()
        }
    }

    handlerMouseMove = (event) => {
        // Solo captura CSS si estamos realmente en PREVIEW web
        if (
          this.props.tool === 'Wwwc' &&
          this._cssWwwcDragging &&
          this.shouldUseCssWwwc()
        ) {
          this.applyCssWwwcDrag(event.clientX, event.clientY)
          try {
            event.preventDefault()
            event.stopPropagation()
          } catch (e) {
            /* ignore */
          }
          return
        }
        if (this.props.mprCrosshairActive) {
          this.suspendStackDrag()
          return
        }
        if (this.isMouseDown && !isMobile && this.props.tool === 'notool' && this.shouldScroll) {
            const now = performance.now()
            const dt = now - (this._mouseSampleTs || now)
            if (dt > 0 && dt < 90) {
              this._mouseSampleVel = (event.clientY - this._mouseSampleY) / dt
            }
            this._mouseSampleTs = now
            this._mouseSampleY = event.clientY
            const pps = this._inertiaPps || this.pxPerSliceSlider()
            this._seekTarget = this._dragOriginIndex + (event.clientY - this._dragOriginY) / pps
            this.seekStackTo(this._seekTarget)
            this.mouseHasNavigated = true
            event.preventDefault()
        }
    }

    handlerMouseUp = (event) => {
        const didNavigate = this.isMouseDown && this.mouseHasNavigated
        // Desktop/mouse: al soltar, frenar chase del tirón (queda el corte actual).
        if (this.isMouseDown) {
          this.stopDesktopStackCoast()
        }
        if (didNavigate) {
          this.flushWheelUiSync()
        }
        this.isMouseDown = false
        this.mouseHasNavigated = false
        this._mouseDragResidual = 0
        this.endWwwcInteraction()
    }

    handlerWwwcTouchStart = (event) => {
        if (this.props.tool !== 'Wwwc') return
        this.beginWwwcInteraction(event)
    }

    handlerWwwcTouchMove = (event) => {
        if (
          this.props.tool !== 'Wwwc' ||
          !this._cssWwwcDragging ||
          !this.shouldUseCssWwwc()
        ) {
          return
        }
        const t = event.touches && event.touches[0]
        if (!t) return
        this.applyCssWwwcDrag(t.clientX, t.clientY)
        try {
          event.preventDefault()
        } catch (e) {
          /* ignore */
        }
    }

    handlerWwwcTouchEnd = () => {
        this.endWwwcInteraction()
    }

    onOpenUrl = (e) => {
      const eventData = e.detail
      this.setState({ progress: eventData.percentComplete })
    }

    showOpenUrlDlg = (url) => {
      this.setState({ visibleOpenUrlDlg: true }, () => {
        cornerstone.events.addEventListener('cornerstoneimageloadprogress', this.onOpenUrl)
        this.loadImage(undefined, url)
      })
    }
  
    hideOpenUrlDlg = () => {
      this.setState({ visibleOpenUrlDlg: false, progress: null })
    }

    measurementSave = (measure) => {
      this.measurements.push(measure) 
    }

    measurementClear = () => {
      this.measurements.splice(0, this.measurements.length)
    }

    measurementRemove = (index) => {
      //console.log('this.measurements: ', this.measurements)
      this.measurements.splice(index, 1)
    }

    /** Spacing calibrado persistido en toolState por serie (sesión). */
    applyStoredCalibrationSpacing = (image, fileData) => {
      if (!image) return
      const seriesUID = this.getSeriesUidFrom(image, fileData)
      if (!seriesUID || !this.toolState[seriesUID]) return
      const st = this.toolState[seriesUID]
      if (st.calibratedRowSpacing > 0 && st.calibratedColSpacing > 0) {
        applySpacingToImage(image, {
          rowPixelSpacing: st.calibratedRowSpacing,
          columnPixelSpacing: st.calibratedColSpacing,
        })
      }
    }

    getCurrentPixelSpacing = () => {
      const img = this.image
      const row = Number(img && img.rowPixelSpacing) || 1
      const col = Number(img && img.columnPixelSpacing) || 1
      return { rowPixelSpacing: row > 0 ? row : 1, columnPixelSpacing: col > 0 ? col : 1 }
    }

    applyCalibratedSpacingToSeries = (seriesUID, rowSp, colSp) => {
      if (!seriesUID || !(rowSp > 0) || !(colSp > 0)) return
      this.toolState[seriesUID] = {
        ...(this.toolState[seriesUID] || {}),
        calibratedRowSpacing: rowSp,
        calibratedColSpacing: colSp,
      }
      const files = this.files === null ? this.props.files : this.files
      if (!Array.isArray(files)) return
      files.forEach((f) => {
        const uid =
          (f && f.series && f.series.seriesInstanceUID) ||
          f.seriesInstanceUID ||
          this.getSeriesUidFrom(f && f.image, f)
        if (uid !== seriesUID) return
        if (f.image) {
          applySpacingToImage(f.image, {
            rowPixelSpacing: rowSp,
            columnPixelSpacing: colSp,
          })
        }
      })
    }

    refreshMeasurementsAfterSpacing = (rowSp, colSp) => {
      const element = this.dicomImage
      if (element) {
        const toolNames = [
          'Length',
          'Angle',
          'CobbAngle',
          'EllipticalRoi',
          'RectangleRoi',
          'FreehandRoi',
          'Probe',
        ]
        const fromCs = collectMeasurementsFromElement(element, toolNames, cornerstoneTools)
        if (fromCs.length > 0) {
          this.measurements = preserveMeasurementNotes(this.measurements, fromCs)
        }
      }
      this.measurements.forEach((m) => {
        recalculateMeasurementData(m.tool, m.data, rowSp, colSp)
      })
      if (element) {
        try {
          cornerstone.updateImage(element)
        } catch (e) {
          /* ignore */
        }
      }
      this.props.setActiveMeasurements(this.measurements)
    }

    /**
     * Calibrar pixel spacing con una medición Length y distancia real (mm).
     * @param {number} measureIndex índice en this.measurements
     * @param {number} knownMm distancia real en milímetros
     * @returns {boolean}
     */
    calibrateFromLengthMeasurement = (measureIndex, knownMm) => {
      if (this.isMprGenerated) {
        console.warn('DicomViewer - calibración no disponible en planos MPR reconstruidos')
        return false
      }
      const measure = this.measurements[measureIndex]
      if (!measure || measure.tool !== 'Length' || !measure.data) return false

      const known = Number(knownMm)
      if (!(known > 0)) return false

      const element = this.dicomImage
      const image = this.image
      if (!element || !image) return false

      const { rowPixelSpacing, columnPixelSpacing } = this.getCurrentPixelSpacing()
      const scale = computeUniformScaleFromLength(
        measure.data,
        known,
        rowPixelSpacing,
        columnPixelSpacing
      )
      if (!(scale > 0)) return false

      const newRow = rowPixelSpacing * scale
      const newCol = columnPixelSpacing * scale
      const seriesUID = this.getSeriesUidFrom(image, null)
      if (!seriesUID) return false

      applySpacingToImage(image, {
        rowPixelSpacing: newRow,
        columnPixelSpacing: newCol,
      })
      this.applyCalibratedSpacingToSeries(seriesUID, newRow, newCol)
      this.refreshMeasurementsAfterSpacing(newRow, newCol)
      return true
    }

    getTransferSyntax = () => {
      if (!this.image || !this.image.data) return ''
      try {
        const value = this.image.data.string('x00020010')
        const ts = resolveTransferSyntax(value)
        if (!ts.uid) return ''
        return `${ts.uid} [${ts.kindLabel} · ${ts.short}] ${ts.name}`
      } catch (e) {
        return ''
      }
    }

    getSopClass = () => {
      if (!this.image || !this.image.data) return ''
      try {
        const value = this.image.data.string('x00080016')
        return value + ' [' + uids[value] + ']'
      } catch (e) {
        return ''
      }
    }

    /**
     * true si es preview web (web-image-loader) — NO DICOM color.
     * Usar canUseWebImageRender / ensureImageRender para el renderer.
     */
    isPreviewImage = (image, fileData) => {
      return isWebPreviewImage(image, fileData)
    }

    /**
     * Solo asigna renderWebImage si image.getImage existe.
     * Nunca por image.color (congela draw loop en DX/SC).
     */
    ensureImageRender = (image, fileData) => {
      return ensureImageRenderUtil(image, fileData)
    }

    canUseWebImageRender = (image) => {
      return canUseWebImageRenderUtil(image)
    }

    /**
     * Frame con VOI local (no clínico de serie): Secondary Capture, preview WebP,
     * o color sin tags WW/WC. En series .Ref la 1ª imagen suele ser así.
     * @param {object|null} image
     * @param {object|null} fileData
     */
    isLocalWwwcFrame = (image, fileData) => {
      try {
        if (this.canUseWebImageRender(image)) return true
        if (this.isPreviewImage(image, fileData)) return true
        if (
          fileData &&
          fileData.renderKind === 'preview' &&
          !(image && image.data)
        ) {
          return true
        }
        const sopFromFile =
          (fileData &&
            (fileData.sopClassUID ||
              fileData.SOPClassUID ||
              (fileData.series &&
                (fileData.series.sopClassUID || fileData.series.SOPClassUID)))) ||
          null
        const sop =
          this.safeImageString(image, 'x00080016', sopFromFile) || sopFromFile
        if (sop && String(sop).indexOf('1.2.840.10008.5.1.4.1.1.7') === 0) {
          return true
        }
        // Color sin Window Width clínico → tratar como captura / 8-bit
        if (image && image.color && image.data && typeof image.data.string === 'function') {
          try {
            const tWw = parseFloat(
              String(image.data.string('x00281051') || '').split('\\')[0]
            )
            if (!Number.isFinite(tWw) || tWw <= 0) return true
          } catch (eTag) {
            return true
          }
        }
      } catch (e) {
        /* ignore */
      }
      return false
    }

    /** true si el corte activo es SC/preview (VOI no debe ir a toolState de serie). */
    isActiveLocalWwwcFrame = () => {
      try {
        const f =
          Array.isArray(this.files) && this.files[this.sliceIndex] != null
            ? this.files[this.sliceIndex]
            : null
        return this.isLocalWwwcFrame(this.image, f)
      } catch (e) {
        return false
      }
    }

    /**
     * Metadata del stack (manifest) cuando no hay image.data.
     */
    getFileMeta = (fileData) => {
      const f = fileData || null
      if (!f) return {}
      return {
        patientName: (f.patient && f.patient.patientName) || null,
        patientId: (f.patient && f.patient.patientId) || null,
        studyUid: (f.study && f.study.studyId) || null,
        seriesUid:
          (f.series && f.series.seriesInstanceUID) ||
          f.seriesInstanceUID ||
          null,
        seriesDescription: (f.series && f.series.seriesDescription) || null,
        instanceNumber:
          f.instanceNumber != null ? String(f.instanceNumber) : null,
        sopInstanceUID: f.sopInstanceUID || null,
      }
    }

    /** Series UID desde tags DICOM o metadata de stack (PREVIEW). */
    getSeriesUidFrom = (image, fileData) => {
      const meta = this.getFileMeta(fileData)
      const fromTags = this.safeImageString(image, 'x0020000e', meta.seriesUid || null)
      if (fromTags) return String(fromTags)
      // Fallback: misma serie del stack local (previews sin SeriesInstanceUID en tags)
      if (meta.seriesUid) return String(meta.seriesUid)
      const sn =
        (fileData && fileData.series && fileData.series.seriesNumber) != null
          ? fileData.series.seriesNumber
          : null
      if (sn != null) {
        return `seriesNum:${sn}:v${this.props.index}`
      }
      return `stack:v${this.props.index}`
    }

    /**
     * Clona zoom/pan/VOI del viewport (para scroll en la misma serie).
     * @param {object|null} viewport
     */
    cloneViewportViewState = (viewport) => {
      if (!viewport) return null
      const t = viewport.translation || { x: 0, y: 0 }
      return {
        ww: viewport.voi ? viewport.voi.windowWidth : null,
        wc: viewport.voi ? viewport.voi.windowCenter : null,
        zoom: viewport.scale,
        translation: { x: t.x || 0, y: t.y || 0 },
        rotation: viewport.rotation || 0,
      }
    }

    /**
     * Guarda zoom/pan (y VOI clínico) en toolState de la serie.
     * En PREVIEW no pisa ww/wc con VOI nativo 255/128 del canvas.
     */
    captureViewportToToolState = (seriesUID, viewport) => {
      if (!seriesUID || !viewport || viewport.scale == null) return
      try {
        const state = this.cloneViewportViewState(viewport)
        if (!state) return
        const prev = this.toolState[seriesUID] || {}
        const isWeb =
          this.shouldUseCssWwwc() ||
          (this.image && typeof this.image.getImage === 'function')
        const localFrame =
          typeof this.isActiveLocalWwwcFrame === 'function' &&
          this.isActiveLocalWwwcFrame()
        // SC/preview: zoom/pan sí; WW/WC de serie no
        const persistWwwc =
          !localFrame && (isWeb || !!prev.wwwcUserSet)
        let ww = state.ww
        let wc = state.wc
        if (localFrame) {
          ww = null
          wc = null
        } else if (isWeb) {
          const logical = this.getLogicalWwwc()
          ww = logical.ww
          wc = logical.wc
        } else if (!persistWwwc) {
          ww = null
          wc = null
        } else if (ww == null || wc == null) {
          const logical = this.getLogicalWwwc()
          ww = ww != null ? ww : logical.ww
          wc = wc != null ? wc : logical.wc
        }
        const next = {
          ...prev,
          zoom: state.zoom,
          translation: state.translation,
          rotation: state.rotation,
        }
        if (persistWwwc && ww != null && wc != null) {
          next.ww = ww
          next.wc = wc
          this._logicalWwwc = { ww: Number(ww), wc: Number(wc) }
        }
        this.toolState[seriesUID] = next
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * Aplica toolState o viewport actual sobre getDefaultViewportForImage.
     * @returns {object} viewport listo para displayImage
     */
    buildViewportPreservingView = (element, image, preferredState, fileData) => {
      const viewport = cornerstone.getDefaultViewportForImage(element, image)
      const isWeb = this.isPreviewImage(image, fileData)
      const isLocal = this.isLocalWwwcFrame(image, fileData)
      // WebP ya ventaneado: VOI neutro 255/128 (WC clínico solo vía CSS WWWC)
      if ((isWeb || isLocal) && viewport.voi && (isWeb || this.canUseWebImageRender(image))) {
        applyNeutralWebPreviewVoi(viewport)
      } else if (isLocal && viewport.voi) {
        // SC DICOM: dejar getDefaultViewport (no pisar con VOI clínico de serie)
      }
      if (preferredState) {
        const applySeriesWwwc =
          !isWeb &&
          !isLocal &&
          preferredState.ww != null &&
          preferredState.wc != null &&
          viewport.voi &&
          !!preferredState.wwwcUserSet
        if (applySeriesWwwc) {
          viewport.voi.windowWidth = preferredState.ww
          viewport.voi.windowCenter = preferredState.wc
        }
        if (preferredState.zoom != null) {
          viewport.scale = preferredState.zoom
        }
        if (preferredState.translation) {
          viewport.translation = {
            x: preferredState.translation.x || 0,
            y: preferredState.translation.y || 0,
          }
        }
        if (preferredState.rotation != null) {
          viewport.rotation = preferredState.rotation
        }
      }
      return viewport
    }

    /**
     * Aplica zoom/pan (y WW si opts.wwwc) desde el viewport maestro del Link Series.
     * Con Link WW/WL OFF no tocar VOI: rebuild desde default DICOM lo pisaba al soltar el scroll.
     */
    applyLinkedViewState = (state, opts = {}) => {
      if (!state || !this.dicomImage || !this.image) return
      const files = this.files === null ? this.props.files : this.files
      const fileData =
        Array.isArray(files) && files[this.sliceIndex] != null
          ? files[this.sliceIndex]
          : null
      try {
        const applyWwwc = !!(opts.wwwc && state.ww != null && state.wc != null)
        if (applyWwwc) {
          this.setLogicalWwwc(state.ww, state.wc, {
            applyCss: this.shouldUseCssWwwc(),
          })
        }

        let viewport = null
        try {
          viewport = cornerstone.getViewport(this.dicomImage)
        } catch (eVp) {
          viewport = null
        }

        if (viewport) {
          if (state.zoom != null) viewport.scale = state.zoom
          if (state.translation) {
            viewport.translation = {
              x: state.translation.x || 0,
              y: state.translation.y || 0,
            }
          }
          if (state.rotation != null) viewport.rotation = state.rotation
          if (applyWwwc && viewport.voi) {
            viewport.voi.windowWidth = state.ww
            viewport.voi.windowCenter = state.wc
          }
        } else {
          const preferred = {
            zoom: state.zoom,
            translation: state.translation,
            rotation: state.rotation,
          }
          if (applyWwwc) {
            preferred.ww = state.ww
            preferred.wc = state.wc
            preferred.wwwcUserSet = true
          } else {
            try {
              const logical =
                typeof this.getLogicalWwwc === 'function'
                  ? this.getLogicalWwwc()
                  : null
              const seriesUID =
                typeof this.getActiveSeriesUidKey === 'function'
                  ? this.getActiveSeriesUidKey()
                  : null
              const userSet =
                seriesUID && typeof this.isSeriesWwwcUserSet === 'function'
                  ? this.isSeriesWwwcUserSet(seriesUID)
                  : false
              if (userSet && logical && logical.ww != null && logical.wc != null) {
                preferred.ww = logical.ww
                preferred.wc = logical.wc
                preferred.wwwcUserSet = true
              }
            } catch (eKeep) {
              /* ignore */
            }
          }
          viewport = this.buildViewportPreservingView(
            this.dicomImage,
            this.image,
            preferred,
            fileData
          )
        }

        cornerstone.setViewport(this.dicomImage, viewport)
        cornerstone.updateImage(this.dicomImage)
      } catch (e) {
        /* ignore */
      }
    }

    /** Lee tag DICOM o cae a metadata de file / null. */
    safeImageString = (image, tag, fallback = null) => {
      if (image && image.data && typeof image.data.string === 'function') {
        try {
          const v = image.data.string(tag)
          if (v != null && v !== '') return v
        } catch (e) {
          /* ignore */
        }
      }
      return fallback
    }

    getSopInstanceUID = () => {
      const fromImage = this.safeImageString(this.image, 'x00080018', null)
      if (fromImage) return fromImage
      const files = this.files === null ? this.props.files : this.files
      const f =
        Array.isArray(files) && files[this.sliceIndex] != null
          ? files[this.sliceIndex]
          : null
      return (f && f.sopInstanceUID) || this.sopInstanceUid || null
    }

    getPixelRepresentation = () => {
      if (!this.image || !this.image.data || typeof this.image.data.uint16 !== 'function') return
      const value = this.image.data.uint16('x00280103')
      if (value === undefined) return
      return value + (value === 0 ? ' (unsigned)' : ' (signed)')
    }

    getPlanarConfiguration = () => {
      if (!this.image || !this.image.data || typeof this.image.data.uint16 !== 'function') return
      const value = this.image.data.uint16('x00280006')
      if (value === undefined) return 
      return value + (value === 0 ? ' (pixel)' : ' (plane)')
    }

    getDicomViewerElement = () => {
      return document.getElementsByClassName('cornerstone-enabled-image')
    }
   
    onImageLoaded = (e) => {
      //console.log('cornerstoneimageloaded: ')
      this.props.onLoadedImage()
    }

    // Listen for changes to the viewport so we can update the text overlays in the corner
    onImageRendered = (e) => {
      // PREVIEW / primera pintura: no hacer trabajo síncrono pesado aquí
      // (displayImage dispara este evento en el mismo stack → congela y no llega al contador)
      if (this._skipHeavyImageRendered || this._cssWwwcDragging) {
        return
      }
      try {
        const viewport = cornerstone.getViewport(e.target)
        if (!viewport || viewport.scale == null) return
        this.zoom = Math.round(Number(viewport.scale).toFixed(2) * 100)

        const isPrev =
          this.isDicom === false ||
          (this.image && !this.image.data) ||
          (this.files &&
            this.files[this.sliceIndex] &&
            this.files[this.sliceIndex].renderKind === 'preview')

        // Path mínimo PREVIEW (móvil): solo WW/zoom en overlays, sin getCurrentImageInfo
        if (isPrev) {
          const mrbottomleft = document.getElementById(`mrbottomleft-${this.props.index}`)
          if (mrbottomleft) {
            const { ww, wc } = this.getLogicalWwwc()
            mrbottomleft.textContent = `WW/WC: ${Math.round(ww)}/${Math.round(wc)}`
          }
          const mrbottomright = document.getElementById(`mrbottomright-${this.props.index}`)
          if (mrbottomright) {
            const w = (this.image && (this.image.columns || this.image.width)) || '?'
            const h = (this.image && (this.image.rows || this.image.height)) || '?'
            mrbottomright.textContent = `${w}x${h} | Zoom: ${this.zoom}%`
          }
          // Persistir zoom/pan + VOI clínico por serie
          try {
            const files = this.files === null ? this.props.files : this.files
            const f =
              Array.isArray(files) && files[this.sliceIndex] != null
                ? files[this.sliceIndex]
                : null
            const seriesUID = this.getSeriesUidFrom(this.image, f)
            if (seriesUID) {
              this.captureViewportToToolState(seriesUID, viewport)
            }
          } catch (err) {
            /* ignore */
          }
          // Throttle contador (no cada paint)
          const now = Date.now()
          if (!this._lastCounterPaintAt || now - this._lastCounterPaintAt > 120) {
            this._lastCounterPaintAt = now
            try {
              this.updateImageInfoDisplay({ light: true })
            } catch (err) {
              /* ignore */
            }
          }
          this.scheduleScrollSliceNotify()
          return
        }

        // Guardar el estado de WW/WC y Zoom para la serie actual (solo DICOM real)
        const seriesUID =
          this.safeImageString(this.image, 'x0020000e', null) ||
          this.getActiveSeriesUidKey()
        const localFrame =
          typeof this.isActiveLocalWwwcFrame === 'function' &&
          this.isActiveLocalWwwcFrame()
        if (seriesUID && viewport.voi) {
                const currentState = this.toolState[seriesUID] || {}
                const userWwwc = !!currentState.wwwcUserSet
                const persistWwwc =
                  !localFrame &&
                  (userWwwc || this._wwwcPointerActive || this._wwwcDidModify)
                const hasChanged =
                    Math.abs((currentState.zoom || 0) - viewport.scale) > 0.01 ||
                    !areEqual(currentState.translation, viewport.translation) ||
                    Math.abs((currentState.rotation || 0) - (viewport.rotation || 0)) > 0.01 ||
                    (persistWwwc &&
                      (Math.abs((currentState.ww || 0) - viewport.voi.windowWidth) > 1 ||
                        Math.abs((currentState.wc || 0) - viewport.voi.windowCenter) > 1))

                if (hasChanged) {
                    const next = {
                        ...(currentState || {}),
                        zoom: viewport.scale,
                        translation: viewport.translation,
                        rotation: viewport.rotation,
                    }
                    if (persistWwwc) {
                      next.ww = viewport.voi.windowWidth
                      next.wc = viewport.voi.windowCenter
                      if (this._wwwcDidModify || this._wwwcPointerActive) {
                        next.wwwcUserSet = true
                      }
                    }
                    this.toolState[seriesUID] = next
                }
                if (!userWwwc && viewport.voi) {
                  this._logicalWwwc = {
                    ww: viewport.voi.windowWidth,
                    wc: viewport.voi.windowCenter,
                  }
                } else if (persistWwwc) {
                    this._logicalWwwc = {
                      ww: viewport.voi.windowWidth,
                      wc: viewport.voi.windowCenter,
                    }
                } else if (localFrame && viewport.voi) {
                  this._logicalWwwc = {
                    ww: viewport.voi.windowWidth,
                    wc: viewport.voi.windowCenter,
                  }
                }
        }

        // Actualizar la UI con los valores actuales
        const mrtopleft = document.getElementById(`mrtopleft-${this.props.index}`)
        if (mrtopleft) {
            if (this.mprIsOrthogonalView()) {
                mrtopleft.textContent = `${capitalize(this.mprPlane)}`
                // Aplicar estilos básicos para vista MPR
                mrtopleft.style.cssText = `
                    position: absolute;
                    top: 0;
                    left: 3px;
                    color: #4caf50;
                    font-size: 0.9em;
                    font-weight: 600;
                    text-shadow: 1px 1px 2px #000;
                    z-index: 10;
                    background-color: rgba(0, 0, 0, 0.6);
                    padding: 4px 6px;
                    border-radius: 4px;
                `
            } else {
                // Mostrar información completa del paciente en la esquina superior izquierda
                const imageInfo = this.getCurrentImageInfo()
                if (imageInfo) {
                    mrtopleft.innerHTML = `
                        <div style="font-size: 0.8em; line-height: 1.1; margin-bottom: 2px; color: #ffffff;">
                            ${imageInfo.patientName}
                        </div>
                        <div style="font-size: 0.7em; line-height: 1.0; color: #cccccc;">
                            ID: ${imageInfo.patientID} | ${imageInfo.patientSex} | ${imageInfo.studyDate}
                        </div>
                    `
                    // Aplicar estilos con fondo translúcido para información del paciente
                    mrtopleft.style.cssText = `
                        position: absolute;
                        top: 0;
                        left: 3px;
                        text-shadow: 1px 1px 2px #000;
                        z-index: 10;
                        background-color: rgba(0, 0, 0, 0.6);
                        padding: 6px 8px;
                        border-radius: 4px;
                        max-width: 250px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        line-height: 1.0;
                        text-align: left;
                    `
                    
                    // Aplicar estilos responsivos para dispositivos móviles
                    if (window.innerWidth <= 768) {
                        mrtopleft.style.cssText += `
                            max-width: 200px;
                            padding: 4px 6px;
                        `
                    }
                } else {
                    mrtopleft.textContent = `${this.PatientsName}`
                    // Aplicar estilos básicos para fallback
                    mrtopleft.style.cssText = `
                        position: absolute;
                        top: 0;
                        left: 3px;
                        color: #ffffff;
                        font-size: 0.8em;
                        text-shadow: 1px 1px 2px #000;
                        z-index: 10;
                        background-color: rgba(0, 0, 0, 0.6);
                        padding: 4px 6px;
                        border-radius: 4px;
                    `
                }
            }
        }

        const mrtopright = document.getElementById(`mrtopright-${this.props.index}`)
        if (mrtopright) {
            mrtopright.textContent = ''
        }

        const mrbottomleft = document.getElementById(`mrbottomleft-${this.props.index}`)
        if (mrbottomleft) {
            const ww = viewport.voi ? Math.round(viewport.voi.windowWidth) : '—'
            const wc = viewport.voi ? Math.round(viewport.voi.windowCenter) : '—'
            mrbottomleft.textContent = `WW/WC: ${ww}/${wc}`
        }

        const mrbottomright = document.getElementById(`mrbottomright-${this.props.index}`)
        if (mrbottomright) {
            // Mostrar resolución de la imagen por encima del zoom
            let resolutionText = ''
            if (viewport.displayedArea && viewport.displayedArea.brhc) {
                resolutionText = `${viewport.displayedArea.brhc.x}x${viewport.displayedArea.brhc.y}`
            } else if (this.image && (this.image.columns || this.image.rows)) {
                resolutionText = `${this.image.columns || this.image.width || '?'}x${this.image.rows || this.image.height || '?'}`
            } else {
                resolutionText = 'N/A'
            }
            
            mrbottomright.textContent = `${resolutionText} | Zoom: ${this.zoom}%`
        }

        // Si hay un gesto WW/WC en curso, detectar si se aplicó un cambio real
        this.markWwwcModifiedIfNeeded(viewport)

        // Sync WW/WC en vivo solo durante gesto activo (no por tool===Wwwc en idle)
        if (
          this.props.onVoiChange &&
          viewport.voi &&
          this._wwwcPointerActive &&
          !this._cssWwwcDragging
        ) {
            this.props.onVoiChange(
              viewport.voi.windowWidth,
              viewport.voi.windowCenter,
              this.props.index
            )
        }

        const mrtopcenter = document.getElementById(`mrtopcenter-${this.props.index}`)
        if (mrtopcenter) mrtopcenter.textContent = ``
        const mrbottomcenter = document.getElementById(`mrbottomcenter-${this.props.index}`)
        if (mrbottomcenter) mrbottomcenter.textContent = ``    
        const mrleftcenter = document.getElementById(`mrleftcenter-${this.props.index}`)
        if (mrleftcenter) mrleftcenter.textContent = ``      
        const mrrightcenter = document.getElementById(`mrrightcenter-${this.props.index}`)
        if (mrrightcenter) mrrightcenter.textContent = ``  

        if (this.mprPlane === 'sagittal') {
            if (mrtopcenter) mrtopcenter.textContent = `S`
            if (mrbottomcenter) mrbottomcenter.textContent = `I`    
            if (mrleftcenter) mrleftcenter.textContent = `A`      
            if (mrrightcenter) mrrightcenter.textContent = `P`  

        } else if (this.mprPlane === 'axial') {
            if (mrtopcenter) mrtopcenter.textContent = `A`
            if (mrbottomcenter) mrbottomcenter.textContent = `P`    
            if (mrleftcenter) mrleftcenter.textContent = `R`      
            if (mrrightcenter) mrrightcenter.textContent = `L`    

        } else if (this.mprPlane === 'coronal') {
            if (mrtopcenter) mrtopcenter.textContent = `S`
            if (mrbottomcenter) mrbottomcenter.textContent = `I`    
            if (mrleftcenter) mrleftcenter.textContent = `R`      
            if (mrrightcenter) mrrightcenter.textContent = `L`                    
        }    

        // Scout/MPR custom lines desactivadas: solo CornerstoneTools ReferenceLines

        // Multi-frame (XA): sincronizar frame con tool stack (wheel/gestos/cine)
        // Durante play: solo DOM (setState 30fps congela React y deja scroll/cine rotos al pausar)
        if (this.isDicom && this.isMultiFrameCine()) {
            let frame1 = this.state.frame || 1
            try {
              const stackState = cornerstoneTools.getToolState(this.dicomImage, 'stack')
              if (stackState && stackState.data && stackState.data[0]) {
                const idx = stackState.data[0].currentImageIdIndex
                if (idx != null && !Number.isNaN(Number(idx))) {
                  frame1 = Number(idx) + 1
                }
              }
            } catch (e) {
              /* ignore */
            }
            const total =
              this.numberOfFrames > 1
                ? this.numberOfFrames
                : resolveFileNumberOfFrames(
                    this.files && (this.files[this.sliceIndex] || this.files[0])
                  ) || this.numberOfFrames
            // Verde (viewport) + blanco (cine): mismo valor por DOM
            this.paintFrameCountersDom(frame1, total)
            this.syncCineScrollbar()
            if (this.state.inPlay) {
              // Contador en DOM; fin de run lo maneja multiFrameCineStep
            } else {
              if (frame1 !== this.state.frame) {
                this.setState({ frame: frame1 })
              }
              this.notifyMultiFrameIndex(frame1 - 1)
            }
        }

        this.props.onRenderedImage && this.props.onRenderedImage(this.props.index)
        this.updateCrosshairOverlay()
        this.schedulePetFusionPaint()
      } catch (err) {
        console.warn('DicomViewer - onImageRendered:', err)
      }
    }

    onMeasurementModified = (e) => {
      const data = e && e.detail && e.detail.measurementData
      if (!data || !this.measurements.length) return
      const uid = data.uuid
      if (!uid) return
      const hit = this.measurements.find((m) => m && m.data && m.data.uuid === uid)
      if (!hit) return
      hit.data = data
      this.props.setActiveMeasurements(this.measurements.slice())
    }

    onMeasurementAdded = () => {
      // No persistir al primer clic: Length/ROI aún no tienen length/area (rompe MeasureItem).
    }

    persistCompletedMeasurement = (measure) => {
      const uid = measure && measure.data && measure.data.uuid
      if (uid && this.measurements.some((m) => m && m.data && m.data.uuid === uid)) {
        const i = this.measurements.findIndex((m) => m.data && m.data.uuid === uid)
        if (i >= 0) this.measurements[i] = measure
      } else {
        this.measurementSave(measure)
      }
      this.attachSuvToMeasurement(measure)
      this.props.setActiveMeasurements(this.measurements.slice())
    }

    fusionEnabled = () => {
      const f = this.props.petFusion
      return !!(f && f.on && Array.isArray(f.files) && f.files.length)
    }

    clearPetFusionCanvas = () => {
      const cv = this._petFusionCanvas
      if (!cv) return
      const ctx = cv.getContext('2d')
      if (ctx) ctx.clearRect(0, 0, cv.width, cv.height)
      cv.style.display = 'none'
    }

    schedulePetFusionPaint = () => {
      if (this._petFusionRaf) return
      this._petFusionRaf = requestAnimationFrame(() => {
        this._petFusionRaf = null
        this.paintPetFusionOverlay()
      })
    }

    paintPetFusionOverlay = async () => {
      const canvas = this._petFusionCanvas
      const element = this.dicomImage
      if (!canvas || !element) return
      if (!this.fusionEnabled() || this.isMprGenerated) {
        this.clearPetFusionCanvas()
        return
      }
      if (this.isWheelGestureLive()) return
      const anatomyFiles = this.files === null ? this.props.files : this.files
      if (seriesLooksPet(anatomyFiles) && !seriesLooksAnatomy(anatomyFiles)) {
        this.clearPetFusionCanvas()
        return
      }
      const petFiles = this.props.petFusion.files
      const anatomyFile = anatomyFiles && anatomyFiles[this.sliceIndex]
      if (!anatomyFile || !this.image) {
        this.clearPetFusionCanvas()
        return
      }
      const petIdx = nearestPetSliceIndex(anatomyFile, petFiles)
      const petFile = petIdx >= 0 ? petFiles[petIdx] : null
      if (!petFile) {
        this.clearPetFusionCanvas()
        return
      }
      const cached = this.getMemoryCachedImage(petFile)
      let petImage = (cached && cached.image) || petFile.image
      if (!petImage || typeof petImage.getPixelData !== 'function') {
        const gen = ++this._petFusionLoadGen
        try {
          const loaded = await this.hydrateFileImagePreferringCache(petFile)
          if (gen !== this._petFusionLoadGen) return
          petImage = loaded && loaded.image
          if (petImage) {
            try {
              stampSliceGeometry(petFile, petImage)
            } catch (e) {
              /* ignore */
            }
            this.rememberDecodedImage(petFile, petImage, loaded.imageId)
          }
        } catch (e) {
          return
        }
      }
      if (!petImage || typeof petImage.getPixelData !== 'function') {
        this.clearPetFusionCanvas()
        return
      }

      const host = element.getBoundingClientRect()
      const w = Math.max(1, Math.round(host.width))
      const h = Math.max(1, Math.round(host.height))
      if (canvas.width !== w) canvas.width = w
      if (canvas.height !== h) canvas.height = h

      const corners = petCornersInAnatomyPixels(petFile, petImage, anatomyFile, this.image)
      if (!corners) {
        this.clearPetFusionCanvas()
        return
      }
      const fusion = this.props.petFusion
      const key = `${petFile.sopInstanceUID || petIdx}:${fusion.clut}:${fusion.windowMax}:${w}x${h}`
      if (key !== this._petFusionLastKey || !this._petFusionOffscreen) {
        const pd = petImage.getPixelData()
        const imgData = colorizePetImageData(
          pd,
          petImage.rows,
          petImage.columns,
          petImage,
          fusion.clut || 'hotMetal',
          Number(fusion.windowMax) || 5
        )
        if (!imgData) {
          this.clearPetFusionCanvas()
          return
        }
        if (!this._petFusionOffscreen) {
          this._petFusionOffscreen = document.createElement('canvas')
        }
        this._petFusionOffscreen.width = petImage.columns
        this._petFusionOffscreen.height = petImage.rows
        this._petFusionOffscreen.getContext('2d').putImageData(imgData, 0, 0)
        this._petFusionLastKey = key
      }

      let c0
      let cX
      let cY
      try {
        c0 = cornerstone.pixelToCanvas(element, corners.origin)
        cX = cornerstone.pixelToCanvas(element, corners.x)
        cY = cornerstone.pixelToCanvas(element, corners.y)
      } catch (e) {
        this.clearPetFusionCanvas()
        return
      }
      const ctx = canvas.getContext('2d')
      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.clearRect(0, 0, w, h)
      ctx.globalAlpha = Math.max(0, Math.min(1, Number(fusion.opacity) || 0.5))
      ctx.setTransform(
        (cX.x - c0.x) / corners.cols,
        (cX.y - c0.y) / corners.cols,
        (cY.x - c0.x) / corners.rows,
        (cY.y - c0.y) / corners.rows,
        c0.x,
        c0.y
      )
      ctx.imageSmoothingEnabled = true
      ctx.drawImage(this._petFusionOffscreen, 0, 0)
      ctx.setTransform(1, 0, 0, 1, 0, 0)
      ctx.globalAlpha = 1
      canvas.style.display = 'block'
    }

    attachSuvToMeasurement = (measure) => {
      if (!measure || !measure.data) return
      const tool = measure.tool
      if (tool !== 'EllipticalRoi' && tool !== 'RectangleRoi' && tool !== 'FreehandRoi') return
      if (!this.fusionEnabled()) return
      const anatomyFiles = this.files === null ? this.props.files : this.files
      const anatomyFile = anatomyFiles && anatomyFiles[this.sliceIndex]
      const petFiles = this.props.petFusion.files
      const petIdx = nearestPetSliceIndex(anatomyFile, petFiles)
      const petFile = petIdx >= 0 ? petFiles[petIdx] : null
      const cachedPet = petFile && this.getMemoryCachedImage(petFile)
      const petImage = (cachedPet && cachedPet.image) || (petFile && petFile.image)
      if (!petFile || !petImage) return
      const samples = sampleRoiOnPet(
        measure.data.handles,
        petImage,
        petFile,
        anatomyFile,
        this.image
      )
      const stats = suvStatsFromSamples(samples, petImage)
      if (stats) measure.data.suv = stats
    }

    gspsFilesKey = (files) => {
      if (!files || !files.length) return ''
      return files
        .map((f) => (f && (f.sopInstanceUID || f.imageId || f.name)) || '')
        .join('|')
    }

    syncGspsFromProps = (prevGsps, gsps) => {
      const nextFiles = (gsps && gsps.files) || []
      const prevFiles = (prevGsps && prevGsps.files) || []
      const nextKey = this.gspsFilesKey(nextFiles)
      const prevKey = this.gspsFilesKey(prevFiles)
      if (nextKey !== prevKey || nextKey !== this._gspsFilesKey) {
        this.ensureGspsIndex()
      }
      const nextOn = !!(gsps && gsps.on)
      const prevOn = !!(prevGsps && prevGsps.on)
      if (nextOn !== prevOn) {
        if (nextOn) {
          this._gspsAppliedSop = null
          this.applyGspsForCurrentSop()
        } else {
          this.removeGspsMeasurements()
        }
      }
    }

    ensureGspsIndex = async () => {
      const files = (this.props.gsps && this.props.gsps.files) || []
      this._gspsFilesKey = this.gspsFilesKey(files)
      if (!files.length) {
        this._gspsBySop = {}
        this._gspsVoiBySop = {}
        this._gspsAppliedSop = null
        return
      }
      const gen = ++this._gspsIndexGen
      const entries = []
      for (let i = 0; i < files.length; i++) {
        const file = files[i]
        if (gen !== this._gspsIndexGen) return
        let parsed = null
        try {
          parsed = await parseGspsFromFile(file)
        } catch (e) {
          parsed = null
        }
        if (!parsed || !parsed.isGsps) continue
        entries.push({ parsed })
      }
      if (gen !== this._gspsIndexGen) return
      this._gspsBySop = indexGspsByReferencedSop(entries)
      this._gspsVoiBySop = indexGspsVoiByReferencedSop(entries)
      this._gspsAppliedSop = null
      this.applyGspsForCurrentSop()
    }

    gspsEnabled = () => !!(this.props.gsps && this.props.gsps.on)

    removeGspsMeasurements = () => {
      const had = this.measurements.some((m) => m && m.data && m.data._fromGsps)
      this._gspsAppliedSop = null
      if (!had) return
      const element = this.dicomImage
      const kept = []
      this.measurements.forEach((measure) => {
        const fromGsps = measure && measure.data && measure.data._fromGsps
        if (fromGsps) {
          if (element) {
            try {
              cornerstoneTools.removeToolState(element, measure.tool, measure.data)
            } catch (e) {
              /* ignore */
            }
          }
        } else {
          kept.push(measure)
        }
      })
      this.measurements.splice(0, this.measurements.length, ...kept)
      try {
        this.props.setActiveMeasurements(this.measurements.slice())
      } catch (e) {
        /* ignore */
      }
      if (element) {
        try {
          cornerstone.updateImage(element)
        } catch (e2) {
          /* ignore */
        }
      }
    }

    applyGspsForCurrentSop = () => {
      if (!this.gspsEnabled() || this.isMprGenerated) return
      if (this.image && this.image.data && parsedFromImage(this.image)) return
      const sop = this.sopInstanceUid
      if (!sop || this._gspsAppliedSop === sop) return
      this.removeGspsMeasurements()
      const list = this._gspsBySop && this._gspsBySop[sop]
      this._gspsAppliedSop = sop
      const voi = this._gspsVoiBySop && this._gspsVoiBySop[sop]
      if (
        voi &&
        Number.isFinite(Number(voi.windowWidth)) &&
        Number(voi.windowWidth) > 0 &&
        Number.isFinite(Number(voi.windowCenter))
      ) {
        try {
          this.applyClinicalVoi(Number(voi.windowWidth), Number(voi.windowCenter))
        } catch (e) {
          /* ignore */
        }
      }
      if (!list || !list.length) return
      const element = this.dicomImage
      if (!element) return
      list.forEach((measure) => {
        const cloned = cloneMeasurement(measure)
        if (!cloned || !cloned.data) return
        cloned.data._fromGsps = true
        cloned.note = cloned.note || 'GSPS'
        try {
          cornerstoneTools.addToolState(element, cloned.tool, cloned.data)
          this.measurementSave(cloned)
        } catch (e) {
          /* ignore */
        }
      })
      try {
        this.props.setActiveMeasurements(this.measurements.slice())
        cornerstone.updateImage(element)
      } catch (e) {
        /* ignore */
      }
    }

    onMeasurementCompleted = (e) => {
      const measure = {
        tool: this.props.tool,
        note: '',
        data: e.detail.measurementData
      }
      if (this.props.tool === "FreehandRoi") {
        setTimeout(() => this.persistCompletedMeasurement(measure), 500)
      } else {
        this.persistCompletedMeasurement(measure)
      }
    }
    
    onErrorOpenImageClose = () => {
      this.setState({errorOnOpenImage: null})
    }

    onErrorCorsClose = () => {
      this.setState({errorOnCors: false})
    }    

    updateImage = () => {
      const element = this.dicomImage
      if (!element || this.isUpdating) return

      // Limpiar timeout anterior si existe
      if (this.updateTimeout) {
        clearTimeout(this.updateTimeout)
      }

      // Usar debounce para evitar actualizaciones excesivas
      this.updateTimeout = setTimeout(() => {
        try {
          this.isUpdating = true
          cornerstone.updateImage(element)
        } catch (error) {
          console.warn('DicomViewer - Error updating image:', error)
        } finally {
          this.isUpdating = false
        }
      }, 16) // ~60fps
    }

    // Método para pre-cargar imágenes adyacentes
    preloadAdjacentImages = (currentIndex) => {
      if (!this.files || this.files.length <= 1) return
      // PREVIEW en móvil: no preload síncrono/paralelo (cuelga el hilo y satura red)
      try {
        const first = this.files[0]
        const isPreviewStack =
          (first && first.renderKind === 'preview') ||
          (this.image && !this.image.data)
        if (isPreviewStack && (isMobile || isTablet)) {
          return
        }
      } catch (e) {
        /* continue */
      }

      const files = this.files === null ? this.props.files : this.files
      const preloadRange = isMobile || isTablet ? 1 : 2

      this.preloadQueue = []

      for (let i = Math.max(0, currentIndex - preloadRange);
           i <= Math.min(files.length - 1, currentIndex + preloadRange);
           i++) {
        const f = files[i]
        if (i === currentIndex || !f) continue
        if (this.getMemoryCachedImage(f)) continue
        if (f.imageId || f.sopInstanceUID) {
          this.preloadQueue.push(i)
        }
      }

      this.processPreloadQueue()
    }

    // Procesar la cola de pre-carga
    processPreloadQueue = () => {
      if (this.preloadQueue.length === 0) return

      // No competir con el scrolleo: IDB/decode en idle
      const scrolling =
        this.isStackScrollLive() ||
        this._seekRaf ||
        this._inertiaRaf ||
        this._stackPanActive ||
        this.isMouseDown
      if (scrolling) {
        if (!this._preloadDeferTimer) {
          this._preloadDeferTimer = setTimeout(() => {
            this._preloadDeferTimer = null
            this.processPreloadQueue()
          }, 120)
        }
        return
      }

      const index = this.preloadQueue.shift()
      const files = this.files === null ? this.props.files : this.files
      const f = files[index]
      const delayMs = isMobile || isTablet ? 80 : 16

      if (!f) {
        setTimeout(() => this.processPreloadQueue(), delayMs)
        return
      }

      const mem = this.getMemoryCachedImage(f)
      if (mem && mem.image) {
        this.rememberDecodedImage(f, mem.image, mem.imageId)
        setTimeout(() => this.processPreloadQueue(), delayMs)
        return
      }

      this.hydrateFileImagePreferringCache(f)
        .then((loaded) => {
          if (loaded && loaded.image) {
            this.rememberDecodedImage(f, loaded.image, loaded.imageId)
          }
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => this.processPreloadQueue(), delayMs)
        })
    }

    /**
     * Imagen ya decodificada en RAM (store, Map del viewer o cache de Cornerstone).
     * @param {object} fileData
     * @returns {{ image: object, imageId: string }|null}
     */
    getMemoryCachedImage = (fileData) => {
      if (!fileData) return null
      if (fileData.image) {
        return { image: fileData.image, imageId: fileData.imageId || '' }
      }
      // Store Redux: el download escribe image ahí; el viewport puede tener stub.
      const fromStore = this.findStoreRamImage(fileData)
      if (fromStore && fromStore.image) {
        return fromStore
      }
      const ids = []
      if (fileData.imageId) ids.push(fileData.imageId)
      if (fileData.decodedImageId && fileData.decodedImageId !== fileData.imageId) {
        ids.push(fileData.decodedImageId)
      }
      if (fileData.sopInstanceUID) ids.push(`sop:${fileData.sopInstanceUID}`)
      for (let i = 0; i < ids.length; i++) {
        const id = ids[i]
        if (this.imageCache.has(id)) {
          const image = this.imageCache.get(id)
          if (image) return { image, imageId: fileData.imageId || id }
        }
      }
      // O(1) vía getImageLoadObject — NUNCA escanear cachedImages[] (O(n) con 3k+).
      try {
        if (
          cornerstone.imageCache &&
          typeof cornerstone.imageCache.getImageLoadObject === 'function'
        ) {
          for (let i = 0; i < ids.length; i++) {
            const id = ids[i]
            if (!id || id.indexOf('sop:') === 0) continue
            const lo = cornerstone.imageCache.getImageLoadObject(id)
            if (lo && lo.image) {
              return { image: lo.image, imageId: id }
            }
          }
        }
      } catch (e) {
        /* ignore */
      }
      return null
    }

    /**
     * Busca image ya decodificada en props.files (misma SOP / imageId).
     * Índice O(1) invalidado cuando cambia la referencia del store.
     */
    findStoreRamImage = (fileData) => {
      if (!fileData) return null
      const pool = this.props && this.props.files
      if (!Array.isArray(pool) || !pool.length) return null
      if (this._storeRamIndexPool !== pool) {
        this._storeRamIndexPool = pool
        this._storeRamBySop = new Map()
        this._storeRamByImageId = new Map()
        for (let i = 0; i < pool.length; i++) {
          const f = pool[i]
          if (!f || !f.image) continue
          if (f.sopInstanceUID) {
            this._storeRamBySop.set(String(f.sopInstanceUID), f)
          }
          if (f.imageId) {
            this._storeRamByImageId.set(String(f.imageId), f)
          }
        }
      }
      let hit = null
      if (fileData.sopInstanceUID) {
        hit = this._storeRamBySop.get(String(fileData.sopInstanceUID))
      }
      if (!hit && fileData.imageId) {
        hit = this._storeRamByImageId.get(String(fileData.imageId))
      }
      if (!hit || !hit.image) return null
      try {
        if (!fileData.image) fileData.image = hit.image
        if (!fileData.imageId && hit.imageId) fileData.imageId = hit.imageId
      } catch (eAtt) {
        /* ignore */
      }
      return { image: hit.image, imageId: hit.imageId || fileData.imageId || '' }
    }

    /**
     * Índice más cercano con imagen en RAM (paint proxy mientras bajan previews).
     * @param {number} center
     * @param {number} [maxDist=2] — mid-scroll: solo vecinos inmediatos (evita saltos visuales)
     */
    findNearestRamStackIndex = (center, maxDist = 2) => {
      const files = this.files === null ? this.props.files : this.files
      if (!Array.isArray(files) || !files.length) return -1
      const n = files.length
      const c = Math.max(0, Math.min(n - 1, Math.round(center) || 0))
      if (this.getMemoryCachedImage(files[c])) return c
      const limit = Math.min(Math.max(0, maxDist | 0), n)
      for (let d = 1; d <= limit; d++) {
        const lo = c - d
        const hi = c + d
        if (lo >= 0 && this.getMemoryCachedImage(files[lo])) return lo
        if (hi < n && this.getMemoryCachedImage(files[hi])) return hi
      }
      return -1
    }

    /**
     * Publica pixels en Map (varias claves) para el próximo scroll síncrono.
     * Preview también se guarda en fileData.image para hits sync al scrollear.
     */
    rememberDecodedImage = (fileData, image, imageId) => {
      if (!fileData || !image) return
      const touch = (key) => {
        if (!key) return
        this.imageCache.set(key, image)
        const ord = this._imageCacheOrder
        if (!Array.isArray(ord)) {
          this._imageCacheOrder = [key]
          return
        }
        const at = ord.indexOf(key)
        if (at >= 0) ord.splice(at, 1)
        ord.push(key)
        const MAX =
          this._imageCacheMaxEntries > 0 ? this._imageCacheMaxEntries : 120
        while (ord.length > MAX) {
          this.evictFarthestImageCacheKey(ord, key)
        }
      }
      touch(imageId)
      if (fileData.imageId && fileData.imageId !== imageId) {
        touch(fileData.imageId)
      }
      if (fileData.sopInstanceUID) {
        touch(`sop:${fileData.sopInstanceUID}`)
      }
      if (imageId && imageId !== fileData.imageId) {
        fileData.decodedImageId = imageId
      }
      fileData.image = image
    }

    /**
     * Evicta la clave más lejana al sliceIndex actual (no solo FIFO).
     */
    evictFarthestImageCacheKey = (ord, keepKey) => {
      if (!Array.isArray(ord) || !ord.length) return
      const files = Array.isArray(this.files) ? this.files : []
      const center = this.sliceIndex || 0
      const indexByKey = new Map()
      for (let i = 0; i < files.length; i++) {
        const f = files[i]
        if (!f) continue
        if (f.imageId) indexByKey.set(String(f.imageId), i)
        if (f.decodedImageId) indexByKey.set(String(f.decodedImageId), i)
        if (f.sopInstanceUID) {
          indexByKey.set(`sop:${f.sopInstanceUID}`, i)
        }
      }
      let worstAt = -1
      let worstDist = -1
      for (let i = 0; i < ord.length; i++) {
        const k = ord[i]
        if (!k || k === keepKey) continue
        const idx = indexByKey.has(k) ? indexByKey.get(k) : -1
        const dist = idx < 0 ? 1e9 : Math.abs(idx - center)
        if (dist >= worstDist) {
          worstDist = dist
          worstAt = i
        }
      }
      if (worstAt < 0) {
        const old = ord.shift()
        if (old && old !== keepKey) this.imageCache.delete(old)
        return
      }
      const [old] = ord.splice(worstAt, 1)
      if (old) this.imageCache.delete(old)
    }

    isPreviewStackFiles = () => {
      try {
        const f0 =
          (Array.isArray(this.files) && (this.files[this.sliceIndex] || this.files[0])) ||
          null
        if (f0 && f0.renderKind === 'preview') return true
        if (this.image && !this.image.data) return true
        return false
      } catch (e) {
        return false
      }
    }

    /**
     * Prefetch agresivo en idle según RAM disponible.
     * Nunca corre mid-scroll (scroll-first).
     *
     * @param {{
     *   centerIndex?: number,
     *   studyFiles?: object[]|null,
     *   renderMode?: string|null,
     *   direction?: number,
     *   boostForward?: number,
     * }} [opts]
     */
    scheduleWarmScrollBuffer = (opts = {}) => {
      if (this._warmScrollTimer) {
        clearTimeout(this._warmScrollTimer)
        this._warmScrollTimer = null
      }
      const center =
        opts.centerIndex != null ? opts.centerIndex : this.sliceIndex || 0
      if (opts.studyFiles) this._warmStudyFiles = opts.studyFiles
      const studyFiles =
        opts.studyFiles || this._warmStudyFiles || null
      const renderMode =
        opts.renderMode ||
        this._appRenderMode ||
        (this.isPreviewStackFiles() ? RENDER_MODE.PREVIEW : RENDER_MODE.DIAGNOSTIC)
      const direction =
        opts.direction != null
          ? opts.direction
          : this._scrollDirection >= 0
            ? 1
            : -1
      const boostForward =
        opts.boostForward != null ? opts.boostForward : 0
      this._warmScrollTimer = setTimeout(() => {
        this._warmScrollTimer = null
        if (this.isStackScrollLive()) {
          this.scheduleWarmScrollBuffer({
            centerIndex: this.sliceIndex || center,
            studyFiles,
            renderMode,
            direction: this._scrollDirection || direction,
            boostForward,
          })
          return
        }
        void this.runWarmScrollBuffer({
          centerIndex: center,
          studyFiles,
          renderMode,
          direction,
          boostForward,
        })
      }, 60)
    }

    /**
     * @param {{
     *   centerIndex?: number,
     *   studyFiles?: object[]|null,
     *   renderMode?: string|null,
     *   direction?: number,
     *   boostForward?: number,
     * }} [opts]
     */
    runWarmScrollBuffer = async (opts = {}) => {
      if (this.isStackScrollLive()) return
      const seriesFiles = Array.isArray(this.files) ? this.files : []
      if (!seriesFiles.length) return

      const studyFiles =
        Array.isArray(opts.studyFiles) && opts.studyFiles.length
          ? opts.studyFiles
          : null
      const renderMode =
        opts.renderMode ||
        this._appRenderMode ||
        (this.isPreviewStackFiles() ? RENDER_MODE.PREVIEW : RENDER_MODE.DIAGNOSTIC)

      const policy = getScrollWarmupPolicy({
        renderMode,
        seriesLength: seriesFiles.length,
        studyLength: studyFiles ? studyFiles.length : seriesFiles.length,
      })
      this._imageCacheMaxEntries = policy.imageCacheMaxEntries

      let pool = seriesFiles
      if (policy.scope === 'study' && studyFiles && studyFiles.length) {
        pool = studyFiles
      }

      const centerInSeries = Math.max(
        0,
        Math.min(
          seriesFiles.length - 1,
          Math.round(
            opts.centerIndex != null ? opts.centerIndex : this.sliceIndex || 0
          )
        )
      )
      let center = centerInSeries
      if (pool !== seriesFiles) {
        const cur = seriesFiles[centerInSeries]
        const sop = cur && cur.sopInstanceUID ? String(cur.sopInstanceUID) : null
        const imgId = cur && cur.imageId ? String(cur.imageId) : null
        let found = -1
        if (sop) {
          found = pool.findIndex(
            (f) => f && f.sopInstanceUID && String(f.sopInstanceUID) === sop
          )
        }
        if (found < 0 && imgId) {
          found = pool.findIndex(
            (f) => f && f.imageId && String(f.imageId) === imgId
          )
        }
        center = found >= 0 ? found : 0
      }

      const direction =
        opts.direction != null
          ? opts.direction
          : this._scrollDirection >= 0
            ? 1
            : -1
      let boostForward = Number(opts.boostForward) || 0
      if (
        !boostForward &&
        policy.velocityBoost &&
        (this._wheelBurst || 0) >= 6
      ) {
        boostForward = Math.min(24, Math.round((this._wheelBurst || 0) * 1.5))
      }

      const order = buildWarmupIndexOrder(policy, pool.length, center, {
        direction,
        boostForward,
      })
      if (!order.length) return

      const gen = ++this._warmScrollGen
      const concurrency = Math.max(1, policy.concurrency || 2)
      let cursor = 0

      const worker = async () => {
        while (cursor < order.length) {
          if (gen !== this._warmScrollGen) return
          if (this.isStackScrollLive()) {
            this.scheduleWarmScrollBuffer({
              centerIndex: this.sliceIndex || centerInSeries,
              studyFiles,
              renderMode,
              direction: this._scrollDirection || direction,
              boostForward,
            })
            return
          }
          const i = order[cursor++]
          const f = pool[i]
          if (!f || !(f.imageId || f.sopInstanceUID)) continue
          if (this.getMemoryCachedImage(f)) continue
          try {
            const loaded = await this.hydrateFileImagePreferringCache(f)
            if (gen !== this._warmScrollGen) return
            if (loaded && loaded.image) {
              this.rememberDecodedImage(f, loaded.image, loaded.imageId)
            }
          } catch (e) {
            /* ignore miss */
          }
        }
      }

      const runners = []
      for (let w = 0; w < concurrency; w++) runners.push(worker())
      await Promise.all(runners)
    }

    /**
     * Prefetch vecinos — delega al warmup adaptativo (solo idle).
     */
    schedulePreviewScrollPrefetch = (centerIndex) => {
      if (this.isStackScrollLive()) {
        this._pendingScrollHydrateIndex = centerIndex
        return
      }
      this.scheduleWarmScrollBuffer({
        centerIndex,
        renderMode: this.isPreviewStackFiles()
          ? RENDER_MODE.PREVIEW
          : this._appRenderMode || RENDER_MODE.DIAGNOSTIC,
      })
    }

    runPreviewScrollPrefetch = (centerIndex) => {
      void this.runWarmScrollBuffer({
        centerIndex,
        renderMode: this.isPreviewStackFiles()
          ? RENDER_MODE.PREVIEW
          : this._appRenderMode || RENDER_MODE.DIAGNOSTIC,
      })
    }

    /**
     * Hidratar el corte actual cuando el usuario deja de scrollear (idle).
     * Política scroll-first: cero IDB/decode mientras el gesto está vivo.
     */
    schedulePostScrollHydrate = (index) => {
      // Planos MPR reconstruidos: this.files es el stack nativo; hidratar
      // files[sliceIndex] pinta un corte axial sobre coronal/sagital.
      if (this.isMprGenerated) return
      const idx =
        index != null && Number.isFinite(Number(index))
          ? Math.round(Number(index))
          : this.sliceIndex || 0
      this._pendingScrollHydrateIndex = idx
      if (this._postScrollHydrateTimer) {
        clearTimeout(this._postScrollHydrateTimer)
        this._postScrollHydrateTimer = null
      }
      if (this._postScrollHydrateIdle != null) {
        try {
          if (typeof cancelIdleCallback === 'function') {
            cancelIdleCallback(this._postScrollHydrateIdle)
          }
        } catch (e) {
          /* ignore */
        }
        this._postScrollHydrateIdle = null
      }
      this._postScrollHydrateTimer = setTimeout(() => {
        this._postScrollHydrateTimer = null
        if (this.isStackScrollLive()) {
          this.schedulePostScrollHydrate(this._pendingScrollHydrateIndex)
          return
        }
        const run = () => {
          if (this.isStackScrollLive()) return
          const want =
            this._pendingScrollHydrateIndex != null
              ? this._pendingScrollHydrateIndex
              : this.sliceIndex || 0
          const files = this.files
          const f = Array.isArray(files) ? files[want] : null
          if (!f) return
          if (!this.getMemoryCachedImage(f)) {
            void this.ensureFileImageThenDisplay(want, f)
          } else if (this.sliceIndex === want) {
            // Ya en RAM: asegurar paint del corte lógico si el canvas quedó atrás
            try {
              this.smoothImageTransition(want)
            } catch (e) {
              /* ignore */
            }
          }
          this.schedulePreviewScrollPrefetch(want)
          // Continuar llenando buffer según RAM (serie/estudio)
          this.scheduleWarmScrollBuffer({
            centerIndex: want,
            renderMode: this.isPreviewStackFiles()
              ? RENDER_MODE.PREVIEW
              : this._appRenderMode || RENDER_MODE.DIAGNOSTIC,
          })
        }
        if (typeof requestIdleCallback === 'function') {
          this._postScrollHydrateIdle = requestIdleCallback(
            () => {
              this._postScrollHydrateIdle = null
              run()
            },
            { timeout: 220 }
          )
        } else {
          run()
        }
      }, 90)
    }

    /**
     * Rehidrata pixels: RAM → IndexedDB → red (wadouri/https).
     * El scroll no debe esperar IDB si Cornerstone ya tiene el corte.
     * @param {object} fileData
     * @returns {Promise<{ image: object, imageId: string }|null>}
     */
    hydrateFileImagePreferringCache = async (fileData) => {
      if (!fileData) return null
      const mem = this.getMemoryCachedImage(fileData)
      if (mem && mem.image) return mem

      // Scroll-first: no tocar IDB/red mientras el gesto está vivo
      try {
        if (this.isStackScrollLive && this.isStackScrollLive()) {
          return null
        }
      } catch (eLive) {
        /* ignore */
      }

      let image = null
      let imageId = fileData.imageId || ''

      const inDiagnostic =
        typeof this.getAppRenderMode === 'function' &&
        this.getAppRenderMode() === RENDER_MODE.DIAGNOSTIC
      // Solo renderKind preview — tener previewUrl no debe bloquear DICOM
      // (webp CORS falla → fallback dcm; si no, viewport queda vacío).
      const preferPreview =
        !inDiagnostic && fileData.renderKind === 'preview'

      if (fileData.sopInstanceUID) {
        if (preferPreview) {
          try {
            const loaded = await loadPreviewFromCacheBySop(fileData.sopInstanceUID)
            if (loaded && loaded.image) {
              image = loaded.image
              imageId = loaded.imageId || imageId
            }
          } catch (e) {
            console.warn('DicomViewer - loadPreviewFromCacheBySop', e)
          }
        }
        // IDB DICOM: en PREVIEW puro se evita (XA MF congela). Si no hay preview
        // usable (CORS / usedFallback), sí hay que leer el Part-10 cacheado.
        if (!image && (!preferPreview || fileData.usedFallback)) {
          try {
            const { loadFromCacheBySop } = await import(
              '../utils/loadDicomInstanceWithCache'
            )
            const loaded = await loadFromCacheBySop(fileData.sopInstanceUID)
            if (loaded && loaded.image) {
              image = loaded.image
              imageId = loaded.imageId || imageId
            }
          } catch (e) {
            console.warn('DicomViewer - loadFromCacheBySop', e)
          }
        }
      }

      // Preferir URL preview https si aún no hay image.
      let previewHttpFailed = false
      if (!image && preferPreview) {
        const previewHttp =
          (fileData.previewUrl &&
            /^https?:\/\//i.test(String(fileData.previewUrl)) &&
            String(fileData.previewUrl)) ||
          (/^https?:\/\//i.test(String(imageId)) ? String(imageId) : '')
        if (previewHttp) {
          try {
            image = await cornerstone.loadAndCacheImage(previewHttp)
            imageId = previewHttp
          } catch (ePrev) {
            image = null
            previewHttpFailed = true
          }
        }
      }

      // udv-pending / udv-nonimage / udv-pdf = sin bytes Cornerstone.
      // Si preview https falló (CORS), cargar imageId DICOM / wadouri.
      if (
        !image &&
        imageId &&
        !/^udv-pending:/i.test(String(imageId)) &&
        !/^udv-nonimage:/i.test(String(imageId)) &&
        !/^udv-pdf:/i.test(String(imageId)) &&
        (!preferPreview || previewHttpFailed || fileData.usedFallback)
      ) {
        try {
          image = await cornerstone.loadAndCacheImage(imageId)
        } catch (e) {
          image = null
        }
      }

      if (!image) return null
      this.ensureImageRender(image, fileData)
      this.rememberDecodedImage(fileData, image, imageId)
      return { image, imageId }
    }

    /**
     * Imagen a mostrar para un índice del stack.
     * RAM primero (sync); needsLoad solo si hay que ir a IDB/red.
     */
    resolveStackImage = (index) => {
      const files = this.files === null ? this.props.files : this.files
      if (!files || !files[index]) return null
      const fileData = files[index]
      const mem = this.getMemoryCachedImage(fileData)
      if (mem && mem.image) {
        this.ensureImageRender(mem.image, fileData)
        this.rememberDecodedImage(fileData, mem.image, mem.imageId)
        return { fileData, image: mem.image }
      }
      if (fileData.imageId || fileData.sopInstanceUID) {
        return { fileData, image: null, needsLoad: true }
      }
      return null
    }

    /**
     * Rehidrata image desde fileManager / IDB y repinta en path ligero.
     * Nunca usar displayImageFromFiles aquí: enableTool/Redux traba el scroll PREVIEW.
     */
    ensureFileImageThenDisplay = async (index, fileData) => {
      if (!fileData) return
      if (this.isMprGenerated) return
      // Scroll-first: no IDB/decode mientras el gesto está vivo
      if (this.isStackScrollLive()) {
        this._pendingScrollHydrateIndex = index
        this.schedulePostScrollHydrate(index)
        return
      }
      // Nueva petición gana (otra slice o reintento)
      this._rehydratingIndex = index
      const gen = ++this._displayGen
      try {
        const loaded = await this.hydrateFileImagePreferringCache(fileData)
        if (this.isStackScrollLive()) {
          this._pendingScrollHydrateIndex = index
          this.schedulePostScrollHydrate(index)
          return
        }
        const image = loaded && loaded.image
        const imageId = loaded && loaded.imageId
        if (!image || gen !== this._displayGen) return
        try {
          stampSliceGeometry(fileData, image)
        } catch (eStamp) {
          /* ignore */
        }
        this.ensureImageRender(image, fileData)
        this.rememberDecodedImage(fileData, image, imageId)
        if (this.sliceIndex !== index) return
        // Paint ligero (mismo path que rueda); evita finishAfterPaint/Redux.
        if (this.smoothImageTransition(index)) {
          this.schedulePreviewScrollPrefetch(index)
          return
        }
        // soft-path falló: típico tras clear/mode-switch (element disabled)
        // aunque isOpen siga true → hay que re-enable con displayImageFromFiles
        let enabled = false
        try {
          const el = this.dicomImage
          enabled = !!(el && cornerstone.getEnabledElement(el))
        } catch (eEn) {
          enabled = false
        }
        const alreadyOpen =
          this.props.isOpen && this.props.isOpen[this.props.index]
        if (!enabled || !alreadyOpen) {
          this.displayImageFromFiles(index)
        }
        this.schedulePreviewScrollPrefetch(index)
      } catch (e) {
        console.warn('DicomViewer - ensureFileImageThenDisplay', e)
      } finally {
        if (this._rehydratingIndex === index) this._rehydratingIndex = null
      }
    }

    // Método para validar la integridad de la imagen mostrada
    validateImageIntegrity = (image, expectedIndex, expectedSeriesUID = null) => {
        if (!image || !image.data) {
            console.error('DicomViewer - Image validation failed: No image data')
            return false
        }

        try {
            // 1. Validar SeriesInstanceUID
            const seriesUID = image.data.string('x0020000e')
            if (!seriesUID) {
                console.error('DicomViewer - Image validation failed: No SeriesInstanceUID')
                return false
            }

            // Si se proporciona un SeriesInstanceUID esperado, validar que coincida
            // Solo validar si no estamos en proceso de cambio de serie o layout
            if (expectedSeriesUID && seriesUID !== expectedSeriesUID && !this.isChangingSeries) {
                console.error('DicomViewer - Image validation failed: SeriesInstanceUID mismatch', {
                    expected: expectedSeriesUID,
                    actual: seriesUID,
                    isChangingSeries: this.isChangingSeries
                })
                return false
            }

            // 2. Validar InstanceNumber
            const instanceNumber = image.data.string('x00200013')
            if (!instanceNumber) {
                console.warn('DicomViewer - Image validation warning: No InstanceNumber')
            } else {
                const instanceNum = parseInt(instanceNumber)
                // Verificar que el InstanceNumber sea razonable (no negativo, no demasiado grande)
                if (instanceNum < 0 || instanceNum > 10000) {
                    console.warn('DicomViewer - Image validation warning: Suspicious InstanceNumber', instanceNum)
                }
            }

            // 3. Validar SOPInstanceUID
            const sopInstanceUID = image.data.string('x00080018')
            if (!sopInstanceUID) {
                console.error('DicomViewer - Image validation failed: No SOPInstanceUID')
                return false
            }

            // 4. Validar que la imagen corresponde al índice esperado en la serie
            const files = this.files === null ? this.props.files : this.files
            if (files && files[expectedIndex]) {
                const expectedFile = files[expectedIndex]
                if (expectedFile.image && expectedFile.image.data) {
                    const expectedSOPUID = expectedFile.image.data.string('x00080018')
                    if (expectedSOPUID && sopInstanceUID !== expectedSOPUID) {
                        console.error('DicomViewer - Image validation failed: SOPInstanceUID mismatch', {
                            expected: expectedSOPUID,
                            actual: sopInstanceUID,
                            index: expectedIndex
                        })
                        return false
                    }
                }
            }

            // 5. Validar datos básicos de la imagen
            const rows = image.data.uint16('x00280010')
            const columns = image.data.uint16('x00280011')
            if (!rows || !columns || rows <= 0 || columns <= 0) {
                console.error('DicomViewer - Image validation failed: Invalid image dimensions', { rows, columns })
                return false
            }

            console.log('DicomViewer - Image validation passed:', {
                seriesUID,
                instanceNumber,
                sopInstanceUID,
                index: expectedIndex,
                dimensions: `${columns}x${rows}`
            })

            return true

        } catch (error) {
            console.error('DicomViewer - Image validation error:', error)
            return false
        }
    }

    // Método para validar la integridad de toda la serie
    validateSeriesIntegrity = () => {
        const files = this.files === null ? this.props.files : this.files
        if (!files || files.length === 0) {
            console.warn('DicomViewer - No files to validate')
            return { isValid: false, errors: ['No files available'] }
        }

        const errors = []
        const seriesUIDs = new Set()
        const sopInstanceUIDs = new Set()
        let firstSeriesUID = null
        let showable = 0

        for (let i = 0; i < files.length; i++) {
            const file = files[i]
            // Ítems ligeros: image puede ser null; basta imageId para el stack
            if (!file || !file.imageId) {
                errors.push(`File at index ${i} has no imageId`)
                continue
            }
            showable += 1

            const metaSeries =
              (file.series && file.series.seriesInstanceUID) ||
              file.seriesInstanceUID ||
              null
            if (metaSeries) {
                seriesUIDs.add(metaSeries)
                if (!firstSeriesUID) firstSeriesUID = metaSeries
                else if (metaSeries !== firstSeriesUID) {
                    errors.push(
                      `File at index ${i} has different SeriesInstanceUID: ${metaSeries} (expected: ${firstSeriesUID})`
                    )
                }
            }

            if (file.sopInstanceUID) {
                if (sopInstanceUIDs.has(file.sopInstanceUID)) {
                    errors.push(
                      `File at index ${i} has duplicate SOPInstanceUID: ${file.sopInstanceUID}`
                    )
                } else {
                    sopInstanceUIDs.add(file.sopInstanceUID)
                }
            }

            if (!file.image || !file.image.data) {
                continue
            }

            try {
                const seriesUID = file.image.data.string('x0020000e')
                const sopInstanceUID = file.image.data.string('x00080018')

                if (seriesUID) {
                    seriesUIDs.add(seriesUID)
                    if (!firstSeriesUID) {
                        firstSeriesUID = seriesUID
                    } else if (seriesUID !== firstSeriesUID) {
                        errors.push(
                          `File at index ${i} has different SeriesInstanceUID: ${seriesUID} (expected: ${firstSeriesUID})`
                        )
                    }
                }

                if (sopInstanceUID && !file.sopInstanceUID) {
                    if (sopInstanceUIDs.has(sopInstanceUID)) {
                        errors.push(
                          `File at index ${i} has duplicate SOPInstanceUID: ${sopInstanceUID}`
                        )
                    } else {
                        sopInstanceUIDs.add(sopInstanceUID)
                    }
                }
            } catch (error) {
                errors.push(`Error validating file at index ${i}: ${error.message}`)
            }
        }

        // Válido si hay frames navegables (no exige pixel data en todos)
        const isValid = showable > 0
        const result = {
            isValid,
            errors,
            totalFiles: files.length,
            showable,
            uniqueSeriesUIDs: seriesUIDs.size,
            uniqueSOPInstanceUIDs: sopInstanceUIDs.size,
            firstSeriesUID
        }

        if (isValid) {
            console.log('DicomViewer - Series integrity validation passed:', result)
        } else {
            console.error('DicomViewer - Series integrity validation failed:', result)
        }

        return result
    }

    // Método para obtener información de la imagen actual
    getCurrentImageInfo = () => {
        const files = this.files === null ? this.props.files : this.files
        const fileData =
          Array.isArray(files) && files[this.sliceIndex] != null
            ? files[this.sliceIndex]
            : null
        const meta = this.getFileMeta(fileData)

        if (!this.image && !fileData) {
            return null
        }

        try {
            const patientName =
              this.safeImageString(this.image, 'x00100010', meta.patientName) || 'N/A'
            const patientID =
              this.safeImageString(this.image, 'x00100020', meta.patientId) || 'N/A'
            const patientSex =
              this.safeImageString(this.image, 'x00100040', null) || 'N/A'

            const studyDate = this.safeImageString(this.image, 'x00080020', null) || ''
            const formattedStudyDate = studyDate
              ? `${studyDate.substring(0, 4)}-${studyDate.substring(4, 6)}-${studyDate.substring(6, 8)}`
              : (fileData && fileData.study && fileData.study.studyDate) || 'N/A'

            return {
                seriesUID: this.safeImageString(
                  this.image,
                  'x0020000e',
                  meta.seriesUid
                ),
                instanceNumber: this.safeImageString(
                  this.image,
                  'x00200013',
                  meta.instanceNumber
                ),
                sopInstanceUID: this.safeImageString(
                  this.image,
                  'x00080018',
                  meta.sopInstanceUID
                ),
                studyUID: this.safeImageString(
                  this.image,
                  'x0020000d',
                  meta.studyUid
                ),
                patientName: patientName,
                patientID: patientID,
                patientSex: patientSex,
                studyDate: formattedStudyDate,
                seriesDescription: this.safeImageString(
                  this.image,
                  'x0008103e',
                  meta.seriesDescription
                ),
                sliceIndex: this.sliceIndex,
                sliceMax: this.sliceMax,
                isPreview: this.isPreviewImage(this.image, fileData),
            }
        } catch (error) {
            console.error('DicomViewer - Error getting image info:', error)
            return null
        }
    }

    // Método para mostrar información de la imagen actual en la UI
    /**
     * Actualiza contador verde (viewport) y blanco (panel cine) por DOM.
     * En play no usamos setState a 30fps; ambos deben ir por este path.
     */
    paintFrameCountersDom = (frame1, total) => {
      const cur = Math.max(1, Number(frame1) || 1)
      const max = Math.max(1, Number(total) || 1)
      const compact = `${cur}/${max}`
      const spaced = `${cur} / ${max}`
      this._domFrame1 = cur
      try {
        const numEl = document.getElementById(
          `image-counter-num-${this.props.index}`
        )
        if (numEl) {
          numEl.textContent = compact
        } else {
          const box = document.getElementById(
            `image-counter-${this.props.index}`
          )
          if (box) {
            const first = box.querySelector('[data-udv-frame-counter]')
            if (first) first.textContent = compact
          }
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const labelEl = document.getElementById(
          `frameLabel-${this.props.index}`
        )
        if (labelEl) labelEl.textContent = spaced
      } catch (e) {
        /* ignore */
      }
    }

    updateImageInfoDisplay = (opts = {}) => {
        try {
            const light = !!(opts && opts.light)
            const imageCounter = document.getElementById(`image-counter-${this.props.index}`)
            if (!imageCounter) {
              this.syncCineScrollbar()
              return
            }

            const resolveFrameTotal = () => {
              const fromViewer = Number(this.numberOfFrames) || 0
              const f = this.files && (this.files[this.sliceIndex] || this.files[0])
              const fromMeta = resolveFileNumberOfFrames(f)
              return Math.max(fromViewer, fromMeta, 0)
            }

            const liveFrame1 = () => {
              const frameTotal = resolveFrameTotal()
              const multi =
                frameTotal > 1 &&
                ((this.files && this.files.length) <= 1 ||
                  this._multiFrameStackActive ||
                  (typeof this.isMultiFrameCine === 'function' &&
                    this.isMultiFrameCine()))
              if (multi && typeof this.getMultiFrameIndex0 === 'function') {
                return this.getMultiFrameIndex0() + 1
              }
              if (this._domFrame1 > 0) return this._domFrame1
              return this.state.frame || 1
            }

            const paintLight = () => {
              if (!this.files || this.files.length === 0) return
              const f = this.files[this.sliceIndex] || this.files[0]
              const seriesInfo =
                (f && f.series && f.series.seriesDescription) ||
                (f && f.seriesDescription) ||
                'Serie'
              const frameTotal = resolveFrameTotal()
              const multi =
                frameTotal > 1 &&
                (this.files.length <= 1 ||
                  this._multiFrameStackActive ||
                  this.isMultiFrameCine())
              const cur = multi
                ? liveFrame1()
                : (this.sliceIndex || 0) + 1
              // En scroll light no recorrer files[] (O(n) con stacks grandes).
              const max = multi
                ? frameTotal
                : Math.max(
                    this.sliceMax || 0,
                    this.files.length,
                    this.seriesTotalImages || 0,
                    (f && f.series && Number(f.series.totalImages)) || 0
                  )
              const counterText = `${cur}/${max}`
              imageCounter.innerHTML =
                `<div data-udv-frame-counter="1" id="image-counter-num-${this.props.index}" style="font-weight:600">${counterText}</div>` +
                `<div style="opacity:0.85;font-size:11px">${seriesInfo}</div>`
              imageCounter.style.display = 'block'
            }

            if (light || !this.image) {
              paintLight()
              this.syncCineScrollbar()
              return
            }

            const imageInfo = this.getCurrentImageInfo()
            if (!imageInfo) {
              paintLight()
              this.syncCineScrollbar()
              return
            }

            const seriesInfo = imageInfo.seriesDescription || 'Sin descripción'
            const frameTotal = resolveFrameTotal()
            const multi =
              frameTotal > 1 &&
              ((this.files && this.files.length) <= 1 ||
                this._multiFrameStackActive ||
                this.isMultiFrameCine())
            const totalKnown = resolveSeriesTotalImages(this.files)
            const displayMax = multi
              ? frameTotal
              : Math.max(
                  this.sliceMax || 0,
                  (this.files && this.files.length) || 0,
                  totalKnown,
                  this.seriesTotalImages || 0
                )
            const cur = multi ? liveFrame1() : this.sliceIndex + 1
            const counterText = multi
              ? `${cur}/${frameTotal}`
              : `${cur}/${displayMax}`
            imageCounter.innerHTML = `
                       <div style="font-size: 0.8em; line-height: 1.1; margin-bottom: 2px; color: #4caf50;">
                           ${seriesInfo}
                       </div>
                       <div data-udv-frame-counter="1" id="image-counter-num-${this.props.index}" style="font-size: 0.9em; font-weight: 600; color: #4caf50;">
                           ${counterText}
                       </div>
                   `
            imageCounter.style.cssText = `
                       display: block;
                       position: absolute;
                       top: 0;
                       right: 0;
                       text-shadow: 1px 1px 2px #000;
                       z-index: 10;
                       background-color: rgba(0, 0, 0, 0.6);
                       padding: 4px 6px;
                       border-radius: 4px;
                       max-width: 200px;
                       overflow: hidden;
                       text-overflow: ellipsis;
                       white-space: nowrap;
                       line-height: 1.1;
                       text-align: right;
                   `
        } catch (error) {
            console.warn('DicomViewer - updateImageInfoDisplay:', error)
        }
        this.syncCineScrollbar()
    }

    getCineScrollMax = () => {
      if (this.isMultiFrameCine && this.isMultiFrameCine()) {
        return Math.max(1, this.numberOfFrames || 1)
      }
      if (this.isMprGenerated && this.sliceMax > 1) {
        return this.sliceMax
      }
      return Math.max(
        1,
        this.sliceMax || 0,
        (this.files && this.files.length) || 0
      )
    }

    getCineScrollIndex = () => {
      if (this.isMultiFrameCine && this.isMultiFrameCine()) {
        if (typeof this.getMultiFrameIndex0 === 'function') {
          return this.getMultiFrameIndex0() || 0
        }
        return Math.max(0, (this.state.frame || 1) - 1)
      }
      return this.sliceIndex || 0
    }

    syncCineScrollbar = () => {
      const bar = this._cineScrollRef && this._cineScrollRef.current
      if (!bar || typeof bar.setSlice !== 'function') return
      bar.setSlice(this.getCineScrollIndex(), this.getCineScrollMax())
    }

    handleCineScrollbarActivate = () => {
      if (typeof this.props.onViewportActivate === 'function') {
        this.props.onViewportActivate(this.props.index)
      }
    }

    handleCineScrollbarSeek = (index) => {
      this.notifyViewportInteraction('scroll')
      if (this.isMprScrollRoute()) {
        this.seekMprLiveSlice(index)
        return
      }
      const max = this.getStackNavMax()
      const clamped = Math.max(
        0,
        Math.min(Math.max(0, max - 1), Math.round(Number(index) || 0))
      )
      // Slider: NO marcar wheel-live. Si no, smoothImageTransition solo mueve
      // el contador (needsLoad) y App cree que ya pintó → imagen congelada
      // (crítico al abrir desde IDB local, donde casi todos los frames son stub).
      if (!this.smoothImageTransition(clamped, { forceHydrate: true })) {
        try {
          this.displayImageFromFiles(clamped)
        } catch (e) {
          /* ignore */
        }
      }
      this.syncCineScrollbar()
      this.scheduleWheelUiSync()
      this.scheduleScrollSliceNotify()
      this.schedulePostScrollHydrate(clamped)
    }

    /**
     * Cambia de imagen en la misma serie de forma síncrona.
     * Evita rAF apilados (al scrollear rápido el último rAF viejo dejaba
     * el canvas en un corte y el contador en otro) y no usa caché por índice
     * (el soft-sync reordena el stack por InstanceNumber).
     * @param {number} newIndex
     * @param {{ forceHydrate?: boolean }} [opts] forceHydrate: no diferir IDB (slider)
     */
    smoothImageTransition = (newIndex, opts = {}) => {
      if (this.isMprGenerated) return false
      const element = this.dicomImage
      if (!element) return false

      // getEnabledElement lanza si disabled (clear / cambio de modo) — no es error
      let enabledElement = null
      try {
        enabledElement = cornerstone.getEnabledElement(element)
      } catch (e) {
        return false
      }
      if (!enabledElement) return false

      try {
        const resolved = this.resolveStackImage(newIndex)
        if (!resolved) return false

        // Antes de rehidratar async: guardar zoom/pan actual de la serie
        // En scroll en vivo se omite: el viewport no cambia y clonar en cada frame baja el FPS.
        const forceHydrate = !!(opts && opts.forceHydrate)
        const scrollLive = forceHydrate
          ? false
          : this.isStackScrollLive() || !!this._seriesLinkDriven
        if (!scrollLive) {
          try {
            const curVp = cornerstone.getViewport(element)
            const prevFiles = this.files === null ? this.props.files : this.files
            const prevFile =
              Array.isArray(prevFiles) && prevFiles[this.sliceIndex] != null
                ? prevFiles[this.sliceIndex]
                : resolved.fileData
            const seriesUID = this.getSeriesUidFrom(this.image, prevFile)
            if (seriesUID && curVp) {
              this.captureViewportToToolState(seriesUID, curVp)
            }
          } catch (e) {
            /* ignore */
          }
        }

        // Frame sin pixels en RAM:
        // - Scroll vivo: paint proxy del vecino cargado si hay; si no, solo contador.
        // - Quieto: hidratar y pintar.
        if (resolved.needsLoad || !resolved.image) {
          this.sliceIndex = newIndex
          try {
            this.updateImageInfoDisplay(scrollLive ? { light: true } : undefined)
          } catch (e) {
            /* ignore */
          }
          this.syncCineScrollbar()
          if (scrollLive) {
            // Proxy solo del vecino ±1: un proxy lejano se ve como “salto” de imagen.
            const near = this.findNearestRamStackIndex(newIndex, 1)
            if (near >= 0 && near !== newIndex) {
              const nearResolved = this.resolveStackImage(near)
              if (nearResolved && nearResolved.image) {
                try {
                  const image = nearResolved.image
                  const fileData = nearResolved.fileData || resolved.fileData
                  this.ensureImageRender(image, fileData)
                  let currentViewport = null
                  try {
                    currentViewport = cornerstone.getViewport(element)
                  } catch (eVp) {
                    currentViewport = null
                  }
                  const seriesUID = this.getSeriesUidFrom(image, fileData)
                  let preferred = this.buildPreferredViewStateForScroll(
                    seriesUID,
                    currentViewport,
                    false
                  )
                  const viewport = this.buildViewportPreservingView(
                    element,
                    image,
                    preferred,
                    fileData
                  )
                  // Plano del corte objetivo ANTES de displayImage (NEW_IMAGE → sync B)
                  if (resolved.fileData) {
                    registerTargetSlicePlaneOnDisplay(resolved.fileData, image)
                  }
                  cornerstone.displayImage(element, image, viewport)
                } catch (eProxy) {
                  /* ignore */
                }
              }
            } else {
              try {
                const enabledNow = cornerstone.getEnabledElement(element)
                const curImg = enabledNow && enabledNow.image
                if (curImg && resolved.fileData) {
                  registerTargetSlicePlaneOnDisplay(resolved.fileData, curImg)
                }
              } catch (ePlane) {
                /* ignore */
              }
            }
            this._pendingScrollHydrateIndex = newIndex
            this.schedulePostScrollHydrate(newIndex)
            this.scheduleScrollSliceNotify()
            return true
          }
          this.ensureFileImageThenDisplay(newIndex, resolved.fileData)
          this.schedulePreviewScrollPrefetch(newIndex)
          return true
        }

        const { fileData, image } = resolved

        this.applyStoredCalibrationSpacing(image, fileData)

        // Generación: ignora si ya se pidió un índice más nuevo
        const gen = ++this._displayGen

        try {
          let currentViewport = null
          try {
            currentViewport = cornerstone.getViewport(element)
          } catch (e) {
            currentViewport = null
          }

          const seriesUID = this.getSeriesUidFrom(image, fileData)
          this.applyStoredCalibrationSpacing(image, fileData)
          this.ensureImageRender(image, fileData)
          try {
            this.ensureLogicalWwwcInitialized(image, fileData)
          } catch (eInit) {
            /* ignore */
          }

          // PREVIEW: mantener filtro CSS actual (identidad salvo drag WWWC del usuario).
          // No re-derivar desde lógicos clínicos (carbón al cambiar de modo).
          if (this.shouldUseCssWwwc()) {
            try {
              const p = this._previewWwwc || {}
              const isIdentity =
                Math.abs((p.brightness != null ? p.brightness : 1) - 1) < 0.02 &&
                Math.abs((p.contrast != null ? p.contrast : 1) - 1) < 0.02 &&
                !p.invert
              if (isIdentity) {
                this.clearPreviewWwwcCss()
              } else {
                this.applyPreviewWwwcCss({ redraw: false })
              }
            } catch (e) {
              /* ignore */
            }
          } else {
            try {
              this.clearPreviewWwwcCss()
            } catch (eClr) {
              /* ignore */
            }
          }

          const prevFile =
            Array.isArray(this.files) && this.files[this.sliceIndex] != null
              ? this.files[this.sliceIndex]
              : null
          const prevSeriesUID = this.getSeriesUidFrom(this.image, prevFile)
          const seriesChanged =
            !!(
              seriesUID &&
              prevSeriesUID &&
              String(seriesUID) !== String(prevSeriesUID)
            )
          let preferred = this.buildPreferredViewStateForScroll(
            seriesUID,
            currentViewport,
            seriesChanged
          )
          // Frame SC/preview: conservar zoom/pan, no VOI clínico de serie
          if (preferred && this.isLocalWwwcFrame(image, fileData)) {
            preferred = {
              ...preferred,
              ww: null,
              wc: null,
              wwwcUserSet: false,
            }
          }

          const viewport = this.buildViewportPreservingView(
            element,
            image,
            preferred,
            fileData
          )
          if (
            !scrollLive ||
            (fileData && fileData.renderKind === 'preview')
          ) {
            try {
              stampSliceGeometry(fileData, image)
            } catch (e) {
              /* ignore */
            }
          }
          // Reference Lines: plano del corte (manifest en PREVIEW) también mid-scroll.
          try {
            registerFileImagePlane(fileData, image, { force: scrollLive })
          } catch (e) {
            /* ignore */
          }
          cornerstone.displayImage(element, image, viewport)

          if (gen !== this._displayGen) return true

          this.image = image
          this.filename = fileData.name
          const meta = this.getFileMeta(fileData)
          this.sopInstanceUid = this.safeImageString(
            image,
            'x00080018',
            meta.sopInstanceUID
          )
          this.PatientsName = this.safeImageString(
            image,
            'x00100010',
            meta.patientName
          )
          this.sliceIndex = newIndex
          this.isDicom = !this.isPreviewImage(image, fileData)

          this.updateImageInfoDisplay(scrollLive ? { light: true } : undefined)
          if (scrollLive) {
            // No prefetch mid-gesto: la carga local también pelea el main thread.
            this._pendingScrollHydrateIndex = newIndex
            this.scheduleScrollSliceNotify()
          } else {
            this.preloadAdjacentImages(newIndex)
            this.applyGspsForCurrentSop()
            this.schedulePreviewScrollPrefetch(newIndex)
          }
          return true
        } catch (error) {
          console.error('DicomViewer - Error in smooth transition:', error)
          return false
        }
      } catch (error) {
        console.error('DicomViewer - Error in smoothImageTransition:', error)
        return false
      }
    }

    displayImageFromFiles = (index) => {
        if (this.isMprGenerated) return
        const resolved = this.resolveStackImage(index)
        if (!resolved) {
            console.log('DicomViewer - No files/image data available for index:', index)
            return
        }
        // Persistir zoom/pan antes de rehidratación async o cambio de frame
        if (!this.isChangingSeries) {
          try {
            const el = this.dicomImage
            if (el) {
              const curVp = cornerstone.getViewport(el)
              const prevFiles = this.files === null ? this.props.files : this.files
              const prevFile =
                Array.isArray(prevFiles) && prevFiles[this.sliceIndex] != null
                  ? prevFiles[this.sliceIndex]
                  : resolved.fileData
              const seriesUID = this.getSeriesUidFrom(this.image, prevFile)
              if (seriesUID && curVp) {
                this.captureViewportToToolState(seriesUID, curVp)
              }
            }
          } catch (e) {
            /* ignore */
          }
        }
        if (resolved.needsLoad || !resolved.image) {
            this.ensureFileImageThenDisplay(index, resolved.fileData)
            return
        }
        const { fileData, image } = resolved
        this._displayGen += 1
        const gen = this._displayGen
        const changingSeriesAtStart = !!this.isChangingSeries

        // Verificar que el elemento del viewport esté disponible y tenga dimensiones válidas
        const element = document.getElementById(`viewer-${this.props.index}`)
        if (!element) {
            console.warn(`DicomViewer - Elemento viewport ${this.props.index} no encontrado`)
            return
        }

        const rect = element.getBoundingClientRect()
        if (rect.width === 0 || rect.height === 0) {
            console.warn(`DicomViewer - Elemento viewport ${this.props.index} no tiene dimensiones válidas: ${rect.width}x${rect.height}`)
            // Evitar bucle infinito: máximo ~2s de reintentos
            const retries = (this._zeroSizeRetries || 0) + 1
            this._zeroSizeRetries = retries
            if (retries > 20) {
              this._zeroSizeRetries = 0
              console.error('DicomViewer - viewport sin tamaño, abort reintentos')
              return
            }
            setTimeout(() => {
                if (gen === this._displayGen) {
                    this.displayImageFromFiles(index)
                }
            }, 100)
            return
        }
        this._zeroSizeRetries = 0

        const dicomElement = this.dicomImage
        if (!dicomElement) {
            console.log('DicomViewer - No dicom element available')
            return
        }

        try {
            const fileMetaEarly = this.getFileMeta(fileData)
            const isPreview = this.isPreviewImage(image, fileData)
            // PREVIEW móvil: disable+enable cuelga el hilo; solo re-enable si hace falta
            const wantForce =
              !!this.isChangingSeries || !!this._forceFullDisplay
            this._forceFullDisplay = false
            const forceFull = isPreview && (isMobile || isTablet) ? false : wantForce

            let isAlreadyEnabled = false
            if (!forceFull) {
              try {
                const enabledElement = cornerstone.getEnabledElement(dicomElement)
                isAlreadyEnabled = !!enabledElement
              } catch (error) {
                isAlreadyEnabled = false
              }
            }

            // Misma serie y no force: pintura síncrona (mantiene WW/WC/zoom) — también PREVIEW
            if (!changingSeriesAtStart && isAlreadyEnabled && this.image && image) {
              this.isChangingSeries = false
            }
            if (
              !forceFull &&
              !changingSeriesAtStart &&
              !this.isChangingSeries &&
              isAlreadyEnabled &&
              this.image &&
              image
            ) {
                try {
                    if (this.smoothImageTransition(index)) {
                        this.isChangingSeries = false
                        return
                    }
                } catch (e) {
                    // continuar con ruta completa
                }
            }

            // enable solo si no está active (evita cycle disable en PREVIEW)
            if (!isAlreadyEnabled || forceFull) {
                dicomElement.removeEventListener("cornerstonenewimage", this.onNewImage)
                dicomElement.removeEventListener("cornerstoneimagerendered", this.onImageRendered)
                dicomElement.removeEventListener("cornerstonetoolsmeasurementadded", this.onMeasurementAdded)
                dicomElement.removeEventListener("cornerstonetoolsmeasurementmodified", this.onMeasurementModified)
                dicomElement.removeEventListener("cornerstonetoolsmeasurementcompleted", this.onMeasurementCompleted)

                if (forceFull || isAlreadyEnabled) {
                  try {
                    cornerstone.disable(dicomElement)
                  } catch (error) {
                    /* ignore */
                  }
                }
                
                dicomElement.addEventListener("cornerstonenewimage", this.onNewImage)
                dicomElement.addEventListener("cornerstoneimagerendered", this.onImageRendered)
                dicomElement.addEventListener("cornerstonetoolsmeasurementadded", this.onMeasurementAdded)
                dicomElement.addEventListener("cornerstonetoolsmeasurementmodified", this.onMeasurementModified)
                dicomElement.addEventListener("cornerstonetoolsmeasurementcompleted", this.onMeasurementCompleted)
                
                try {
                  cornerstone.enable(dicomElement)
                } catch (e) {
                  // ya enabled
                }
                lockCornerstoneCanvasContext(dicomElement)
                const newEnabledElement = cornerstone.getEnabledElement(dicomElement)
                if (!newEnabledElement) {
                    throw new Error('Failed to enable element')
                }
                // Tras disable/enable se pierden instances; rehidratar ya (no esperar rAF)
                try {
                  this.ensureToolsRegistered({ activateScroll: true })
                } catch (eReg) {
                  /* ignore */
                }
            }

            if (gen !== this._displayGen) return

            const imageId = fileData.imageId
            this.imageId = imageId || (image && image.imageId) || this.imageId
            this.filename = fileData.name
            this.image = image
            const fileMeta = fileMetaEarly
            this.isDicom = !isPreview
            this.sliceIndex = index

            // Solo renderWebImage si getImage existe (DICOM color usa renderer nativo)
            const isWebRender = this.canUseWebImageRender(image)
            this.applyStoredCalibrationSpacing(image, fileData)
            this.ensureImageRender(image, fileData)
            
            this.PatientsName = this.safeImageString(
              image,
              'x00100010',
              fileMeta.patientName
            )
            this.sopInstanceUid =
              this.safeImageString(image, 'x00080018', fileMeta.sopInstanceUID) ||
              this.getSopInstanceUID()

            // Contador YA antes del paint (displayImage dispara onImageRendered síncrono)
            // NumberOfFrames primero para no pintar 1/1 en multiframe
            // PREVIEW web (webp/jpg): NUNCA armar stack ?frame= (rompe imageId https).
            let stack = { currentImageIdIndex: 0, imageIds: "" }
            this.numberOfFrames = 0
            if (!isPreview && image && image.data) {
              try {
                let nf = 0
                if (typeof image.data.intString === 'function') {
                  nf = parseInt(image.data.intString('x00280008'), 10) || 0
                }
                if (!(nf > 0) && typeof image.data.string === 'function') {
                  nf = parseInt(image.data.string('x00280008'), 10) || 0
                }
                if (!(nf > 0)) {
                  nf = resolveFileNumberOfFrames(fileData) || 0
                }
                this.numberOfFrames = nf > 0 ? nf : 0
              } catch (e) {
                this.numberOfFrames = resolveFileNumberOfFrames(fileData) || 0
              }
            } else if (!isPreview && fileData) {
              this.numberOfFrames = resolveFileNumberOfFrames(fileData) || 0
            }
            // Re-aplicar FPS cuando hay tags DICOM o descripción (p.ej. tras PREVIEW→DIAG)
            try {
              if (
                this.numberOfFrames > 1 ||
                (Array.isArray(this.files) && this.files.length > 1)
              ) {
                this.applyCineFpsFromStudy(image, fileData)
              }
            } catch (eFps2) {
              /* ignore */
            }
            if (this.numberOfFrames > 1) {
              try {
                stampNumberOfFramesOnFile(fileData, this.numberOfFrames)
                this.sliceMax = this.numberOfFrames
                this.seriesTotalImages = Math.max(
                  this.seriesTotalImages || 0,
                  this.numberOfFrames
                )
                if (this.numberOfFrames > 1) {
                  this.initMultiFrameProgress(fileData)
                }
              } catch (eStamp) {
                /* ignore */
              }
            }
            if (!isPreview && this.numberOfFrames > 0 && imageId) {
                let imageIds = []	
                for(var i=0; i < this.numberOfFrames; ++i) {
                    imageIds.push(imageId + "?frame="+i)
                }	
                stack.imageIds = imageIds
            }

            try {
              this.updateImageInfoDisplay({ light: isPreview || isWebRender })
            } catch (e) {
              /* ignore */
            }

            const seriesUID = this.getSeriesUidFrom(image, fileData)
            const diagnosticDicomOpen =
              changingSeriesAtStart &&
              !this.shouldUseCssWwwc() &&
              !isWebRender &&
              !!(image && image.data)
            // Inicializar / rehidratar WW/WC clínico de la serie
            try {
              this.ensureLogicalWwwcInitialized(image, fileData, {
                forceRefresh: diagnosticDicomOpen,
              })
            } catch (e) {
              /* ignore */
            }
            // En cambio de serie no reutilizar toolState viejo (puede invalidar WW/scale)
            // PREVIEW también reusa zoom/pan de toolState / viewport actual
            let preferredState = null
            if (!forceFull && !changingSeriesAtStart && !this.isChangingSeries) {
              if (seriesUID && this.toolState[seriesUID]) {
                preferredState = this.buildPreferredViewStateForScroll(
                  seriesUID,
                  null,
                  false
                )
              } else {
                try {
                  preferredState = this.cloneViewportViewState(
                    cornerstone.getViewport(dicomElement)
                  )
                  if (preferredState) {
                    preferredState.ww = null
                    preferredState.wc = null
                  }
                } catch (e) {
                  preferredState = null
                }
              }
            }
            if (
              preferredState &&
              this.isLocalWwwcFrame(image, fileData)
            ) {
              preferredState = {
                ...preferredState,
                ww: null,
                wc: null,
                wwwcUserSet: false,
              }
            }

            // Durante displayImage no hacer trabajo pesado en onImageRendered
            this._skipHeavyImageRendered = true
            try {
              try {
                stampSliceGeometry(fileData, image)
                registerFileImagePlane(fileData, image)
              } catch (ePlane) {
                /* ignore */
              }
              // Cambio de serie: limpiar filtro CSS residual ANTES del paint (DICOM o preview)
              if (changingSeriesAtStart) {
                try {
                  if (!this.shouldUseCssWwwc()) {
                    this.resetPreviewWwwcState()
                  } else {
                    this.clearPreviewWwwcCss()
                  }
                } catch (eCssClr) {
                  /* ignore */
                }
              }
              // VOI horneado listo antes del primer paint PREVIEW
              if (isWebRender && this.shouldUseCssWwwc()) {
                try {
                  this.applyPreviewLookIdentity({ clearInvert: true })
                } catch (e) {
                  /* ignore */
                }
              } else if (!isWebRender && !this.shouldUseCssWwwc()) {
                try {
                  this.resetPreviewWwwcState()
                  this.clearPreviewWwwcCss()
                } catch (eClr) {
                  /* ignore */
                }
              }
              if (preferredState) {
                  const viewport = this.buildViewportPreservingView(
                    dicomElement,
                    image,
                    preferredState,
                    fileData
                  )
                  cornerstone.displayImage(dicomElement, image, viewport)
              } else {
                  let viewport = cornerstone.getDefaultViewportForImage(dicomElement, image)
                  // VOI neutro en preview web; DICOM color conserva viewport WADO
                  if (isWebRender && viewport.voi) {
                    applyNeutralWebPreviewVoi(viewport)
                  } else if (
                    !diagnosticDicomOpen &&
                    !isWebRender &&
                    !this.isLocalWwwcFrame(image, fileData) &&
                    viewport.voi &&
                    this.toolState[seriesUID] &&
                    this.toolState[seriesUID].wwwcUserSet &&
                    this.toolState[seriesUID].ww != null
                  ) {
                    viewport.voi.windowWidth = this.toolState[seriesUID].ww
                    viewport.voi.windowCenter = this.toolState[seriesUID].wc
                  }
                  cornerstone.displayImage(dicomElement, image, viewport)
                  // fitToWindow en web-preview opcional (getDefaultViewport suele bastar)
                  if (!isWebRender) {
                    try {
                      if (typeof cornerstone.fitToWindow === 'function') {
                        cornerstone.fitToWindow(dicomElement)
                      }
                    } catch (e) {
                      /* ignore */
                    }
                  }
              }
            } finally {
              this._skipHeavyImageRendered = false
            }

            if (fileData.imageId) {
                this.imageCache.set(fileData.imageId, image)
            }

            // Nunca reasignar renderWebImage por .color; no 2º updateImage innecesario
            if (isWebRender) {
              this.ensureImageRender(image, fileData)
              // Tras paint: identidad si PREVIEW; limpiar CSS si DIAG residual
              try {
                if (this.shouldUseCssWwwc()) {
                  this.applyPreviewLookIdentity({ clearInvert: true })
                } else {
                  this.clearPreviewWwwcCss()
                  const el = dicomElement
                  const vp = cornerstone.getViewport(el)
                  if (vp) {
                    applyNeutralWebPreviewVoi(vp)
                    cornerstone.setViewport(el, vp)
                  }
                }
              } catch (e) {
                /* ignore */
              }
            } else {
              // Asegurar VOI clínico en canvas DICOM; en web nunca
              try {
                this.clearPreviewWwwcCss()
                if (this.canUseWebImageRender(image)) {
                  const el = dicomElement
                  const vp = cornerstone.getViewport(el)
                  if (vp) {
                    applyNeutralWebPreviewVoi(vp)
                    cornerstone.setViewport(el, vp)
                  }
                } else if (
                  this.isLocalWwwcFrame(image, fileData)
                ) {
                  // SC: dejar default del viewport; no aplicar VOI de serie
                  try {
                    const el = dicomElement
                    const vp = cornerstone.getViewport(el)
                    if (vp && vp.voi) {
                      this._logicalWwwc = {
                        ww: vp.voi.windowWidth,
                        wc: vp.voi.windowCenter,
                      }
                    }
                  } catch (eLoc) {
                    /* ignore */
                  }
                } else if (this.isSeriesWwwcUserSet(seriesUID)) {
                const { ww, wc } = this.getLogicalWwwc()
                const el = dicomElement
                const vp = cornerstone.getViewport(el)
                if (vp && vp.voi && ww != null && wc != null) {
                  if (
                    Math.abs(vp.voi.windowWidth - ww) > 0.5 ||
                    Math.abs(vp.voi.windowCenter - wc) > 0.5
                  ) {
                    vp.voi.windowWidth = ww
                    vp.voi.windowCenter = wc
                    cornerstone.setViewport(el, vp)
                  }
                }
                } else {
                  try {
                    const el = dicomElement
                    const vp = cornerstone.getViewport(el)
                    if (vp && vp.voi) {
                      this._logicalWwwc = {
                        ww: vp.voi.windowWidth,
                        wc: vp.voi.windowCenter,
                      }
                    }
                    cornerstone.updateImage(el)
                  } catch (eSync) {
                    /* ignore */
                  }
                }
              } catch (e) {
                /* ignore */
              }
            }

            // Limpiar residual CSS filter si el paint recreó el canvas
            if (this.shouldUseCssWwwc()) {
              try {
                this.applyPreviewWwwcCss({ redraw: false })
              } catch (e) {
                /* ignore */
              }
            } else {
              try {
                this.clearPreviewWwwcCss()
              } catch (eClr) {
                /* ignore */
              }
            }

            // MPR tags no aplica a preview web
            if (!isPreview) {
              this.mprPlanePosition()
            }

            // Contador otra vez por si setViewport/fit lo movió
            try {
              this.updateImageInfoDisplay({ light: isPreview || isWebRender })
            } catch (e) {
              /* ignore */
            }

            this.isChangingSeries = false

            // enableTool + Redux fuera del tick de paint (evita freeze con Edge toolbar)
            const finishAfterPaint = () => {
              if (gen !== this._displayGen) return
              const alreadyOpen =
                this.props.isOpen && this.props.isOpen[this.props.index]
              try {
                // Tras disable+enable (forceFull) hay que re-adjuntar tools al elemento.
                // Siempre asegurar registro; en PREVIEW móvil no re-dispatchear dcmEnableTool.
                if (isPreview && (isMobile || isTablet) && this.props.dcmEnableTool) {
                  this.ensureToolsRegistered({ activateScroll: true })
                } else {
                  this.enableTool()
                }
              } catch (e) {
                /* ignore */
              }
              try {
                if (!alreadyOpen) {
                  this.props.setIsOpenStore({index: this.props.index, value: true})
                }
                if (!isPreview) {
                  this.props.setActiveDcm(this)
                }
              } catch (e) {
                /* ignore */
              }
              if (!isPreview && this.numberOfFrames > 1) {
                // Diferir stack MF (XA 50–110 frames): pintar frame 0 primero.
                this._multiFrameStackActive = false
                this.refreshScrollFlags()
                const stackDeferred = {
                  currentImageIdIndex: 0,
                  imageIds: Array.isArray(stack.imageIds)
                    ? stack.imageIds.slice()
                    : stack.imageIds,
                }
                const elDeferred = element
                const runMf = () => {
                  try {
                    if (!this.dicomImage || this.dicomImage !== elDeferred) return
                    this.applyMultiFrameStackState(stackDeferred, elDeferred)
                  } catch (e) {
                    /* ignore */
                  }
                }
                if (typeof requestIdleCallback === 'function') {
                  requestIdleCallback(runMf, { timeout: 1500 })
                } else {
                  setTimeout(runMf, 250)
                }
              } else {
                this._multiFrameStackActive = false
                this.refreshScrollFlags()
                // Stack multi-SOP: reanudar cine tras paint (XA multi-frame lo hace en applyMultiFrameStackState)
                this.maybeResumeCineAfterSeriesChange()
              }
              // Re-assert contador (por si un re-render intermedio lo vació)
              try {
                this.updateImageInfoDisplay({ light: isPreview || isWebRender })
              } catch (e) {
                /* ignore */
              }
              this.applyGspsForCurrentSop()
            }
            // rAF + timeout: contador visible un frame antes de Redux/Edge re-render
            const finishDelay = isPreview && (isMobile || isTablet) ? 80 : 0
            if (typeof requestAnimationFrame === 'function') {
              requestAnimationFrame(() => {
                setTimeout(finishAfterPaint, finishDelay)
              })
            } else {
              setTimeout(finishAfterPaint, finishDelay || 32)
            }

            // Preload diferido (nulo en PREVIEW móvil)
            if (!isPreview || !(isMobile || isTablet)) {
              setTimeout(() => {
                try {
                  this.preloadAdjacentImages(index)
                } catch (e) { /* ignore */ }
              }, isPreview ? 200 : 50)
            }

        } catch (error) {
            console.error('DicomViewer - Error displaying image:', error)
            this.isChangingSeries = false
            this.image = null
            this.isDicom = false
            
            const el = this.dicomImage
            if (el) {
            try {
                cornerstone.disable(el)
            } catch (disableError) {
                console.warn('DicomViewer - Error disabling element after error:', disableError)
            }
            }
            
            this.setState({errorOnOpenImage: error.message || 'Error displaying image'})
        }
    }

    loadImageFromCanvas = (canvas) => {
      //console.log('loadImageFromCanvas, dcmViewer: ', this.props.index)

      const element = this.dicomImage
      element.addEventListener("cornerstonenewimage", this.onNewImage)
      element.addEventListener("cornerstoneimagerendered", this.onImageRendered)
      element.addEventListener("cornerstonetoolsmeasurementadded", this.onMeasurementAdded)
      element.addEventListener("cornerstonetoolsmeasurementmodified", this.onMeasurementModified)
      element.addEventListener("cornerstonetoolsmeasurementcompleted", this.onMeasurementCompleted)
      cornerstone.enable(element)
      lockCornerstoneCanvasContext(element)

      const imageId = cornerstoneFileImageLoader.fileManager.addCanvas(canvas)

      cornerstone.loadImage(imageId).then(image => {
        this.image = image

        this.isDicom = false

        cornerstone.displayImage(element, image)

        this.enableTool()

        this.props.setIsOpenStore({index: this.props.index, value: true})

      }, (e) => {
        console.log('error', e)
        this.setState({errorOnOpenImage: "This is not a valid canvas."})
      })
    }

    /**
     * Carga un plano MPR sintético sin apagar el viewport (evita flash negro).
     * @param {number} columns
     * @param {number} rows
     * @param {Int16Array|TypedArray} pixelData
     * @param {{ rowPixelSpacing?: number, columnPixelSpacing?: number }} [spacing]
     */
    loadImageFromCustomObject = (columns, rows, pixelData, spacing, planeOpts) => {
      const element = this.dicomImage
      if (!element) return

      try {
        cornerstone.getEnabledElement(element)
      } catch (e) {
        cornerstone.enable(element)
        lockCornerstoneCanvasContext(element)
      }

      element.addEventListener("cornerstonenewimage", this.onNewImage)
      element.addEventListener("cornerstoneimagerendered", this.onImageRendered)

      const origin = this.originImage || {}
      const rowSp = Number(
        spacing && spacing.rowPixelSpacing != null
          ? spacing.rowPixelSpacing
          : origin.rowPixelSpacing || 1
      )
      const colSp = Number(
        spacing && spacing.columnPixelSpacing != null
          ? spacing.columnPixelSpacing
          : origin.columnPixelSpacing || 1
      )

      const imageMeta = {
        minPixelValue: origin.minPixelValue != null ? origin.minPixelValue : -1024,
        maxPixelValue: origin.maxPixelValue != null ? origin.maxPixelValue : 3071,
        slope: origin.slope != null ? origin.slope : 1,
        intercept: origin.intercept != null ? origin.intercept : 0,
        windowCenter: origin.windowCenter,
        windowWidth: origin.windowWidth,
        color: !!origin.color,
        rgba: !!origin.rgba,
        invert: !!origin.invert,
        columnPixelSpacing: colSp > 0 ? colSp : 1,
        rowPixelSpacing: rowSp > 0 ? rowSp : 1,
        modalityLUT: origin.modalityLUT,
        voiLUT: origin.voiLUT,
        data: origin.data,
      }

      const customObj = {
        rows: rows,
        columns: columns,
        pixelData: pixelData,
        image: imageMeta,
      }

      const imageId = cornerstoneFileImageLoader.fileManager.addCustom(customObj)

      if (planeOpts && planeOpts.planeModule) {
        registerMprImagePlane(imageId, planeOpts.planeModule)
      } else if (planeOpts && planeOpts.kind === 'oblique') {
        const planeMod =
          planeOpts.planeModule ||
          buildMprObliqueImagePlaneModule({
            files: planeOpts.files || this.files,
            mprData: planeOpts.mprData || this.mprData,
            originImage: this.originImage || origin,
            columns,
            rows,
            u: planeOpts.u,
            v: planeOpts.v,
            n: planeOpts.n,
            center: planeOpts.center,
            spacingMm: planeOpts.spacingMm,
          })
        if (planeMod) registerMprImagePlane(imageId, planeMod)
      } else if (planeOpts && planeOpts.kind) {
        const planeMod = buildMprImagePlaneModule(planeOpts.kind, planeOpts.sliceIndex, {
          files: planeOpts.files || this.files,
          mprData: planeOpts.mprData || this.mprData,
          originImage: this.originImage || origin,
          columns,
          rows,
        })
        if (planeMod) registerMprImagePlane(imageId, planeMod)
      } else if (planeOpts && planeOpts.nativeAxial) {
        const plane = buildNativeImagePlaneModule(this.originImage || origin)
        if (plane) {
          plane.rows = rows
          plane.columns = columns
          registerMprImagePlane(imageId, plane)
        }
      }

      let prevViewport = null
      try {
        prevViewport = cornerstone.getViewport(element)
      } catch (e) {
        /* ignore */
      }

      this._mprLoadToken = (this._mprLoadToken || 0) + 1
      const token = this._mprLoadToken
      const spacingKey = `${colSp.toFixed(5)}:${rowSp.toFixed(5)}`
      const sameSize =
        this._mprLastCols === columns &&
        this._mprLastRows === rows &&
        this._mprLastSpacing === spacingKey &&
        this._mprFitted

      cornerstone.loadImage(imageId).then((image) => {
        if (token !== this._mprLoadToken) return // scroll más nuevo en curso
        // Asegurar spacing en el Image object (aspect ratio real)
        image.columnPixelSpacing = colSp > 0 ? colSp : 1
        image.rowPixelSpacing = rowSp > 0 ? rowSp : 1
        this.image = image
        this.isDicom = true

        const obliqueLoad =
          (planeOpts && planeOpts.kind === 'oblique') || !!this.props.mprObliqueActive

        let viewport
        if (sameSize && prevViewport && !obliqueLoad) {
          viewport = prevViewport
        } else if (sameSize && prevViewport && obliqueLoad) {
          // Oblicuo: conservar VOI/scale, NUNCA translation (evita estela / imagen fuera)
          viewport = Object.assign({}, prevViewport, {
            translation: { x: 0, y: 0 },
          })
          if (prevViewport.voi) {
            viewport.voi = {
              windowCenter: prevViewport.voi.windowCenter,
              windowWidth: prevViewport.voi.windowWidth,
            }
          }
        } else {
          viewport = cornerstone.getDefaultViewportForImage(element, image)
          if (prevViewport && prevViewport.voi) {
            viewport.voi.windowCenter = prevViewport.voi.windowCenter
            viewport.voi.windowWidth = prevViewport.voi.windowWidth
          }
          if (obliqueLoad) {
            viewport.translation = { x: 0, y: 0 }
          }
        }

        cornerstone.displayImage(element, image, viewport)

        if (obliqueLoad) {
          this.recenterObliqueViewport()
        }

        if (!sameSize) {
          const fit = () => {
            try {
              if (typeof cornerstone.fitToWindow === 'function') {
                cornerstone.fitToWindow(element)
              }
              if (obliqueLoad) this.recenterObliqueViewport()
            } catch (e) {
              /* ignore */
            }
          }
          fit()
          // Re-fit tras layout (canvas puede no tener tamaño aún)
          requestAnimationFrame(fit)
          this._mprFitted = true
          this._mprLastCols = columns
          this._mprLastRows = rows
          this._mprLastSpacing = spacingKey
        }

        this.updateImageInfoDisplay()
        this.props.setIsOpenStore({ index: this.props.index, value: true })
        this.scheduleScrollSliceNotify()
        if (obliqueLoad) {
          try {
            this.updateObliqueOverlay()
          } catch (eOv) {
            /* ignore */
          }
        }
      }, (e) => {
        if (token !== this._mprLoadToken) return
        console.log('error', e)
        this.setState({ errorOnOpenImage: 'This is not a valid canvas.' })
      })
    }

    /** Spacing para planos reconstruidos (mm/px) — define el aspect ratio en Cornerstone */
    mprPlaneSpacing = (kind) => {
      const origin = this.originImage || {}
      const md = this.mprData || {}
      const files = this.files === null ? this.props.files : this.files

      let rowSp = Number(
        md.rowPixelSpacing != null ? md.rowPixelSpacing : origin.rowPixelSpacing || 0
      )
      let colSp = Number(
        md.columnPixelSpacing != null
          ? md.columnPixelSpacing
          : origin.columnPixelSpacing || 0
      )
      if (!(rowSp > 0)) rowSp = 1
      if (!(colSp > 0)) colSp = 1

      let zSp = Number(md.zSpacing != null ? md.zSpacing : 0)
      if (!(zSp > 0) && files && files.length >= 2) {
        try {
          ensureMprStackGeometry(files, md)
          zSp = Number(md.zSpacing != null ? md.zSpacing : 0)
        } catch (e) {
          zSp = 0
        }
      }
      if (!(zSp > 0) && files && files.length >= 2) {
        try {
          zSp = Number(computeZSpacingForVolume(files))
        } catch (e) {
          zSp = 0
        }
      }
      if (!(zSp > 0)) zSp = colSp

      // YZ (sagittal from axial): horizontal=Y, vertical=Z
      if (kind === 'yz') {
        return { columnPixelSpacing: rowSp, rowPixelSpacing: zSp }
      }
      // XZ (coronal from axial): horizontal=X, vertical=Z
      if (kind === 'xz') {
        return { columnPixelSpacing: colSp, rowPixelSpacing: zSp }
      }
      return { columnPixelSpacing: colSp, rowPixelSpacing: rowSp }
    }

    loadImage = (localfile, url=undefined, fsItem=undefined) => {
      //console.log('loadImage, localfile: ', localfile)
      //console.log('loadImage, fsItem: ', fsItem)
      //console.log('loadImage, url: ', url)

      if (localfile === undefined && url === undefined && fsItem === undefined) return
      
      if (fsItem !== undefined) {
        this.fsItem = fsItem
      } else if (localfile !== undefined) {
        this.localfile = localfile
      } else {
        this.localurl = url
      }
 
      const element = this.dicomImage

      element.addEventListener("cornerstonenewimage", this.onNewImage)
      element.addEventListener("cornerstoneimagerendered", this.onImageRendered)
      element.addEventListener("cornerstonetoolsmeasurementadded", this.onMeasurementAdded)
      element.addEventListener("cornerstonetoolsmeasurementmodified", this.onMeasurementModified)
      element.addEventListener("cornerstonetoolsmeasurementcompleted", this.onMeasurementCompleted)

      let imageId = undefined

      cornerstone.enable(element)
      lockCornerstoneCanvasContext(element)

      if (localfile === undefined && isUrlImage(url)) { // check if it's a simple image [jpeg or png] from url
        //console.log('image: ', file)
        cornerstone.loadImage(url).then(image => {
          //console.log('loadImage, image from url: ', image)

          this.hideOpenUrlDlg()

          this.image = image

          this.isDicom = false

          cornerstone.displayImage(element, image)
          
          this.enableTool()

          this.props.setActiveDcm(this) // {image: this.image, element: this.dicomImage, isDicom: this.isDicom}
          this.props.isOpenStore(true)

        }, (e) => {
          console.log('error', e)
          this.setState({errorOnOpenImage: "This is not a valid JPG or PNG file."})
        })

      } else if ((localfile !== undefined && isFileImage(localfile)) || (fsItem !== undefined && isFsFileImage(fsItem))) { // otherwise try to open as local image file (JPEG, PNG) 
        if (fsItem !== undefined) {
          imageId = cornerstoneFileImageLoader.fileManager.addBuffer(fsItem.data)
        } else {
          imageId = cornerstoneFileImageLoader.fileManager.add(localfile)
        }
        cornerstone.loadImage(imageId).then(image => {
          console.log('loadImage, image from local: ', image)

          this.image = image
          this.isDicom = false
          this.PatientsName = ''

          cornerstone.displayImage(element, image)
          
          this.enableTool()

          this.props.setActiveDcm(this) // {image: this.image, element: this.dicomImage, isDicom: this.isDicom}
          //this.props.isOpenStore(true)
          this.props.setIsOpenStore({index: this.props.index, value: true})

        }, (e) => {
          console.log('error', e)
          this.setState({errorOnOpenImage: "This is not a valid JPG or PNG file."})
        })

      } else { // otherwise try to open as Dicom file
        //let size = 0
        if (fsItem !== undefined) {
          imageId = cornerstoneWADOImageLoader.wadouri.fileManager.addBuffer(fsItem.data)
          this.filename = fsItem.name
          //size = fsItem.size
        } else if (localfile !== undefined) {
          imageId = cornerstoneWADOImageLoader.wadouri.fileManager.add(localfile)
          this.filename = localfile.name
          //size = localfile.size
        } else { // it's a web dicom image
          imageId = "wadouri:"+url
        }
  
        //console.log('loadImage, imageId: ', imageId)

        cornerstone.loadAndCacheImage(imageId).then(image => {
          //console.log('loadImage, image: ', image)
          //let pixelDataElement = image.data.elements.x7fe00010
          //console.log('loadImage, pixelDataElement: ', pixelDataElement)
          //console.log('loadImage, getPixelData: ', image.getPixelData())
          
          this.hideOpenUrlDlg()

          this.image = image
          this.imageId = imageId

          this.isDicom = true

          this.PatientsName = image.data.string('x00100010')
          this.sopInstanceUid = this.getSopInstanceUID()

          let stack = { currentImageIdIndex: 0, imageIds: "" }
          try {
            let nf = 0
            if (image.data && typeof image.data.intString === 'function') {
              nf = parseInt(image.data.intString('x00280008'), 10) || 0
            }
            if (!(nf > 0) && image.data && typeof image.data.string === 'function') {
              nf = parseInt(image.data.string('x00280008'), 10) || 0
            }
            this.numberOfFrames = nf > 0 ? nf : 0
          } catch (e) {
            this.numberOfFrames = 0
          }
          if (this.numberOfFrames > 0) {
            let imageIds = []	
            for(var i=0; i < this.numberOfFrames; ++i) {
              imageIds.push(imageId + "?frame="+i)
            }	
            stack.imageIds = imageIds
          }

          cornerstone.displayImage(element, image)
          //cornerstoneTools.mouseInput.enable(element);
          //cornerstoneTools.mouseWheelInput.enable(element);

          this.enableTool()

          if (this.numberOfFrames > 1) {
            this.applyMultiFrameStackState(stack, element)
            try {
              this.updateImageInfoDisplay()
            } catch (e) {
              /* ignore */
            }
          } else {
            this._multiFrameStackActive = false
            this.refreshScrollFlags()
          }
  
          // Load the possible measurements from DB and save in the store 
          db.measurement.where('sopinstanceuid').equals(this.sopInstanceUid).each(measure => {
            //console.log('load measure from db: ', measure)
            //this.props.measurementStore(measure)
            this.measurementSave(measure)
            cornerstoneTools.addToolState(element, measure.tool, measure.data)
            this.runTool(measure.tool)
            cornerstone.updateImage(element)
            cornerstoneTools.setToolEnabled(measure.tool)
          }).then(() => {
            //console.log('this.measurements: ', this.measurements)
            this.props.setActiveMeasurements(this.measurements)
            this.props.setActiveDcm(this) // {name: this.filename, size: size, image: this.image, element: this.dicomImage, isDicom: this.isDicom}
            this.props.setIsOpenStore({index: this.props.index, value: true})
            this.applyGspsForCurrentSop()
          })       

        }, (e) => {
          console.log('error', e)   
          this.hideOpenUrlDlg()      
          //console.log('toString: ', e.error.toString())
          const error = e.error.toString()
          if (error === '[object XMLHttpRequest]') {
            this.setState({errorOnCors: true})
          } else {
            const pos = error.indexOf(":")
            this.setState({errorOnOpenImage: pos < 0 ? e.error : error.substring(pos+1)})            
          } 
        })
      }
    }
  
    enableTool = (toolName, mouseButtonNumber) => {
      // Registrar tools SIEMPRE antes de activar (path PREVIEW a menudo las omite).
      this.ensureToolsRegistered()

      try {
        if (this.dicomImage) {
          cornerstone.getEnabledElement(this.dicomImage)
        }
      } catch (error) {
        // Elemento aún no enable: las tools quedan en global; se adjuntan en el próximo paint.
        if (!this.props.dcmEnableTool) {
          try {
            this.props.setDcmEnableToolStore(true)
          } catch (e) {
            /* ignore */
          }
        }
        return
      }

      if (!this.props.dcmEnableTool) {
        this.props.setDcmEnableToolStore(true)
      }
    }

    /**
     * Catálogo de tools de medición/navegación (cornerstone-tools v4).
     * @returns {Array<[string, function]>}
     */
    getMeasurementToolCatalog = () => {
      const pick = (exportName) => this.resolveToolClass(exportName)
      return [
        ['Length', pick('LengthTool')],
        ['Pan', pick('PanTool')],
        ['Magnify', pick('MagnifyTool')],
        ['Angle', pick('AngleTool')],
        ['CobbAngle', pick('CobbAngleTool')],
        ['Wwwc', pick('WwwcTool')],
        ['Zoom', pick('ZoomTool')],
        ['ZoomTouchPinch', pick('ZoomTouchPinchTool')],
        ['Probe', pick('ProbeTool')],
        ['EllipticalRoi', pick('EllipticalRoiTool')],
        ['RectangleRoi', pick('RectangleRoiTool')],
        ['FreehandRoi', pick('FreehandRoiTool')],
        ['StackScrollMouseWheel', pick('StackScrollMouseWheelTool')],
      ]
    }

    /**
     * True solo si la tool está en state.globalTools (requerido por setToolMode).
     * NO usar state.tools (instancias por elemento): puede dar false positive.
     * @param {string} toolName
     */
    isToolRegisteredGlobally = (toolName) => {
      try {
        const gt =
          cornerstoneTools.store &&
          cornerstoneTools.store.state &&
          cornerstoneTools.store.state.globalTools
        return !!(gt && gt[toolName])
      } catch (e) {
        return false
      }
    }

    /**
     * Resuelve clase Tool (named export o default interop CRA).
     * @param {string} exportName p.ej. 'LengthTool'
     */
    resolveToolClass = (exportName) => {
      const ct = cornerstoneTools
      if (ct && ct[exportName]) return ct[exportName]
      if (ct && ct.default && ct.default[exportName]) return ct.default[exportName]
      return null
    }

    /**
     * Tool ya adjunta al elemento.
     * @param {HTMLElement} el
     * @param {string} toolName
     */
    getToolOnElement = (el, toolName) => {
      if (!el || !toolName) return null
      try {
        if (typeof cornerstoneTools.getToolForElement === 'function') {
          return cornerstoneTools.getToolForElement(el, toolName) || null
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const tools =
          (cornerstoneTools.store &&
            cornerstoneTools.store.state &&
            cornerstoneTools.store.state.tools) ||
          []
        for (let i = 0; i < tools.length; i++) {
          const t = tools[i]
          if (t && t.element === el && t.name === toolName) return t
        }
      } catch (e2) {
        /* ignore */
      }
      return null
    }

    /**
     * Registra tools globalmente + addToolForElement en este viewport.
     * Crítico tras forceFull (disable+enable) o path PREVIEW sin tools.
     * @param {{ activateScroll?: boolean }} [opts]
     * @returns {boolean}
     */
    ensureToolsRegistered = (opts = {}) => {
      const activateScroll = opts.activateScroll !== false
      // Asegurar sync global (setToolMode / re-enable depende de esto)
      try {
        const mod =
          typeof cornerstoneTools.getModule === 'function'
            ? cornerstoneTools.getModule('globalConfiguration')
            : null
        if (mod && mod.configuration && !mod.configuration.globalToolSyncEnabled) {
          mod.configuration.globalToolSyncEnabled = true
        }
      } catch (e) {
        /* ignore */
      }

      const catalog = this.getMeasurementToolCatalog()

      catalog.forEach(([name, ToolClass]) => {
        let Cls = ToolClass
        if (!Cls) {
          // Fallback por nombre de export
          const exportMap = {
            Length: 'LengthTool',
            Pan: 'PanTool',
            Magnify: 'MagnifyTool',
            Angle: 'AngleTool',
            CobbAngle: 'CobbAngleTool',
            Wwwc: 'WwwcTool',
            Zoom: 'ZoomTool',
            ZoomTouchPinch: 'ZoomTouchPinchTool',
            Probe: 'ProbeTool',
            EllipticalRoi: 'EllipticalRoiTool',
            RectangleRoi: 'RectangleRoiTool',
            FreehandRoi: 'FreehandRoiTool',
            StackScrollMouseWheel: 'StackScrollMouseWheelTool',
          }
          Cls = this.resolveToolClass(exportMap[name] || `${name}Tool`)
        }
        if (!Cls) {
          console.warn('DicomViewer - class tool ausente:', name)
          return
        }
        if (!this.isToolRegisteredGlobally(name)) {
          try {
            if (name === 'Magnify') {
              const compact = isMobile || isTablet || window.innerWidth < 1024
              cornerstoneTools.addTool(Cls, {
                configuration: {
                  magnifySize: compact ? 140 : 280,
                  magnificationLevel: 2,
                },
              })
            } else {
              cornerstoneTools.addTool(Cls)
            }
          } catch (error) {
            try {
              cornerstoneTools.addTool(Cls, { name })
            } catch (e2) {
              console.warn('DicomViewer - addTool failed', name, e2)
            }
          }
        }
      })

      DicomViewer._globalToolsAdded = true

      const el =
        this.dicomImage || document.getElementById(`viewer-${this.props.index}`)
      if (!el) return false
      try {
        cornerstone.getEnabledElement(el)
      } catch (e) {
        return false
      }

      // Adjuntar al elemento: post-disable+enable las instances se pierden si global vacío
      catalog.forEach(([name, ToolClass]) => {
        let Cls = ToolClass
        if (!Cls) {
          Cls = this.resolveToolClass(`${name}Tool`)
        }
        if (!Cls) return
        if (this.getToolOnElement(el, name)) return
        try {
          if (typeof cornerstoneTools.addToolForElement === 'function') {
            cornerstoneTools.addToolForElement(el, Cls)
          } else {
            cornerstoneTools.addTool(Cls)
          }
        } catch (e) {
          // ya en elemento / race
        }
      })

      if (activateScroll && this.isToolRegisteredGlobally('StackScrollMouseWheel')) {
        try {
          cornerstoneTools.setToolEnabled('StackScrollMouseWheel')
          cornerstoneTools.setToolActive('StackScrollMouseWheel', {})
        } catch (e) {
          /* ignore */
        }
      }

      return true
    }

    /** Opciones de puntero: mouse + touch (PWA/móvil). Sin isTouchActive Magnify no arranca. */
    pointerToolOptions = () => ({
      mouseButtonMask: 1,
      isTouchActive: true,
      isMouseActive: true,
    })

    bindMagnifyPointers = () => {
      const el = this.dicomImage
      if (!el || this._magnifyBound) return
      this._magnifyBound = true
      this._magnifyMode = true
      el.addEventListener('pointerdown', this.onMagnifyPointerDown, { capture: true })
    }

    unbindMagnifyPointers = () => {
      this._magnifyMode = false
      this.endMagnifySession()
      const el = this.dicomImage
      if (this._magnifyBound && el) {
        el.removeEventListener('pointerdown', this.onMagnifyPointerDown, { capture: true })
      }
      this._magnifyBound = false
      hideMagnifyLoupe()
    }

    exitMagnifyToNoTool = () => {
      this._suppressFitToggleUntil = Date.now() + 450
      this.unbindMagnifyPointers()
      try {
        this.props.toolStore('notool')
      } catch (e) {
        /* ignore */
      }
      try {
        this.runTool('notool')
      } catch (e2) {
        /* ignore */
      }
    }

    onMagnifyPointerDown = (event) => {
      if (!this._magnifyMode && this.props.tool !== 'Magnify') return
      if (event.pointerType === 'mouse' && event.button !== 0) return
      try {
        event.preventDefault()
        event.stopPropagation()
      } catch (e) {
        /* ignore */
      }

      const now = Date.now()
      const dx = event.clientX - (this._magnifyLastX || 0)
      const dy = event.clientY - (this._magnifyLastY || 0)
      const dist = Math.sqrt(dx * dx + dy * dy)
      if (now - (this._magnifyLastTs || 0) < 320 && dist < 44) {
        this._magnifyLastTs = 0
        this.exitMagnifyToNoTool()
        return
      }
      this._magnifyLastTs = now
      this._magnifyLastX = event.clientX
      this._magnifyLastY = event.clientY

      this._magnifyActive = true
      this._magnifyPointerType = event.pointerType || 'mouse'
      paintMagnifyLoupe(this.dicomImage, event.clientX, event.clientY, {
        pointerType: this._magnifyPointerType,
      })
      window.addEventListener('pointermove', this.onMagnifyPointerMove, true)
      window.addEventListener('pointerup', this.onMagnifyPointerUp, true)
      window.addEventListener('pointercancel', this.onMagnifyPointerUp, true)
    }

    onMagnifyPointerMove = (event) => {
      if (!this._magnifyActive) return
      try {
        event.preventDefault()
      } catch (e) {
        /* ignore */
      }
      paintMagnifyLoupe(this.dicomImage, event.clientX, event.clientY, {
        pointerType: event.pointerType || this._magnifyPointerType || 'mouse',
      })
    }

    onMagnifyPointerUp = () => {
      this.endMagnifySession()
    }

    endMagnifySession = () => {
      this._magnifyActive = false
      window.removeEventListener('pointermove', this.onMagnifyPointerMove, true)
      window.removeEventListener('pointerup', this.onMagnifyPointerUp, true)
      window.removeEventListener('pointercancel', this.onMagnifyPointerUp, true)
      hideMagnifyLoupe()
    }

    /**
     * Activa una tool de medición con registro previo garantizado.
     * @param {string} toolName
     * @param {object} [options]
     */
    activateMeasurementTool = (toolName, options) => {
      // No auto-activar stack scroll en medio del setup (evita pisa de bindings)
      this.ensureToolsRegistered({ activateScroll: false })

      const opts = options || this.pointerToolOptions()

      // Pasivar otras tools de puntero sin ir a setToolDisabled (rompe registro)
      const passivate = [
        'Length',
        'Pan',
        'Magnify',
        'Angle',
        'CobbAngle',
        'RectangleRoi',
        'Wwwc',
        'ZoomTouchPinch',
        'Probe',
        'EllipticalRoi',
        'FreehandRoi',
        'Zoom',
      ]
      const el = this.dicomImage
      passivate.forEach((name) => {
        if (name === toolName) return
        if (!this.isToolRegisteredGlobally(name) && !this.getToolOnElement(el, name)) {
          return
        }
        try {
          if (el && typeof cornerstoneTools.setToolPassiveForElement === 'function') {
            cornerstoneTools.setToolPassiveForElement(el, name)
          }
        } catch (e) {
          /* ignore */
        }
        try {
          if (this.isToolRegisteredGlobally(name)) {
            cornerstoneTools.setToolPassive(name)
          }
        } catch (e2) {
          /* ignore */
        }
      })

      if (toolName === 'StackScrollMouseWheel') {
        try {
          if (el && typeof cornerstoneTools.setToolActiveForElement === 'function') {
            cornerstoneTools.setToolActiveForElement(el, toolName, {})
          }
          cornerstoneTools.setToolEnabled(toolName)
          cornerstoneTools.setToolActive(toolName, {})
        } catch (e) {
          console.warn('activateMeasurementTool StackScroll', e)
        }
        return
      }

      // Re-intentar adjunto si falta en element
      if (el && !this.getToolOnElement(el, toolName)) {
        this.ensureToolsRegistered({ activateScroll: false })
      }

      try {
        if (el && typeof cornerstoneTools.setToolEnabledForElement === 'function') {
          cornerstoneTools.setToolEnabledForElement(el, toolName)
        } else {
          cornerstoneTools.setToolEnabled(toolName)
        }
      } catch (e) {
        try {
          cornerstoneTools.setToolEnabled(toolName)
        } catch (e2) {
          /* ignore */
        }
      }

      let activated = false
      try {
        if (el && typeof cornerstoneTools.setToolActiveForElement === 'function') {
          cornerstoneTools.setToolActiveForElement(el, toolName, opts)
          activated = !!this.getToolOnElement(el, toolName)
        }
      } catch (e) {
        /* fallback global */
      }

      if (!activated || this.isToolRegisteredGlobally(toolName)) {
        try {
          cornerstoneTools.setToolActive(toolName, opts)
        } catch (e) {
          console.warn('setToolActive', toolName, e)
        }
      }

      // Wheel scroll siempre disponible junto a medición
      try {
        if (this.isToolRegisteredGlobally('StackScrollMouseWheel')) {
          cornerstoneTools.setToolActive('StackScrollMouseWheel', {})
        } else if (el) {
          cornerstoneTools.setToolActiveForElement(
            el,
            'StackScrollMouseWheel',
            {}
          )
        }
      } catch (e) {
        /* ignore */
      }

      try {
        if (!this.props.dcmEnableTool) {
          this.props.setDcmEnableToolStore(true)
        }
      } catch (e) {
        /* ignore */
      }
      try {
        this.props.toolStore(toolName)
      } catch (e) {
        /* ignore */
      }
    }
  
  // helper function used by the tool button handlers to disable the active tool
  // before making a new tool active
  disableAllTools = () => {
    // No bajar dcmEnableTool: evita re-init pesado en cada openimage/slice.
    // Solo pasar a pasivo las tools de medición/navegación editables.
    // Primero asegurar registro para no spamear "not available globally".
    try {
      this.ensureToolsRegistered()
    } catch (e) {
      /* ignore */
    }
    const toolsToDisable = [
      'Length', 'Pan', 'Magnify', 'Angle', 'CobbAngle', 'RectangleRoi', 
      'Wwwc', 'ZoomTouchPinch', 'Probe', 'EllipticalRoi', 
      'FreehandRoi', 'Zoom'
    ]
    
    toolsToDisable.forEach(toolName => {
      if (!this.isToolRegisteredGlobally(toolName)) return
      try {
        const el = this.dicomImage
        if (el && typeof cornerstoneTools.setToolPassiveForElement === 'function') {
          try {
            cornerstoneTools.setToolPassiveForElement(el, toolName)
          } catch (e) {
            /* ignore */
          }
        }
        cornerstoneTools.setToolPassive(toolName)
      } catch (error) {
        // tool no registrada
      }
    })
    
    try {
      if (this.isToolRegisteredGlobally('StackScrollMouseWheel')) {
        cornerstoneTools.setToolEnabled('StackScrollMouseWheel')
        cornerstoneTools.setToolActive('StackScrollMouseWheel', { })
      }
    } catch (error) {
      // ignore
    }
    
    try {
      if (
        this.props.visibleReferenceLines &&
        this.isToolRegisteredGlobally('ReferenceLines')
      ) {
        const sync =
          ReferenceLinesManager && ReferenceLinesManager.synchronizer
            ? ReferenceLinesManager.synchronizer
            : null
        if (sync) {
          cornerstoneTools.setToolEnabled('ReferenceLines', {
            synchronizationContext: sync,
          })
        } else {
          cornerstoneTools.setToolEnabled('ReferenceLines')
        }
      }
    } catch (error) {
      // ignore
    }
  }

    // Método para limpiar el canvas manualmente
    clearCanvas = () => {
      if (this.dicomImage) {
        try {
          const canvas = this.dicomImage.querySelector('.cornerstone-canvas')
          if (canvas) {
            const ctx = canvas.getContext('2d')
            ctx.clearRect(0, 0, canvas.width, canvas.height)
            console.log('DicomViewer - Canvas limpiado')
          }
        } catch (error) {
          console.warn('DicomViewer - Error limpiando canvas:', error)
        }
      }
    }
  
    runTool = (toolName, opt) => {
      if (toolName !== 'Magnify') {
        this.unbindMagnifyPointers()
      }
      // Soft expand de stack no debe cortar el cine en reproducción
      const softSetfiles = toolName === 'setfiles' && opt && !Array.isArray(opt) && opt.soft
      if (this.state.inPlay && !softSetfiles && toolName !== 'cine') {
        this.runCinePlayer('pause')
      }

      // openimage/setslice/setfiles: no desactivar tools (evita trabajo síncrono masivo y re-init)
      // Soft setfiles: igual
      const skipDisable =
        softSetfiles ||
        toolName === 'openimage' ||
        toolName === 'setslice' ||
        toolName === 'setfiles' ||
        toolName === 'clear' ||
        toolName === 'cine' ||
        toolName === 'Invert' ||
        toolName === 'saveas' ||
        toolName === 'share'
      if (!skipDisable) {
        this.disableAllTools()
      }

      switch (toolName) {
        case 'setfiles': {
          // Soporta array clásico o { files, soft, keepKey, remappedIndex }
          const soft = softSetfiles
          const nextFiles = Array.isArray(opt) ? opt : ((opt && opt.files) || [])
          const prevIndex = this.sliceIndex || 0
          const prevFile = Array.isArray(this.files) ? this.files[prevIndex] : null
          const prevImageId = prevFile && prevFile.imageId
          const prevInstance =
            prevFile && prevFile.instanceNumber != null ? Number(prevFile.instanceNumber) : null
          const keepKey = (opt && !Array.isArray(opt) && opt.keepKey) || null
          const prevFiles = Array.isArray(this.files) ? this.files : []

          // Soft solo crece/reordena un stack ya abierto; no inyectar en viewport vacío
          const hadStack =
            prevFiles.length > 0 || !!this.image || !!prevImageId
          if (soft && !hadStack) {
            break
          }

          // Append puro: creció y extremos iguales (evita every() O(n) en stacks grandes)
          const pureAppend =
            soft &&
            nextFiles.length > prevFiles.length &&
            prevFiles.length > 0 &&
            prevFiles[0] &&
            nextFiles[0] &&
            prevFiles[0].imageId &&
            prevFiles[0].imageId === nextFiles[0].imageId &&
            prevFiles[prevFiles.length - 1] &&
            nextFiles[prevFiles.length - 1] &&
            prevFiles[prevFiles.length - 1].imageId ===
              nextFiles[prevFiles.length - 1].imageId

          this.files = nextFiles
          this._scrollStackRef = null
          this._scrollStackUid = null
          this._scrollStackLen = 0
          const prevLen = prevFiles.length
          const nextLen = nextFiles.length
          // Multi-frame: sliceMax = frames mientras no se reemplace al detectar SOP nuevo
          // MPR generado: no pisar sliceMax (cols/rows del plano reconstruido)
          if (this.isMprGenerated && this.sliceMax > 1) {
            // keep sliceMax
          } else if (this.numberOfFrames > 1 && this._multiFrameStackActive && nextFiles.length <= 1) {
            this.sliceMax = this.numberOfFrames
          } else {
            this.sliceMax = this.files.length
          }
          this.refreshScrollFlags()
          if (this.isMprGenerated && this.sliceMax > 1) {
            this.shouldScroll = true
          }

          if (!soft) {
            try {
              this.clearDsa({ redraw: false })
            } catch (eDsa) {
              /* ignore */
            }
            this._scrollSeriesUid = null
            // No bajar isChangingSeries aquí: openimage/display lo baja al pintar
            this._cineUserClosed = false
            this._cineFpsUserSet = false
            this._cineFpsSource = 'default'
            this._multiFrameStackActive = false
            // Conservar NumberOfFrames del monofile si ya venía en metadata
            const preservedFrames =
              nextFiles.length === 1
                ? resolveFileNumberOfFrames(nextFiles[0])
                : 0
            this.numberOfFrames = preservedFrames > 1 ? preservedFrames : 1
            if (preservedFrames > 1) {
              this.sliceMax = preservedFrames
            }
            // FPS del estudio (desc "15 fps" / Frame Time) antes del paint
            try {
              this.applyCineFpsFromStudy(null, nextFiles[0] || null)
            } catch (eFps) {
              /* ignore */
            }
            let hasAnyId = false
            for (let i = 0; i < this.files.length; i++) {
              if (this.files[i] && this.files[i].imageId) {
                hasAnyId = true
                break
              }
            }
            if (this.files.length === 0 || !hasAnyId) {
              console.warn('DicomViewer - setfiles: stack sin imageId')
            }
            // PREVIEW móvil: no forceFull (disable+enable cuelga)
            const previewMobile =
              (isMobile || isTablet) &&
              this.files.some(
                (f) =>
                  f &&
                  (f.renderKind === 'preview' ||
                    (f.image && !f.image.data) ||
                    (f.previewUrl && f.renderKind !== 'dicom'))
              )
            this._forceFullDisplay = !previewMobile
            // toolStore('notool') re-render Edge: diferir / omitir en preview móvil
            if (this.props.tool !== 'notool') {
              if (previewMobile) {
                setTimeout(() => {
                  try {
                    if (this.props.tool !== 'notool') this.props.toolStore('notool')
                  } catch (e) {
                    /* ignore */
                  }
                }, 100)
              } else {
                this.props.toolStore('notool')
              }
            }
            // Índice inicial opcional (p. ej. restore de modo) — no dejar en 0 si llega remappedIndex
            if (
              opt &&
              !Array.isArray(opt) &&
              opt.remappedIndex != null &&
              opt.remappedIndex >= 0
            ) {
              this.sliceIndex = Math.min(
                opt.remappedIndex,
                Math.max(0, this.sliceMax - 1)
              )
            }
          } else {
            // Soft: remapear slice a la misma imagen lógica
            // Preferir remappedIndex (App) sobre pureAppend (que deja index viejo)
            let newIndex = -1
            if (opt && opt.remappedIndex != null && opt.remappedIndex >= 0) {
              newIndex = Math.min(opt.remappedIndex, Math.max(0, this.sliceMax - 1))
            }

            // pureAppend sin remappedIndex: solo creció; mantener índice actual
            if (newIndex < 0 && pureAppend) {
              newIndex = Math.min(prevIndex, Math.max(0, this.sliceMax - 1))
              if (typeof this.updateImageInfoDisplay === 'function') {
                try {
                  this.updateImageInfoDisplay({ light: true })
                } catch (err) {
                  // ignore
                }
              }
              this.sliceIndex = newIndex
              this.afterStackBufferGrew(prevLen, nextLen)
              break
            }

            const key = keepKey || (prevImageId ? `id:${prevImageId}` : null)
            if (newIndex < 0 && key) {
              const ks = String(key)
              if (ks.startsWith('id:')) {
                const id = ks.slice(3)
                newIndex = this.files.findIndex((f) => f && f.imageId === id)
              } else if (ks.startsWith('sop:')) {
                const sop = ks.slice(4)
                newIndex = this.files.findIndex(
                  (f) => f && f.sopInstanceUID && String(f.sopInstanceUID) === sop
                )
              } else if (ks.startsWith('in:')) {
                const n = Number(ks.slice(3))
                newIndex = this.files.findIndex(
                  (f) => f && Number(f.instanceNumber) === n
                )
              }
            }
            if (newIndex < 0 && prevImageId) {
              newIndex = this.files.findIndex((f) => f && f.imageId === prevImageId)
            }
            if (newIndex < 0 && prevInstance != null) {
              newIndex = this.files.findIndex(
                (f) => f && Number(f.instanceNumber) === prevInstance
              )
            }
            // SOP del frame previo aunque keepKey no venga
            if (
              newIndex < 0 &&
              prevFile &&
              prevFile.sopInstanceUID
            ) {
              const sop = String(prevFile.sopInstanceUID)
              newIndex = this.files.findIndex(
                (f) => f && f.sopInstanceUID && String(f.sopInstanceUID) === sop
              )
            }
            if (newIndex < 0) {
              newIndex = Math.min(prevIndex, Math.max(0, this.sliceMax - 1))
            }

            // Reorden real: la caché por posición deja de ser fiable
            if (!pureAppend) {
              this.imageCache.clear()
              this._imageCacheOrder = []
              this.preloadQueue = []
            }
            const prevSlice = this.sliceIndex
            this.sliceIndex = newIndex

            const nextFile = this.files[newIndex]
            const nextId = nextFile && nextFile.imageId
            // Re-paint si cambió imageId o el índice lógico (restore modo / reorder)
            // Durante cine en play no repintar el mismo frame (evita pelear con el tick)
            const shouldRepaint =
              ((prevImageId && nextId && nextId !== prevImageId) ||
                prevSlice !== newIndex) &&
              !(this.state.inPlay && prevSlice === newIndex && prevImageId === nextId)
            if (shouldRepaint && !this.isMprGenerated) {
              try {
                this.displayImageFromFiles(newIndex)
              } catch (err) {
                // ignore
              }
            }

            if (typeof this.updateImageInfoDisplay === 'function') {
              try {
                this.updateImageInfoDisplay({ light: true })
              } catch (err) {
                // ignore
              }
            }
            this.afterStackBufferGrew(prevLen, nextLen)
          }
          break
        }        
        case 'openimage': {
          this.sliceIndex = opt
          this._miniatureLoaded = false
          this.displayImageFromFiles(opt)
          break   
        }
        case 'setslice': {
          this.sliceIndex = opt
          this._miniatureLoaded = false
          this.displayImageFromFiles(opt)
          break   
        }
        case 'openLocalFs': {
          cornerstone.disable(this.dicomImage)
          this.loadImage(opt)
          break   
        } 
        case 'openSandboxFs': {
          cornerstone.disable(this.dicomImage)
          this.loadImage(undefined, undefined, opt)
          break   
        }         
        case 'openurl': {
          this.showOpenUrlDlg(opt)
          break                 
        }
        case 'clear': {
          this.runCinePlayer('pause')
          this._cineUserClosed = false
          this.setState({ visibleCinePlayer: false, inPlay: false })
          console.log(`DicomViewer ${this.props.index} - Starting clear operation`)
          
          this.mprPlane = ''
          this.files = null
          this.image = null
          this.isChangingSeries = true

          // ✅ LIMPIAR CANVAS ANTES DE DESHABILITAR
          try {
            this.clearCanvas()
          } catch (e) {
            console.warn('DicomViewer - clearCanvas:', e)
          }

          // ✅ LIMPIAR LÍNEAS DE REFERENCIA PERSONALIZADAS
          if (this.referenceLines) {
            console.log('DicomViewer - Limpiando líneas de referencia personalizadas')
            this.referenceLines = {}
          }

          // ✅ REMOVER DEL REFERENCE LINES MANAGER
          if (this.dicomImage) {
            try {
              const ReferenceLinesManager = require('../managers/ReferenceLinesManager').default
              if (ReferenceLinesManager && ReferenceLinesManager.getInstance) {
                const manager = ReferenceLinesManager.getInstance()
                manager.removeElement(this.dicomImage)
                console.log('DicomViewer - Elemento removido del ReferenceLinesManager')
              }
            } catch (error) {
              console.warn('DicomViewer - Error removiendo elemento del ReferenceLinesManager:', error)
            }
          }

          try {
            this.props.setIsOpenStore({index: this.props.index, value: false})
          } catch (e) {
            console.warn('DicomViewer - setIsOpenStore clear:', e)
          }
          if (this.dicomImage) {
            try {
              cornerstone.disable(this.dicomImage)
            } catch (e) {
              console.warn('DicomViewer - disable on clear (ok):', e)
            }
          }
          
          // Limpiar cache de imágenes y timeouts
          this.imageCache.clear()
          this._imageCacheOrder = []
          this.preloadQueue = []
          if (this.updateTimeout) {
            clearTimeout(this.updateTimeout)
            this.updateTimeout = null
          }
          this.isUpdating = false
          
          console.log(`DicomViewer ${this.props.index} - Clear operation completed`)
          break
        }  
        case 'notool': {
          // Desactivar todas las herramientas y establecer notool como herramienta activa
          this.disableAllTools()
          this.props.toolStore('notool')
          break
        }
        case 'Wwwc': {
          this.ensureToolsRegistered({ activateScroll: false })
          // Decidir path según modo app actual (no residual de PREVIEW)
          if (this.shouldUseCssWwwc()) {
            this._cssWwwcMode = true
            try {
              const f =
                Array.isArray(this.files) && this.files[this.sliceIndex]
                  ? this.files[this.sliceIndex]
                  : null
              if (this.image) this.ensureImageRender(this.image, f)
              this.applyPreviewWwwcCss()
            } catch (e) {
              /* ignore */
            }
            try {
              // Asegurar que la tool nativa NO capture el drag
              if (this.isToolRegisteredGlobally('Wwwc')) {
                cornerstoneTools.setToolPassive('Wwwc')
              }
            } catch (e) {
              /* ignore */
            }
            this.props.toolStore('Wwwc')
          } else {
            // DIAGNOSTIC: reset total del path CSS y reactivar nativo limpio
            this._cssWwwcMode = false
            this._cssWwwcDragging = false
            try {
              this.resetPreviewWwwcState()
            } catch (e) {
              /* ignore */
            }
            this.activateMeasurementTool(
              'Wwwc',
              this.pointerToolOptions()
            )
          }
          break
        }  
        case 'Pan': {
          this.activateMeasurementTool('Pan', this.pointerToolOptions())
          break   
        }  
        case 'Zoom': {
          this.activateMeasurementTool(
            isMobile || isTablet ? 'ZoomTouchPinch' : 'Zoom',
            this.pointerToolOptions()
          )
          break
        }
        case 'Length': {
          this.activateMeasurementTool('Length', this.pointerToolOptions())
          break  
        }
        case 'Probe': {
          this.activateMeasurementTool('Probe', this.pointerToolOptions())
          break
        }
        case 'EllipticalRoi': {
          this.activateMeasurementTool('EllipticalRoi', this.pointerToolOptions())
          break   
        }
        case 'RectangleRoi': {
          this.activateMeasurementTool('RectangleRoi', this.pointerToolOptions())
          break  
        }  
        case 'Angle': {
          this.activateMeasurementTool('Angle', this.pointerToolOptions())
          break 
        }
        case 'CobbAngle': {
          this.activateMeasurementTool('CobbAngle', this.pointerToolOptions())
          break
        }
        case 'Magnify': {
          this._magnifyMode = true
          try {
            this.props.toolStore('Magnify')
          } catch (e) {
            /* ignore */
          }
          this.bindMagnifyPointers()
          break
        }
        case 'FreehandRoi': {
          this.activateMeasurementTool('FreehandRoi', this.pointerToolOptions())
          break 
        }
        case 'Invert': {
          const element = this.dicomImage
          if (this.shouldUseCssWwwc()) {
            this._previewWwwc.invert = !this._previewWwwc.invert
            this.applyPreviewWwwcCss()
          } else if (element) {
            const viewport = cornerstone.getViewport(element)
            viewport.invert = !viewport.invert
            cornerstone.setViewport(element, viewport)
          }
          // Si quedó como tool activa (builds viejos / paths alternos), volver a notool
          if (this.props.tool === 'Invert' && typeof this.props.toolStore === 'function') {
            try {
              this.props.toolStore('notool')
            } catch (e) {
              /* ignore */
            }
          }
          break
        }
        case 'saveas': {
          // opt: 'clipboard' | 'file' | { dest: 'clipboard'|'file' }
          const destRaw =
            typeof opt === 'string'
              ? opt
              : opt && typeof opt === 'object'
                ? opt.dest
                : 'file'
          const dest = destRaw === 'clipboard' ? 'clipboard' : 'file'
          this.captureViewport(dest)
          break
        }
        case 'cine': {
          const canCine = this.canUseCine()
          if (!canCine) break
          const nextVisible = !this.state.visibleCinePlayer
          if (!nextVisible) {
            this.runCinePlayer('pause')
            this._cineUserClosed = true
            this._cineWaitingBuffer = false
            this._cineResumeOnBufferGrow = false
            this.setState({ visibleCinePlayer: false })
            break
          }
          // Usuario abre de nuevo: permitir auto y mostrar
          this._cineUserClosed = false
          this.reloadCinePanelLayoutForModality()
          {
            const fileHint =
              (this.files && this.files[this.sliceIndex]) ||
              (this.files && this.files[0]) ||
              null
            const fps = this.getResolvedCineFps(this.image, fileHint)
            this.setState({ visibleCinePlayer: true, cineFps: fps })
          }
          break
        }
        case 'reset': {
          this.reset()
          break
        }
        case 'removetool': {
          //console.log('removetool index: ', opt)
          const element = this.dicomImage
          cornerstoneTools.removeToolState(element, this.measurements[opt].tool, this.measurements[opt].data)
          cornerstone.updateImage(element)
          //this.props.measurementRemoveStore(opt)
          this.measurementRemove(opt)
          this.props.setActiveMeasurements(this.measurements)
          break
        }  
        case 'removetools': {   
          const element = this.dicomImage
          // for each measurement remove it 
          this.measurements.forEach(measure => {
            cornerstoneTools.clearToolState(element, measure.tool)         
          })
          cornerstone.updateImage(element)
          this.measurementClear()
          // also remove all measurements from db
          db.measurement.where('sopinstanceuid').equals(this.sopInstanceUid).delete()
          this.props.setActiveMeasurements(this.measurements)
          break
        }  
        case 'savetools': {
          // first, remove eventually previous measurements from db
          db.measurement.where('sopinstanceuid').equals(this.sopInstanceUid).delete()
          // then save all the current measurements
          this.measurements.forEach(measure => {
            if (measure && measure.data && measure.data._fromGsps) return
            try {
              db.measurement.add({
                sopinstanceuid: this.sopInstanceUid, 
                tool: measure.tool,
                note: measure.note,
                data: measure.data
              })
            } catch(error) {
              console.error(error)
            }                       
          })
          break
        }
        default: {
          break
        }
      }
    } 

    /**
     * Blob de captura sin descargar (para Web Share).
     * @returns {Promise<{ blob: Blob, filename: string }|null>}
     */
    getCaptureBlob = () => {
      return new Promise((resolve) => {
        try {
          let type = (localStorage.getItem(SETTINGS_SAVEAS) || 'png').toLowerCase()
          if (type === 'jpg') type = 'jpeg'
          if (type !== 'png' && type !== 'jpeg') type = 'png'
          const mime = `image/${type}`
          const ext = type === 'jpeg' ? 'jpg' : 'png'
          const element = this.dicomImage
          if (!element) {
            resolve(null)
            return
          }
          const canvas =
            element.querySelector('canvas.cornerstone-canvas') ||
            element.querySelector('canvas')
          if (!canvas) {
            resolve(null)
            return
          }
          let exportCanvas = canvas
          try {
            const out = document.createElement('canvas')
            out.width = canvas.width
            out.height = canvas.height
            const ctx = out.getContext('2d')
            if (ctx) {
              ctx.fillStyle = '#000'
              ctx.fillRect(0, 0, out.width, out.height)
              ctx.drawImage(canvas, 0, 0)
              exportCanvas = out
            }
          } catch (e) {
            exportCanvas = canvas
          }
          const rawName =
            this.filename ||
            (this.files &&
              this.files[this.sliceIndex] &&
              this.files[this.sliceIndex].name) ||
            'udv-capture'
          const base =
            getFileName(String(rawName).replace(/\.(dcm|dicom|jpe?g|png)$/i, '')) ||
            'udv-capture'
          const sliceTag =
            this.sliceIndex != null ? `-s${Number(this.sliceIndex) + 1}` : ''
          const filename = `${base}${sliceTag}.${ext}`
          const quality = type === 'jpeg' ? 0.92 : undefined
          exportCanvas.toBlob(
            (blob) => {
              if (!blob) resolve(null)
              else resolve({ blob, filename })
            },
            mime,
            quality
          )
        } catch (err) {
          console.warn('DicomViewer - getCaptureBlob:', err)
          resolve(null)
        }
      })
    }

    /**
     * Captura el canvas del viewport.
     * @param {'clipboard'|'file'} dest
     */
    captureViewport = (dest = 'file') => {
      let type = (localStorage.getItem(SETTINGS_SAVEAS) || 'png').toLowerCase()
      if (type === 'jpg') type = 'jpeg'
      if (type !== 'png' && type !== 'jpeg') type = 'png'
      // Portapapeles: PNG es el más compatible con ClipboardItem
      const useType = dest === 'clipboard' ? 'png' : type
      const mime = `image/${useType}`
      const ext = useType === 'jpeg' ? 'jpg' : 'png'
      const element = this.dicomImage
      if (!element) return
      const canvas =
        element.querySelector('canvas.cornerstone-canvas') ||
        element.querySelector('canvas')
      if (!canvas) {
        console.warn('DicomViewer - captureViewport: sin canvas')
        return
      }

      let exportCanvas = canvas
      try {
        const out = document.createElement('canvas')
        out.width = canvas.width
        out.height = canvas.height
        const ctx = out.getContext('2d')
        if (ctx) {
          ctx.fillStyle = '#000'
          ctx.fillRect(0, 0, out.width, out.height)
          ctx.drawImage(canvas, 0, 0)
          exportCanvas = out
        }
      } catch (e) {
        exportCanvas = canvas
      }

      const rawName =
        this.filename ||
        (this.files &&
          this.files[this.sliceIndex] &&
          this.files[this.sliceIndex].name) ||
        'udv-capture'
      const base =
        getFileName(String(rawName).replace(/\.(dcm|dicom|jpe?g|png)$/i, '')) ||
        'udv-capture'
      const sliceTag =
        this.sliceIndex != null ? `-s${Number(this.sliceIndex) + 1}` : ''
      const filename = `${base}${sliceTag}.${ext}`
      const quality = useType === 'jpeg' ? 0.92 : undefined

      const canvasToBlob = () =>
        new Promise((resolve, reject) => {
          try {
            if (typeof exportCanvas.toBlob === 'function') {
              exportCanvas.toBlob(
                (blob) =>
                  blob ? resolve(blob) : reject(new Error('toBlob vacío')),
                mime,
                quality
              )
            } else {
              blobUtil
                .canvasToBlob(exportCanvas, mime)
                .then(resolve)
                .catch(reject)
            }
          } catch (err) {
            reject(err)
          }
        })

      if (dest === 'clipboard') {
        canvasToBlob()
          .then(async (blob) => {
            if (
              typeof navigator === 'undefined' ||
              !navigator.clipboard ||
              typeof window.ClipboardItem === 'undefined'
            ) {
              throw new Error('clipboard_unsupported')
            }
            await navigator.clipboard.write([
              new window.ClipboardItem({ [blob.type || 'image/png']: blob }),
            ])
            if (typeof this.props.onCaptureResult === 'function') {
              this.props.onCaptureResult({ ok: true, dest: 'clipboard' })
            }
          })
          .catch((err) => {
            console.warn('DicomViewer - capture clipboard:', err)
            if (typeof this.props.onCaptureResult === 'function') {
              this.props.onCaptureResult({
                ok: false,
                dest: 'clipboard',
                error: err,
              })
            }
          })
        return
      }

      // Archivo: local download o sandbox según settings
      if (getSettingsSaveInto() === 'local') {
        try {
          const a = document.createElement('a')
          a.href = exportCanvas.toDataURL(mime, quality)
          a.download = filename
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          if (typeof this.props.onCaptureResult === 'function') {
            this.props.onCaptureResult({ ok: true, dest: 'file' })
          }
        } catch (err) {
          console.warn('DicomViewer - capture file:', err)
          if (typeof this.props.onCaptureResult === 'function') {
            this.props.onCaptureResult({ ok: false, dest: 'file', error: err })
          }
        }
        return
      }

      canvasToBlob()
        .then((blob) => blobUtil.blobToArrayBuffer(blob))
        .then((arrayBuffer) => {
          const name = `${base}${sliceTag}`
          let newName = name
          let counter = 1
          let done = false
          do {
            const fileEntry = `${newName}.${ext}`
            const checkName =
              this.props.fsCurrentList &&
              this.props.fsCurrentList.find((e) => e.name === fileEntry)
            if (checkName === undefined) {
              fs.transaction('rw', fs.files, async () => {
                await fs.files.add({
                  parent: this.props.fsCurrentDir,
                  name: fileEntry,
                  type: ext,
                  size: arrayBuffer.byteLength,
                  data: arrayBuffer,
                })
              }).then(() => {
                if (this.props.makeFsRefresh) this.props.makeFsRefresh()
                if (typeof this.props.onCaptureResult === 'function') {
                  this.props.onCaptureResult({ ok: true, dest: 'file' })
                }
              })
              done = true
            } else {
              newName = `${name} - ${counter}`
              counter++
            }
          } while (!done && counter < 100)
        })
        .catch((err) => {
          console.warn('DicomViewer - capture sandbox:', err)
          if (typeof this.props.onCaptureResult === 'function') {
            this.props.onCaptureResult({ ok: false, dest: 'file', error: err })
          }
        })
    }

    cropCanvas = (canvas, x, y, width, height) => {
      // create a temp canvas
      const newCanvas = document.createElement('canvas')
      // set its dimensions
      newCanvas.width = width
      newCanvas.height = height
      // draw the canvas in the new resized temp canvas 
      newCanvas.getContext('2d').drawImage(canvas, x, y, width, height, 0, 0, width, height)
      return newCanvas
    }

    changeTool = (toolName, value) => {
      if (value === 1) {
        const opts =
          toolName === 'Wwwc' || toolName === 'Length' || toolName === 'CobbAngle'
            ? isMobile || isTablet
              ? { isTouchActive: true }
              : { mouseButtonMask: 1 }
            : { mouseButtonMask: 1 }
        const name =
          toolName === 'Zoom' && (isMobile || isTablet)
            ? 'ZoomTouchPinch'
            : toolName
        this.activateMeasurementTool(name, opts)
        return
      }

      if (value === 0) {
        this.ensureToolsRegistered({ activateScroll: false })
        try {
          const name =
            toolName === 'Zoom' && (isMobile || isTablet)
              ? 'ZoomTouchPinch'
              : toolName
          if (this.isToolRegisteredGlobally(name)) {
            cornerstoneTools.setToolPassive(name)
          }
        } catch (e) {
          /* ignore */
        }
        try {
          this.props.toolStore('notool')
        } catch (e2) {
          /* ignore */
        }
      }
    }

    isMultiFrameCine = () => {
      if (this.numberOfFrames > 1) return true
      const f = this.files && (this.files[this.sliceIndex] || this.files[0])
      return resolveFileNumberOfFrames(f) > 1 && (!this.files || this.files.length <= 1)
    }

    isStackCine = () =>
      !this.isMultiFrameCine() && Array.isArray(this.files) && this.files.length > 1

    canUseCine = () => this.isMultiFrameCine() || this.isStackCine()

    /**
     * cornerstonenewimage: envolver getPixelData con DSA antes del paint.
     * No llamar updateImage aquí: scrollToIndex/playClip ya pintan; un forceUpdate
     * extra en wheel/drag congela el hilo y deja el stack sin respuesta.
     */
    onNewImage = (e) => {
      try {
        const image = e && e.detail && e.detail.image
        if (image) {
          this.image = image
          if (image.imageId) this.imageId = image.imageId
        }
        // Liberar paso de cine rAF tras paint real (evita cola de scrollToIndex)
        if (this.state.inPlay) {
          this._cinePaintBusy = false
        }
        if (this._dsa && this._dsa.enabled && this._dsa.maskPixels) {
          if (this._dsa.engine === 'gpu') {
            this.paintDsaGpuFrame(image || this.image)
          } else {
            this.applyDsaToImage(image || this.image)
          }
        }
      } catch (err) {
        console.warn('DicomViewer - onNewImage DSA:', err)
      }
    }

    /**
     * Aplica / actualiza estado DSA desde App (vía ref; props del constructor están congeladas).
     * @param {{
     *   enabled?: boolean,
     *   maskMode?: string|null,
     *   maskFrameIndex?: number|null,
     *   pixelShift?: { x?: number, y?: number },
     *   invertDSA?: boolean,
     *   gain?: number,
     *   offset?: number|null,
     *   noiseFloor?: number,
     *   engineMode?: 'auto'|'gpu'|'cpu',
     *   roadmap?: { on?: boolean, alpha?: number, lut?: string },
     * }} dsaUi
     * @returns {Promise<{ ok: boolean, reason?: string, engine?: string }>}
     */
    applyDsaState = async (dsaUi) => {
      const next = dsaUi || {}
      if (!next.enabled) {
        this.clearDsa({ redraw: true })
        return { ok: true }
      }

      if (!(this.numberOfFrames > 1)) {
        this.clearDsa({ redraw: false })
        return { ok: false, reason: 'need-multiframe' }
      }

      const element = this.dicomImage
      let image = this.image
      try {
        if (element && cornerstone.getEnabledElement(element)) {
          image = cornerstone.getImage(element) || image
        }
      } catch (e) {
        /* ignore */
      }

      if (
        !image ||
        typeof image.getPixelData !== 'function' ||
        !image.data ||
        image.color
      ) {
        return { ok: false, reason: 'no-pixels' }
      }

      const maskFrameIndex = Math.max(
        0,
        Math.min(
          this.numberOfFrames - 1,
          next.maskFrameIndex != null ? Number(next.maskFrameIndex) | 0 : 0
        )
      )
      const shiftX =
        next.pixelShift && next.pixelShift.x != null
          ? Number(next.pixelShift.x)
          : 0
      const shiftY =
        next.pixelShift && next.pixelShift.y != null
          ? Number(next.pixelShift.y)
          : 0

      const wasEnabled = !!(this._dsa && this._dsa.enabled)

      this._dsa.enabled = true
      this._dsa.maskMode = next.maskMode || null
      this._dsa.maskFrameIndex = maskFrameIndex
      this._dsa.pixelShift = { x: shiftX, y: shiftY }
      this._dsa.invertDSA = next.invertDSA === true
      this._dsa.gain =
        next.gain != null && Number.isFinite(Number(next.gain))
          ? Number(next.gain)
          : 1
      this._dsa.noiseFloor =
        next.noiseFloor != null && Number.isFinite(Number(next.noiseFloor))
          ? Number(next.noiseFloor)
          : DSA_DEFAULTS.noiseFloor
      this._dsa.bias = dsaDefaultBias(image)
      this._dsa.offset =
        next.offset != null && Number.isFinite(Number(next.offset))
          ? Number(next.offset)
          : this._dsa.bias
      this._dsa.engineMode =
        next.engineMode === 'gpu' || next.engineMode === 'cpu'
          ? next.engineMode
          : 'auto'
      // Reintentar GPU al reaplicar (salvo forzado CPU)
      if (this._dsa.engineMode !== 'cpu') {
        this._dsa.gpuFailed = false
      }

      if (next.roadmap) {
        this._dsa.roadmapOn = !!next.roadmap.on
        if (next.roadmap.alpha != null && Number.isFinite(Number(next.roadmap.alpha))) {
          this._dsa.roadmapAlpha = Math.max(0, Math.min(1, Number(next.roadmap.alpha)))
        }
        const lutMap = { gray: 0, 'fluoro-green': 1, 'alert-red': 2 }
        if (next.roadmap.lut && lutMap[next.roadmap.lut] != null) {
          this._dsa.roadmapLut = lutMap[next.roadmap.lut]
        }
      }

      const loaded = await this.ensureDsaMaskLoaded(maskFrameIndex)
      if (!loaded.ok) {
        this.clearDsa({ redraw: false })
        return loaded
      }

      this.resolveDsaEngine()
      this.refreshDsaFrame({ forceUpdate: true })
      // WW/WC solo al activar DSA (no en cada tweak de G/O/N durante cine)
      if (!wasEnabled) {
        try {
          const vp = cornerstone.getViewport(element)
          if (vp && vp.voi) {
            const min =
              image.minPixelValue != null ? Number(image.minPixelValue) : 0
            const max =
              image.maxPixelValue != null ? Number(image.maxPixelValue) : 4095
            vp.voi.windowWidth = Math.max(1, max - min)
            vp.voi.windowCenter = (min + max) / 2
            cornerstone.setViewport(element, vp)
          }
        } catch (e) {
          /* ignore */
        }
      }
      this.updateDsaOverlay()
      this.syncDsaHudState()
      // Layout de paneles: solo al activar DSA por primera vez.
      // Si se toca en cada tweak (invert/gain/…), se forzaba dock free y desacoplaba.
      if (!wasEnabled) {
        this.reloadDsaHudLayoutForModality()
        this.reloadCinePanelLayoutForModality()
        try {
          this._cineUserClosed = false
          const prevDsa = this.state.dsaHudLayout
          const prevCine = this.state.cinePanelLayout
          const coupled =
            prevDsa &&
            (prevDsa.dock === 'left' || prevDsa.dock === 'right')
          if (coupled) {
            this.setState({ visibleCinePlayer: true })
          } else {
            const cine =
              prevCine &&
              prevCine.dock === 'free' &&
              Number.isFinite(Number(prevCine.x))
                ? prevCine
                : {
                    dock: 'free',
                    x: Math.max(
                      8,
                      Math.round((window.innerWidth || 360) / 2 - 150)
                    ),
                    y: Math.max(8, (window.innerHeight || 640) - 220),
                  }
            const dsa =
              prevDsa &&
              prevDsa.dock === 'free' &&
              Number.isFinite(Number(prevDsa.x))
                ? prevDsa
                : {
                    dock: 'free',
                    x: Math.max(
                      8,
                      Math.round((window.innerWidth || 360) / 2 + 160)
                    ),
                    y: Math.max(8, (window.innerHeight || 640) - 280),
                  }
            this.setState({
              visibleCinePlayer: true,
              cinePanelLayout: { dock: 'free', x: cine.x, y: cine.y },
              dsaHudLayout: { dock: 'free', x: dsa.x, y: dsa.y },
            })
          }
        } catch (e) {
          /* ignore */
        }
      }
      return { ok: true, engine: this._dsa.engine }
    }

    /** Elige GPU si auto/gpu y WebGL2 disponible; fallback CPU transparente. */
    resolveDsaEngine = () => {
      const mode = this._dsa.engineMode || 'auto'
      const wantGpu =
        !this._dsa.gpuFailed &&
        (mode === 'gpu' || (mode === 'auto' && hasWebGl2()))
      if (!wantGpu) {
        this.teardownDsaGpu()
        this._dsa.engine = 'cpu'
        this.clearDsaGpuCanvas()
        return
      }
      if (!this.ensureDsaGpuPipeline()) {
        this._dsa.engine = 'cpu'
        this._dsa.gpuFailed = true
        this.clearDsaGpuCanvas()
        return
      }
      if (this._dsa.gpu && this._dsa.gpu.isLost()) {
        this.fallbackDsaToCpu('webglcontextlost')
        return
      }
      this._dsa.engine = 'gpu'
      if (this._dsa.maskPixels) {
        const cols = (this.image && (this.image.columns || this.image.width)) | 0
        const rows = (this.image && (this.image.rows || this.image.height)) | 0
        if (cols > 0 && rows > 0) {
          this._dsa.gpu.setMaskPixels(this._dsa.maskPixels, cols, rows)
        }
      }
      if (this._dsa.roadmapPixels) {
        const cols = (this.image && (this.image.columns || this.image.width)) | 0
        const rows = (this.image && (this.image.rows || this.image.height)) | 0
        if (cols > 0 && rows > 0) {
          this._dsa.gpu.setRoadmapPixels(this._dsa.roadmapPixels, cols, rows)
        }
      }
    }

    fallbackDsaToCpu = (reason) => {
      this.teardownDsaGpu()
      this._dsa.engine = 'cpu'
      this._dsa.gpuFailed = true
      this.clearDsaGpuCanvas()
      try {
        if (typeof this.props.onDsaEngineFallback === 'function') {
          this.props.onDsaEngineFallback(reason || 'gpu-fail')
        }
      } catch (e) {
        /* ignore */
      }
    }

    ensureDsaGpuPipeline = () => {
      if (this._dsa.gpu && !this._dsa.gpu.isLost()) return true
      const canvas = this._dsaGpuCanvas
      if (!canvas) return false
      this.teardownDsaGpu()
      const pipe = createDsaGpuPipeline(canvas)
      if (!pipe) return false
      this._dsa.gpu = pipe
      return true
    }

    teardownDsaGpu = () => {
      if (this._dsa.gpu) {
        try {
          this._dsa.gpu.destroy()
        } catch (e) {
          /* ignore */
        }
      }
      this._dsa.gpu = null
    }

    clearDsaGpuCanvas = () => {
      const cv = this._dsaGpuCanvas
      if (!cv) return
      cv.style.display = 'none'
    }

    showDsaGpuCanvas = () => {
      const cv = this._dsaGpuCanvas
      const element = this.dicomImage
      if (!cv || !element) return
      const host = element.getBoundingClientRect()
      const w = Math.max(1, Math.round(host.width))
      const h = Math.max(1, Math.round(host.height))
      if (this._dsa.gpu) this._dsa.gpu.resize(w, h)
      cv.style.display = 'block'
    }

    paintDsaGpuFrame = (image) => {
      if (!this._dsa || !this._dsa.enabled || this._dsa.engine !== 'gpu') {
        this.clearDsaGpuCanvas()
        return false
      }
      if (!this._dsa.gpu || this._dsa.gpu.isLost()) {
        this.fallbackDsaToCpu('gpu-lost')
        this.applyDsaToImage(image)
        try {
          const el = this.dicomImage
          if (el) cornerstone.updateImage(el, true)
        } catch (e) {
          /* ignore */
        }
        return false
      }
      if (!image || typeof image.getPixelData !== 'function') return false
      if (!this._dsa.maskPixels) {
        this.clearDsaGpuCanvas()
        return false
      }

      const live = image._udvDsaOrigGetPixelData
        ? image._udvDsaOrigGetPixelData()
        : image.getPixelData()
      const cols = (image.columns || image.width) | 0
      const rows = (image.rows || image.height) | 0
      if (!(cols > 0 && rows > 0 && live && live.length >= cols * rows)) {
        this.fallbackDsaToCpu('bad-pixels')
        this.applyDsaToImage(image)
        try {
          cornerstone.updateImage(this.dicomImage, true)
        } catch (e) {
          /* ignore */
        }
        return false
      }

      // Asegurar máscara subida con tamaño del frame
      try {
        this._dsa.gpu.setMaskPixels(this._dsa.maskPixels, cols, rows)
      } catch (e) {
        /* ignore */
      }

      const min = image.minPixelValue != null ? Number(image.minPixelValue) : 0
      const max = image.maxPixelValue != null ? Number(image.maxPixelValue) : 4095
      const offset =
        this._dsa.offset != null
          ? this._dsa.offset
          : this._dsa.bias != null
            ? this._dsa.bias
            : dsaDefaultBias(image)

      let ww = Math.max(1, max - min)
      let wc = (min + max) / 2
      try {
        const vp = cornerstone.getViewport(this.dicomImage)
        if (vp && vp.voi) {
          ww = vp.voi.windowWidth || ww
          wc = vp.voi.windowCenter != null ? vp.voi.windowCenter : wc
        }
      } catch (e) {
        /* ignore */
      }

      // Resize offscreen primero; solo mostrar overlay si el draw OK
      const cv = this._dsaGpuCanvas
      const element = this.dicomImage
      if (cv && element) {
        const host = element.getBoundingClientRect()
        this._dsa.gpu.resize(
          Math.max(1, Math.round(host.width)),
          Math.max(1, Math.round(host.height))
        )
      }

      const ok = this._dsa.gpu.drawFrame(live, {
        cols,
        rows,
        shiftX: (this._dsa.pixelShift && this._dsa.pixelShift.x) || 0,
        shiftY: (this._dsa.pixelShift && this._dsa.pixelShift.y) || 0,
        gain: this._dsa.gain != null ? this._dsa.gain : 1,
        offset,
        invert: this._dsa.invertDSA === true,
        noiseFloor: this._dsa.noiseFloor != null ? this._dsa.noiseFloor : 0,
        min,
        max,
        ww,
        wc,
        roadmapOn: !!this._dsa.roadmapOn && !!this._dsa.roadmapPixels,
        roadmapAlpha: this._dsa.roadmapAlpha != null ? this._dsa.roadmapAlpha : 0.45,
        roadmapLut: this._dsa.roadmapLut != null ? this._dsa.roadmapLut : 1,
      })

      if (!ok) {
        this.fallbackDsaToCpu('draw-fail')
        this.applyDsaToImage(image)
        try {
          cornerstone.updateImage(this.dicomImage, true)
        } catch (e) {
          /* ignore */
        }
        return false
      }

      this.showDsaGpuCanvas()
      return true
    }

    /**
     * Carga y cachea píxeles de la máscara (una sola copia TypedArray).
     * @param {number} maskFrameIndex
     * @returns {Promise<{ ok: boolean, reason?: string }>}
     */
    ensureDsaMaskLoaded = async (maskFrameIndex) => {
      const baseId =
        dsaBaseImageId(this.imageId) ||
        dsaBaseImageId(this.image && this.image.imageId)
      if (!baseId) {
        return { ok: false, reason: 'no-pixels' }
      }

      const sameSource =
        this._dsa.sourceImageId === baseId &&
        this._dsa.maskLoadedFrameIndex === maskFrameIndex &&
        this._dsa.maskPixels

      if (sameSource) {
        return { ok: true }
      }

      const gen = ++this._dsa.loadGen
      const maskId = `${baseId}?frame=${maskFrameIndex}`
      try {
        const maskImage = await cornerstone.loadAndCacheImage(maskId)
        if (gen !== this._dsa.loadGen) {
          return { ok: false, reason: 'stale' }
        }
        if (!maskImage || typeof maskImage.getPixelData !== 'function') {
          return { ok: false, reason: 'no-pixels' }
        }
        const pd = maskImage.getPixelData()
        if (!pd || !pd.length) {
          return { ok: false, reason: 'no-pixels' }
        }
        // Copia estable (no alias del cache de cornerstone)
        const Ctor =
          typeof pd.constructor === 'function' && pd.constructor !== Array
            ? pd.constructor
            : Int16Array
        this._dsa.maskPixels = new Ctor(pd)
        this._dsa.sourceImageId = baseId
        this._dsa.maskFrameIndex = maskFrameIndex
        this._dsa.maskLoadedFrameIndex = maskFrameIndex
        this._dsa.bias = dsaDefaultBias(maskImage)
        if (this._dsa.gpu && !this._dsa.gpu.isLost()) {
          const cols = (maskImage.columns || maskImage.width) | 0
          const rows = (maskImage.rows || maskImage.height) | 0
          this._dsa.gpu.setMaskPixels(this._dsa.maskPixels, cols, rows)
        }
        return { ok: true }
      } catch (e) {
        console.warn('DicomViewer - ensureDsaMaskLoaded:', e)
        return { ok: false, reason: 'no-pixels' }
      }
    }

    /**
     * Envuelve getPixelData del image actual para devolver frame sustraído (CPU path).
     * No llama updateImage (el paint de newimage / displayImage lo hará).
     */
    applyDsaToImage = (image) => {
      if (!image || typeof image.getPixelData !== 'function') return
      if (!this._dsa || !this._dsa.enabled || !this._dsa.maskPixels) return
      if (this._dsa.engine === 'gpu') {
        this.paintDsaGpuFrame(image)
        return
      }

      if (!image._udvDsaOrigGetPixelData) {
        image._udvDsaOrigGetPixelData = image.getPixelData.bind(image)
        const self = this
        image.getPixelData = function udvDsaGetPixelData() {
          if (!self._dsa || !self._dsa.enabled || !self._dsa.maskPixels) {
            return image._udvDsaOrigGetPixelData()
          }
          if (self._dsa.engine === 'gpu') {
            return image._udvDsaOrigGetPixelData()
          }
          return self.computeDsaPixels(image)
        }
      }
      // Invalidar LUT solo al envolver / cambiar params (computeDsaPixels cachea out)
      try {
        image.cachedLut = undefined
      } catch (e) {
        /* ignore */
      }
    }

    dsaOutCacheKey = (image) => {
      const id = (image && image.imageId) || ''
      const sx = (this._dsa.pixelShift && this._dsa.pixelShift.x) || 0
      const sy = (this._dsa.pixelShift && this._dsa.pixelShift.y) || 0
      const m =
        this._dsa.maskLoadedFrameIndex != null
          ? this._dsa.maskLoadedFrameIndex
          : this._dsa.maskFrameIndex
      const inv = this._dsa.invertDSA === true ? 1 : 0
      const g = this._dsa.gain != null ? this._dsa.gain : 1
      const o =
        this._dsa.offset != null
          ? this._dsa.offset
          : this._dsa.bias != null
            ? this._dsa.bias
            : 0
      const nf = this._dsa.noiseFloor != null ? this._dsa.noiseFloor : 0
      return `${id}|m${m}|${sx},${sy}|i${inv}|g${g}|o${o}|n${nf}`
    }

    computeDsaPixels = (image) => {
      const key = this.dsaOutCacheKey(image)
      if (
        this._dsa.outCacheKey === key &&
        this._dsa.outBuffer &&
        this._dsa.outBuffer.length
      ) {
        return this._dsa.outBuffer
      }

      const live = image._udvDsaOrigGetPixelData
        ? image._udvDsaOrigGetPixelData()
        : image.getPixelData()
      const cols = (image && (image.columns || image.width)) | 0
      const rows = (image && (image.rows || image.height)) | 0
      const min =
        image && image.minPixelValue != null
          ? Number(image.minPixelValue)
          : 0
      const max =
        image && image.maxPixelValue != null
          ? Number(image.maxPixelValue)
          : 4095
      const offset =
        this._dsa.offset != null
          ? this._dsa.offset
          : this._dsa.bias != null
            ? this._dsa.bias
            : dsaDefaultBias(image)
      this._dsa.outBuffer = ensureDsaOutBuffer(live, this._dsa.outBuffer)
      subtractFrame(live, this._dsa.maskPixels, this._dsa.outBuffer, {
        cols,
        rows,
        shiftX: (this._dsa.pixelShift && this._dsa.pixelShift.x) || 0,
        shiftY: (this._dsa.pixelShift && this._dsa.pixelShift.y) || 0,
        gain: this._dsa.gain != null ? this._dsa.gain : 1,
        offset,
        invert: this._dsa.invertDSA === true,
        noiseFloor: this._dsa.noiseFloor != null ? this._dsa.noiseFloor : 0,
        min,
        max,
      })
      this._dsa.outCacheKey = key
      return this._dsa.outBuffer
    }

    /**
     * Reaplica DSA al frame visible.
     * @param {{ forceUpdate?: boolean }} [opts]
     */
    refreshDsaFrame = (opts) => {
      const forceUpdate = !!(opts && opts.forceUpdate)
      const element = this.dicomImage
      if (!element) return

      let image = this.image
      try {
        if (cornerstone.getEnabledElement(element)) {
          image = cornerstone.getImage(element) || image
        }
      } catch (e) {
        /* ignore */
      }
      if (!image) return

      if (this._dsa && this._dsa.enabled && this._dsa.maskPixels) {
        this._dsa.outCacheKey = null
        if (this._dsa.engine === 'gpu') {
          this.paintDsaGpuFrame(image)
        } else {
          this.clearDsaGpuCanvas()
          this.applyDsaToImage(image)
          this.image = image
          if (forceUpdate) {
            try {
              cornerstone.updateImage(element, true)
            } catch (e) {
              /* ignore */
            }
          }
        }
      }
      this.updateDsaOverlay()
    }

    /**
     * Desactiva DSA y fuerza repaint con píxeles originales.
     * @param {{ redraw?: boolean }} [opts]
     */
    clearDsa = (opts) => {
      const redraw = !opts || opts.redraw !== false
      this._dsa.loadGen += 1
      this._dsa.enabled = false
      this._dsa.maskMode = null
      this._dsa.maskFrameIndex = null
      this._dsa.maskLoadedFrameIndex = null
      this._dsa.pixelShift = { x: 0, y: 0 }
      this._dsa.invertDSA = DSA_DEFAULTS.invertDSA
      this._dsa.gain = DSA_DEFAULTS.gain
      this._dsa.offset = null
      this._dsa.noiseFloor = DSA_DEFAULTS.noiseFloor
      this._dsa.maskPixels = null
      this._dsa.outBuffer = null
      this._dsa.outCacheKey = null
      this._dsa.sourceImageId = null
      this._dsa.bias = null
      this._dsa.gateMethod = null
      this._dsa.roadmapOn = false
      this.clearDsaGpuCanvas()
      this.teardownDsaGpu()
      this._dsa.engine = 'cpu'
      this._dsa.gpuFailed = false

      const element = this.dicomImage
      if (redraw && element) {
        try {
          const image = cornerstone.getImage(element) || this.image
          if (image) {
            try {
              image.cachedLut = undefined
            } catch (e) {
              /* ignore */
            }
          }
          cornerstone.updateImage(element, true)
        } catch (e) {
          /* ignore */
        }
      }
      this.updateDsaOverlay()
      this.syncDsaHudState()
    }

    /** Badge DSA en overlay superior-derecha del viewport. */
    updateDsaOverlay = () => {
      try {
        const el = document.getElementById(`dsaLabel-${this.props.index}`)
        if (!el) return
        if (this._dsa && this._dsa.enabled) {
          const m =
            this._dsa.maskFrameIndex != null
              ? Number(this._dsa.maskFrameIndex) + 1
              : '?'
          const sx = (this._dsa.pixelShift && this._dsa.pixelShift.x) || 0
          const sy = (this._dsa.pixelShift && this._dsa.pixelShift.y) || 0
          const shift =
            sx !== 0 || sy !== 0 ? ` · Δ${sx},${sy}` : ''
          const inv = this._dsa.invertDSA === true ? ' INV' : ''
          const g =
            this._dsa.gain != null && Number.isFinite(Number(this._dsa.gain))
              ? Number(this._dsa.gain)
              : 1
          const gStr = String(g).replace(/\.0$/, '')
          const eng = this._dsa.engine === 'gpu' ? ' · GPU' : ' · CPU'
          const gate =
            this._dsa.gateMethod === 'ecg'
              ? ' · ECG'
              : this._dsa.gateMethod === 'acf'
                ? ' · ACF'
                : ''
          const rm = this._dsa.roadmapOn ? ' · RM' : ''
          el.textContent = `DSA · M${m}${shift}${inv} · G${gStr}${eng}${gate}${rm}`
          el.style.display = ''
        } else {
          el.textContent = ''
          el.style.display = 'none'
        }
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * Sincroniza snapshot React del HUD cine (labels G/O/N) desde this._dsa.
     */
    syncDsaHudState = () => {
      const d = this._dsa || {}
      const next = {
        enabled: !!d.enabled,
        maskFrameIndex: d.maskFrameIndex != null ? d.maskFrameIndex : null,
        invertDSA: d.invertDSA === true,
        gain: d.gain != null ? d.gain : 1,
        offset: d.offset,
        noiseFloor: d.noiseFloor != null ? d.noiseFloor : 8,
        engine: d.engine || 'cpu',
        roadmapOn: !!d.roadmapOn,
        pixelShift: {
          x: (d.pixelShift && d.pixelShift.x) || 0,
          y: (d.pixelShift && d.pixelShift.y) || 0,
        },
      }
      const prev = this.state.dsaHud || {}
      const same =
        prev.enabled === next.enabled &&
        prev.maskFrameIndex === next.maskFrameIndex &&
        prev.invertDSA === next.invertDSA &&
        prev.gain === next.gain &&
        prev.offset === next.offset &&
        prev.noiseFloor === next.noiseFloor &&
        prev.engine === next.engine &&
        prev.roadmapOn === next.roadmapOn &&
        (prev.pixelShift && prev.pixelShift.x) === next.pixelShift.x &&
        (prev.pixelShift && prev.pixelShift.y) === next.pixelShift.y
      if (!same) {
        this.setState({ dsaHud: next })
      }
    }

    /**
     * Síntesis vascular MinIP/MIP sobre rango temporal.
     * @param {{ fStart?: number, fEnd?: number, mode?: 'minip'|'mip' }} [opts]
     */
    runDsaVascularSynth = async (opts) => {
      if (!this._dsa || !this._dsa.enabled || !this._dsa.maskPixels) {
        return { ok: false, reason: 'dsa-off' }
      }
      const image = this.image
      const baseId =
        dsaBaseImageId(this.imageId) ||
        dsaBaseImageId(image && image.imageId)
      if (!baseId || !(this.numberOfFrames > 1)) {
        return { ok: false, reason: 'need-multiframe' }
      }
      const cols = (image.columns || image.width) | 0
      const rows = (image.rows || image.height) | 0
      const cur = this.getMultiFrameIndex0 ? this.getMultiFrameIndex0() : 0
      const fStart =
        opts && opts.fStart != null ? opts.fStart | 0 : 0
      const fEnd =
        opts && opts.fEnd != null
          ? opts.fEnd | 0
          : Math.max(cur, this.numberOfFrames - 1)
      const mode =
        opts && opts.mode
          ? opts.mode
          : defaultSynthMode(this._dsa.invertDSA === true)

      try {
        const result = await computeTemporalSynth({
          baseImageId: baseId,
          fStart,
          fEnd,
          numberOfFrames: this.numberOfFrames,
          maskPixels: this._dsa.maskPixels,
          cols,
          rows,
          mode,
          shiftX: (this._dsa.pixelShift && this._dsa.pixelShift.x) || 0,
          shiftY: (this._dsa.pixelShift && this._dsa.pixelShift.y) || 0,
          gain: this._dsa.gain,
          offset: this._dsa.offset,
          invert: this._dsa.invertDSA === true,
          noiseFloor: this._dsa.noiseFloor,
        })
        const dataUrl = synthPixelsToDataUrl(result.pixels, result.cols, result.rows)
        this._dsa.lastSynth = result
        this._dsa.roadmapPixels = result.pixels
        if (this._dsa.gpu && !this._dsa.gpu.isLost()) {
          this._dsa.gpu.setRoadmapPixels(result.pixels, result.cols, result.rows)
        }
        return {
          ok: true,
          dataUrl,
          mode: result.mode,
          frames: result.frames,
          cols: result.cols,
          rows: result.rows,
        }
      } catch (e) {
        console.warn('runDsaVascularSynth:', e)
        return { ok: false, reason: e.message || 'synth-error' }
      }
    }

    /**
     * Activa/desactiva roadmap con última síntesis (o genera una).
     */
    setDsaRoadmap = async (on, alpha, lut) => {
      this._dsa.roadmapOn = !!on
      if (alpha != null && Number.isFinite(Number(alpha))) {
        this._dsa.roadmapAlpha = Math.max(0, Math.min(1, Number(alpha)))
      }
      const lutMap = { gray: 0, 'fluoro-green': 1, 'alert-red': 2 }
      if (lut && lutMap[lut] != null) this._dsa.roadmapLut = lutMap[lut]
      if (on && !this._dsa.roadmapPixels) {
        const synth = await this.runDsaVascularSynth({
          fStart: 0,
          fEnd: this.numberOfFrames - 1,
        })
        if (!synth.ok) return synth
      }
      this.refreshDsaFrame({ forceUpdate: true })
      this.updateDsaOverlay()
      this.syncDsaHudState()
      return { ok: true }
    }

    /**
     * Auto-máscara cardíaca (ECG tags o ACF).
     * @returns {Promise<{ ok: boolean, maskIndex?: number, method?: string }>}
     */
    suggestDsaCardiacMask = async () => {
      const nFrames = this.numberOfFrames | 0
      if (!(nFrames > 1)) return { ok: false, reason: 'need-multiframe' }
      const inject = this.getMultiFrameIndex0 ? this.getMultiFrameIndex0() : 0
      const dataSet = this.image && this.image.data
      let frameMeans = null
      const baseId =
        dsaBaseImageId(this.imageId) ||
        dsaBaseImageId(this.image && this.image.imageId)

      // Muestrear medias si no hay ECG usable
      const probe = suggestCardiacMask({
        dataSet,
        numberOfFrames: nFrames,
        injectFrame: inject,
      })
      if (probe.method !== 'ecg' && baseId) {
        frameMeans = []
        const limit = Math.min(nFrames, 48)
        for (let i = 0; i < limit; i++) {
          try {
            const im = await cornerstone.loadAndCacheImage(`${baseId}?frame=${i}`)
            const pd = im && im.getPixelData && im.getPixelData()
            frameMeans.push(meanSubsample(pd, Math.max(1, (pd && pd.length / 2048) | 0)))
          } catch (e) {
            frameMeans.push(0)
          }
        }
      }

      const suggestion = suggestCardiacMask({
        dataSet,
        numberOfFrames: nFrames,
        injectFrame: inject,
        frameMeans,
      })
      this._dsa.gateMethod = suggestion.method
      return {
        ok: true,
        maskIndex: suggestion.maskIndex,
        method: suggestion.method,
        cycleFrames: suggestion.cycleFrames,
      }
    }

    /** Acciones del HUD cine → App.handleDsaMenuSelect (quiet). */
    handleDsaHudAction = (actionId) => {
      if (typeof this._onDsaMenuSelect === 'function') {
        this._onDsaMenuSelect(actionId, { quiet: true, fromHud: true })
      }
    }

    /**
     * Modalidad del viewport activo (para persistir layout del HUD).
     * @returns {string}
     */
    getDsaHudModality = () => {
      try {
        if (this.image && this.image.data && typeof this.image.data.string === 'function') {
          const m = this.image.data.string('x00080060')
          if (m) return normalizeDsaHudModality(m)
        }
      } catch (e) {
        /* ignore */
      }
      try {
        const f =
          Array.isArray(this.files) && this.files.length
            ? this.files[this.sliceIndex || 0] || this.files[0]
            : null
        if (f) {
          const m =
            (f.series && (f.series.modality || f.series.Modality)) ||
            f.modality ||
            f.Modality ||
            (f.image &&
              f.image.data &&
              typeof f.image.data.string === 'function' &&
              f.image.data.string('x00080060'))
          if (m) return normalizeDsaHudModality(m)
        }
      } catch (e) {
        /* ignore */
      }
      return 'DEFAULT'
    }

    /**
     * Recarga layout HUD desde localStorage según modalidad actual.
     */
    reloadDsaHudLayoutForModality = () => {
      const mod = this.getDsaHudModality()
      if (this._dsaHudModalityKey === mod && this.state.dsaHudLayout) return
      this._dsaHudModalityKey = mod
      const layout = loadDsaHudLayout(mod)
      this.setState({ dsaHudLayout: layout })
    }

    /**
     * Recarga layout del panel cine por modalidad.
     */
    reloadCinePanelLayoutForModality = () => {
      const mod = this.getDsaHudModality()
      if (this._cinePanelModalityKey === mod && this.state.cinePanelLayout) return
      this._cinePanelModalityKey = mod
      this.setState({
        cinePanelLayout: loadCinePanelLayout(mod),
        linkedPanelsLayout: loadLinkedPanelsLayout(mod),
      })
    }

    /**
     * Acopla DSA al cine (siempre free flotante, lado pegajoso).
     * @param {'left'|'right'} [dsaSide]
     * @param {{ x?: number|null, y?: number|null }} [opts]
     */
    relinkCineWithDsa = (dsaSide, opts = {}) => {
      const side = dsaSide === 'left' ? 'left' : 'right'
      const mod = this.getDsaHudModality()
      const fallback = {
        x: Math.max(8, Math.round((window.innerWidth || 360) / 2 - 180)),
        y: Math.max(8, (window.innerHeight || 640) - 220),
      }
      const x = Number.isFinite(Number(opts.x))
        ? Math.round(Number(opts.x))
        : (this.state.cinePanelLayout &&
            Number.isFinite(Number(this.state.cinePanelLayout.x)) &&
            Math.round(Number(this.state.cinePanelLayout.x))) ||
          fallback.x
      const y = Number.isFinite(Number(opts.y))
        ? Math.round(Number(opts.y))
        : (this.state.cinePanelLayout &&
            Number.isFinite(Number(this.state.cinePanelLayout.y)) &&
            Math.round(Number(this.state.cinePanelLayout.y))) ||
          fallback.y
      const cineLayout = { dock: 'free', x, y }
      const linked = { mode: 'free', x, y }
      const dsaLayout = {
        ...(this.state.dsaHudLayout || {}),
        dock: side,
        x: null,
        y: null,
      }
      this._cinePanelModalityKey = mod
      this._dsaHudModalityKey = mod
      saveCinePanelLayout(cineLayout, mod)
      saveLinkedPanelsLayout({ mode: 'bottom', x: null, y: null }, mod)
      saveDsaHudLayout(dsaLayout, mod)
      this._cineUserClosed = false
      this.setState({
        visibleCinePlayer: true,
        cinePanelLayout: cineLayout,
        linkedPanelsLayout: linked,
        dsaHudLayout: dsaLayout,
      })
    }

    /**
     * Desacopla cine y DSA conservando la posición visual actual de cada uno.
     */
    uncoupleFloatingPanels = () => {
      const mod = this.getDsaHudModality()
      const fallbackCine = {
        x: Math.max(8, Math.round((window.innerWidth || 360) / 2 - 150)),
        y: Math.max(8, (window.innerHeight || 640) - 220),
      }
      const fallbackDsa = {
        x: Math.max(8, Math.round((window.innerWidth || 360) / 2 + 160)),
        y: Math.max(8, (window.innerHeight || 640) - 280),
      }
      let cineX = fallbackCine.x
      let cineY = fallbackCine.y
      let dsaX = fallbackDsa.x
      let dsaY = fallbackDsa.y
      try {
        const cineEl = document.querySelector('[data-cine-controls="true"]')
        const dsaEl = document.querySelector('[data-dsa-cine-hud="true"]')
        if (cineEl) {
          const r = cineEl.getBoundingClientRect()
          if (r.width > 20) {
            cineX = Math.round(r.left)
            cineY = Math.round(r.top)
          }
        }
        if (dsaEl) {
          const r = dsaEl.getBoundingClientRect()
          if (r.width > 20) {
            dsaX = Math.round(r.left)
            dsaY = Math.round(r.top)
          }
        }
      } catch (e) {
        /* ignore */
      }
      const cineLayout = { dock: 'free', x: cineX, y: cineY }
      const dsaLayout = { dock: 'free', x: dsaX, y: dsaY }
      this._cinePanelModalityKey = mod
      this._dsaHudModalityKey = mod
      saveCinePanelLayout(cineLayout, mod)
      saveDsaHudLayout(dsaLayout, mod)
      this.setState({
        cinePanelLayout: cineLayout,
        dsaHudLayout: dsaLayout,
        linkedPanelsLayout: { mode: 'free', x: cineX, y: cineY },
      })
    }

    handleDsaHudLayoutChange = (nextLayout) => {
      const layout = {
        dock: nextLayout.dock || 'free',
        x: nextLayout.x != null ? Number(nextLayout.x) : null,
        y: nextLayout.y != null ? Number(nextLayout.y) : null,
      }
      const mod = this.getDsaHudModality()
      this._dsaHudModalityKey = mod

      if (
        (layout.dock === 'left' || layout.dock === 'right') &&
        (nextLayout.coupled || nextLayout.groupMode === 'free')
      ) {
        this.relinkCineWithDsa(layout.dock, { x: layout.x, y: layout.y })
        return
      }
      if (layout.dock === 'left' || layout.dock === 'right') {
        this.relinkCineWithDsa(layout.dock, { x: layout.x, y: layout.y })
        return
      }

      // free: desacoplar conservando posiciones actuales
      this.uncoupleFloatingPanels()
    }

    handleCinePanelLayoutChange = (nextLayout) => {
      const layout = {
        dock: 'free',
        x: nextLayout.x != null ? Number(nextLayout.x) : null,
        y: nextLayout.y != null ? Number(nextLayout.y) : null,
      }
      const mod = this.getDsaHudModality()
      this._cinePanelModalityKey = mod

      if (
        nextLayout.coupled &&
        nextLayout.dsaSide &&
        (nextLayout.dsaSide === 'left' || nextLayout.dsaSide === 'right') &&
        this.state.dsaHud &&
        this.state.dsaHud.enabled
      ) {
        this.relinkCineWithDsa(nextLayout.dsaSide, {
          x: layout.x,
          y: layout.y,
        })
        return
      }

      saveCinePanelLayout(layout, mod)
      // Si DSA sigue acoplado (left/right), mover el grupo free juntos
      const dsaDock =
        (this.state.dsaHudLayout && this.state.dsaHudLayout.dock) || 'free'
      if (
        this.state.dsaHud &&
        this.state.dsaHud.enabled &&
        (dsaDock === 'left' || dsaDock === 'right')
      ) {
        this.setState({
          cinePanelLayout: layout,
          linkedPanelsLayout: { mode: 'free', x: layout.x, y: layout.y },
        })
        return
      }
      this.setState({ cinePanelLayout: layout })
    }

    handleLinkedPanelsLayoutChange = (nextLayout) => {
      const vw = window.innerWidth || 360
      const vh = window.innerHeight || 640
      let x =
        nextLayout && nextLayout.x != null ? Number(nextLayout.x) : null
      let y =
        nextLayout && nextLayout.y != null ? Number(nextLayout.y) : null
      if (!Number.isFinite(x) || !Number.isFinite(y)) {
        x = Math.max(8, Math.round(vw / 2 - 180))
        y = Math.max(8, vh - 220)
      }
      x = Math.max(4, Math.min(vw - 80, x))
      y = Math.max(4, Math.min(vh - 80, y))
      const layout = { mode: 'free', x, y }
      const mod = this.getDsaHudModality()
      saveLinkedPanelsLayout(layout, mod)
      this.setState({
        linkedPanelsLayout: layout,
        cinePanelLayout: {
          dock: 'free',
          x,
          y,
        },
      })
    }

    /** Props comunes del panel DSA (dock / free). */
    getDsaHudElement = (opts) => {
      const hud = this.state.dsaHud
      if (!hud || !hud.enabled) return null
      const layout =
        this.state.dsaHudLayout || loadDsaHudLayout(this.getDsaHudModality())
      // No forzar dock:'free' (rompe botones de acople); solo coords si hace falta
      let effectiveLayout = layout
      if (
        opts &&
        opts.forceFree &&
        layout.dock === 'free' &&
        (!Number.isFinite(Number(layout.x)) || !Number.isFinite(Number(layout.y)))
      ) {
        effectiveLayout = {
          dock: 'free',
          x: Math.max(8, Math.round((window.innerWidth || 360) / 2 - 100)),
          y: Math.max(8, (window.innerHeight || 640) - 280),
        }
      }
      return (
        <DsaCineHud
          invertDSA={hud.invertDSA}
          gain={hud.gain}
          offset={hud.offset}
          noiseFloor={hud.noiseFloor}
          pixelShift={hud.pixelShift}
          maskFrameIndex={hud.maskFrameIndex}
          layout={effectiveLayout}
          inPlay={!!this.state.inPlay}
          onAction={this.handleDsaHudAction}
          onLayoutChange={this.handleDsaHudLayoutChange}
          onLinkedGroupMode={this.handleLinkedPanelsLayoutChange}
          onUncouple={this.uncoupleFloatingPanels}
        />
      )
    }

    /** Ajuste fino de máscara (default ±0.5 px). */
    nudgeDsaPixelShift = (dx, dy) => {
      if (!this._dsa || !this._dsa.enabled) return false
      const stepX = dx != null ? Number(dx) : 0
      const stepY = dy != null ? Number(dy) : 0
      this._dsa.pixelShift = {
        x:
          Math.round(
            (((this._dsa.pixelShift && this._dsa.pixelShift.x) || 0) + stepX) *
              10
          ) / 10,
        y:
          Math.round(
            (((this._dsa.pixelShift && this._dsa.pixelShift.y) || 0) + stepY) *
              10
          ) / 10,
      }
      this.refreshDsaFrame({ forceUpdate: true })
      this.syncDsaHudState()
      return true
    }

    getDsaPixelShift = () =>
      this._dsa && this._dsa.pixelShift
        ? {
            x: Number(this._dsa.pixelShift.x) || 0,
            y: Number(this._dsa.pixelShift.y) || 0,
          }
        : { x: 0, y: 0 }

    /**
     * shouldScroll: multi-SOP (files) o multi-frame (XA NumberOfFrames)
     * o totalImages conocido > 1 aunque el buffer aún sea parcial.
     */
    refreshScrollFlags = () => {
      const multi = this.numberOfFrames > 1
      const n = typeof this.getStackNavMax === 'function' ? this.getStackNavMax() : 1
      this.shouldScroll = multi || n > 1
      return this.shouldScroll
    }

    /**
     * Stack cornerstone de frames (imageId?frame=N) + wheel + cine auto.
     * @param {{ currentImageIdIndex: number, imageIds: string[] }} stack
     * @param {HTMLElement} [element]
     */
    applyMultiFrameStackState = (stack, element) => {
      const el = element || this.dicomImage
      if (!el || !(this.numberOfFrames > 1) || !stack || !stack.imageIds) return

      try {
        this.ensureToolsRegistered({ activateScroll: true })
      } catch (e) {
        /* ignore */
      }

      try {
        cornerstoneTools.addStackStateManager(el, ['stack', 'playClip'])
        // Quitar stack previo para no acumular states en re-display
        try {
          const existing = cornerstoneTools.getToolState(el, 'stack')
          if (existing && existing.data && existing.data.length) {
            cornerstoneTools.clearToolState(el, 'stack')
          }
        } catch (e2) {
          /* ignore */
        }
        cornerstoneTools.addToolState(el, 'stack', stack)
      } catch (e) {
        console.warn('DicomViewer - applyMultiFrameStackState stack:', e)
      }

      try {
        if (this.isToolRegisteredGlobally('StackScrollMouseWheel')) {
          cornerstoneTools.setToolEnabled('StackScrollMouseWheel')
          cornerstoneTools.setToolActive('StackScrollMouseWheel', {})
        }
      } catch (e) {
        /* ignore */
      }

      this._multiFrameStackActive = true
      this.sliceMax = this.numberOfFrames
      this.refreshScrollFlags()
      this.maybeAutoShowMultiFrameCine()
      this.markMultiFrameReady(0)
      this._mfStackImageIds = stack.imageIds
      this.scheduleMultiFramePreload()

      if (typeof this.props.onMultiFrameStackReady === 'function') {
        try {
          this.props.onMultiFrameStackReady(this.props.index, {
            frames: this.numberOfFrames,
            frame: 0,
          })
        } catch (err) {
          /* ignore */
        }
      }
    }

    /** File monofile MF (o SOP actual) para stamps de progreso de frames. */
    getMultiFrameFileData = () => {
      const files = this.files === null ? this.props.files : this.files
      if (!Array.isArray(files) || !files.length) return null
      if (files.length === 1) return files[0]
      return files[this.sliceIndex] || files[0] || null
    }

    initMultiFrameProgress = (fileData) => {
      const f = fileData || this.getMultiFrameFileData()
      if (!f || !(this.numberOfFrames > 1)) return
      if (!f.framesReadySet || typeof f.framesReadySet.add !== 'function') {
        f.framesReadySet = new Set()
      }
      if (f.framesReadyCount == null || !Number.isFinite(Number(f.framesReadyCount))) {
        f.framesReadyCount = 0
      }
    }

    markMultiFrameReady = (frame0) => {
      if (!(this.numberOfFrames > 1)) return
      const f = this.getMultiFrameFileData()
      if (!f) return
      this.initMultiFrameProgress(f)
      const idx = Math.max(0, Math.min(this.numberOfFrames - 1, frame0 | 0))
      f.framesReadySet.add(idx)
      f.framesReadyCount = f.framesReadySet.size
    }

    /**
     * Precarga idle de frames MF para ir pintando cuadraditos Oviyam.
     * Cancela corridas anteriores al rearmar el stack.
     */
    scheduleMultiFramePreload = () => {
      if (!(this.numberOfFrames > 1)) return
      const imageIds = this._mfStackImageIds
      if (!Array.isArray(imageIds) || !imageIds.length) return
      const gen = (this._mfPreloadGen = (this._mfPreloadGen || 0) + 1)
      const total = Math.min(this.numberOfFrames, imageIds.length)
      const run = async () => {
        for (let i = 0; i < total; i++) {
          if (gen !== this._mfPreloadGen || this._unmounted) return
          const f = this.getMultiFrameFileData()
          if (f && f.framesReadySet && f.framesReadySet.has(i)) continue
          try {
            await cornerstone.loadAndCacheImage(imageIds[i])
            if (gen !== this._mfPreloadGen) return
            this.markMultiFrameReady(i)
          } catch (e) {
            /* frame no cacheable aún */
          }
          if (i % 4 === 3) {
            await new Promise((r) => setTimeout(r, 0))
          }
        }
      }
      const start = () => {
        void run()
      }
      if (typeof requestIdleCallback === 'function') {
        try {
          requestIdleCallback(start, { timeout: 1500 })
          return
        } catch (e) {
          /* fallthrough */
        }
      }
      setTimeout(start, 40)
    }

    /**
     * Índice 0-based del frame multi-frame actual (tool stack o state.frame).
     */
    getMultiFrameIndex0 = () => {
      if (!(this.numberOfFrames > 1)) return 0
      try {
        const stackState = cornerstoneTools.getToolState(this.dicomImage, 'stack')
        if (stackState && stackState.data && stackState.data[0]) {
          const idx = stackState.data[0].currentImageIdIndex
          if (idx != null && !Number.isNaN(Number(idx))) {
            return Math.max(0, Math.min(this.numberOfFrames - 1, Number(idx)))
          }
        }
      } catch (e) {
        /* ignore */
      }
      return Math.max(0, (this.state.frame || 1) - 1)
    }

    notifyMultiFrameIndex = (frame0) => {
      const max = this.numberOfFrames || 1
      const idx = Math.max(0, Math.min(max - 1, frame0 | 0))
      this.markMultiFrameReady(idx)
      if (typeof this.props.onMultiFrameIndexChange !== 'function') return
      try {
        this.props.onMultiFrameIndexChange(this.props.index, idx, max)
      } catch (e) {
        /* ignore */
      }
    }

    /**
     * Avanza/retrocede N frames en multi-frame (XA). Usado por gestos y App.
     * @param {number} delta
     * @returns {boolean} true si se aplicó (modo multi-frame activo)
     */
    advanceMultiFrameBySteps = (delta) => {
      if (!(this.numberOfFrames > 1) || !delta) return false
      const element = this.dicomImage
      if (!element) return false

      const max = this.numberOfFrames
      let next = this.getMultiFrameIndex0() + delta
      while (next < 0) next += max
      while (next >= max) next -= max

      try {
        scrollToIndex(element, next)
      } catch (err) {
        console.warn('DicomViewer - advanceMultiFrameBySteps:', err)
        return false
      }

      this.setState({ frame: next + 1 }, () => {
        try {
          this.updateImageInfoDisplay({ light: true })
        } catch (e) {
          /* ignore */
        }
      })
      this.notifyMultiFrameIndex(next)
      // DSA: onNewImage ya envuelve getPixelData; no forceUpdate (rompe wheel/drag)
      return true
    }

    /**
     * Salta a un frame 0-based del multi-frame actual.
     * @param {number} index0
     * @returns {boolean}
     */
    gotoMultiFrameIndex = (index0) => {
      if (!(this.numberOfFrames > 1)) return false
      const element = this.dicomImage
      if (!element) return false
      const max = this.numberOfFrames
      const next = Math.max(0, Math.min(max - 1, index0 | 0))
      try {
        scrollToIndex(element, next)
      } catch (err) {
        console.warn('DicomViewer - gotoMultiFrameIndex:', err)
        return false
      }
      this.setState({ frame: next + 1 }, () => {
        try {
          this.updateImageInfoDisplay({ light: true })
        } catch (e) {
          /* ignore */
        }
      })
      this.notifyMultiFrameIndex(next)
      // DSA: onNewImage ya envuelve getPixelData; no forceUpdate (rompe wheel/drag)
      return true
    }

    /**
     * FPS de cine desde tags DICOM / descripción de serie (p.ej. "15 fps").
     * Respeta ajuste manual del usuario hasta el próximo cambio de serie.
     * @param {object|null|undefined} image
     * @param {object|null|undefined} fileData
     * @returns {number}
     */
    getResolvedCineFps = (image, fileData) => {
      if (this._cineFpsUserSet) {
        return Math.max(1, Math.min(60, this.state.cineFps || 30))
      }
      const multi =
        this.numberOfFrames > 1 ||
        (typeof this.isMultiFrameCine === 'function' && this.isMultiFrameCine())
      const defaultFps = multi ? 30 : 15
      const file =
        fileData ||
        (this.files && this.files[this.sliceIndex]) ||
        (this.files && this.files[0]) ||
        null
      const resolved = resolveCineFps({
        image: image || this.image || null,
        file,
        defaultFps,
      })
      this._cineFpsSource = resolved.source
      return resolved.fps
    }

    /**
     * Aplica FPS detectado al state (sin pisar slider manual).
     * @param {object|null|undefined} image
     * @param {object|null|undefined} fileData
     */
    applyCineFpsFromStudy = (image, fileData) => {
      if (this._cineFpsUserSet) return
      const fps = this.getResolvedCineFps(image, fileData)
      if (fps == null || fps === this.state.cineFps) return
      this.setState({ cineFps: fps })
    }

    /**
     * Abre el overlay de cine al detectar multi-frame (salvo que el usuario lo haya cerrado).
     */
    maybeAutoShowMultiFrameCine = () => {
      if (!(this.numberOfFrames > 1)) return
      if (this._pendingCineResume) {
        // Cambio de serie con cine activo: resume dedicado
        this.maybeResumeCineAfterSeriesChange()
        return
      }
      if (this._cineUserClosed) {
        this.setState({ frame: 1 })
        return
      }
      const fileHint =
        (this.files && this.files[this.sliceIndex]) ||
        (this.files && this.files[0]) ||
        null
      const fps = this.getResolvedCineFps(this.image, fileHint)
      this.setState({
        frame: 1,
        visibleCinePlayer: true,
        cineFps: fps,
      })
    }

    /**
     * Tras cambiar de serie: reabrir cine y continuar play si venía reproduciendo.
     */
    maybeResumeCineAfterSeriesChange = () => {
      const pending = this._pendingCineResume
      if (!pending) return
      this._pendingCineResume = null

      if (typeof this.canUseCine === 'function' && !this.canUseCine()) {
        if (this.state.visibleCinePlayer || this.state.inPlay) {
          this.setState({ visibleCinePlayer: false, inPlay: false })
        }
        return
      }

      this._cineUserClosed = false
      const fileHint =
        (this.files && this.files[this.sliceIndex]) ||
        (this.files && this.files[0]) ||
        null
      // Preferir FPS del estudio nuevo (no arrastrar 30 del default de la serie previa)
      const nextFps = this.getResolvedCineFps(this.image, fileHint)
      const nextLoop = pending.loop != null ? pending.loop : this.state.cineLoop !== false

      this.setState(
        {
          visibleCinePlayer: pending.visible !== false,
          cineFps: nextFps,
          cineLoop: nextLoop,
          frame: this.isMultiFrameCine() ? this.state.frame || 1 : this.state.frame,
        },
        () => {
          if (!pending.play) return
          // Esperar a que stack/multi-frame y paint estén listos
          const tryPlay = (attempt) => {
            if (typeof this.canUseCine === 'function' && !this.canUseCine()) {
              if (attempt < 8) {
                setTimeout(() => tryPlay(attempt + 1), 50 + attempt * 30)
              }
              return
            }
            if (this.state.inPlay) return
            try {
              this.runCinePlayer('play')
            } catch (e) {
              /* ignore */
            }
            if (!this.state.inPlay && attempt < 8) {
              setTimeout(() => tryPlay(attempt + 1), 60 + attempt * 40)
            }
          }
          setTimeout(() => tryPlay(0), 40)
        }
      )
    }

    /** Evita que toques en el cine lleguen a Hammer/Cornerstone del viewport. */
    stopCinePointer = (e) => {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation()
      }
    }

    getCineTotal = () => {
      if (this.isMultiFrameCine()) return this.numberOfFrames
      if (this.isMprGenerated && this.sliceMax > 1) return this.sliceMax
      return Math.max(
        1,
        this.sliceMax || 0,
        (this.files && this.files.length) || 0
      )
    }

    getCinePosition = () => {
      if (this.isMultiFrameCine()) {
        if (typeof this.getMultiFrameIndex0 === 'function') {
          return this.getMultiFrameIndex0() + 1
        }
        return this._domFrame1 || this.state.frame || 1
      }
      return (this.sliceIndex || 0) + 1
    }

    /**
     * Tras soft-sync: el buffer (imágenes ya decodificadas) creció.
     * Actualiza UI de cine y reanuda si se había pausado al final del buffer.
     */
    afterStackBufferGrew = (prevLen, nextLen) => {
      this._scrollStackRef = null
      this._scrollStackUid = null
      this._scrollStackLen = 0
      if (!(nextLen > prevLen)) {
        // Aun sin crecimiento, reafirmar max en barra/contador si cine está abierto
        if (this.state.visibleCinePlayer || this.state.inPlay) {
          this.syncCineBufferUi()
        }
        return
      }
      this.syncCineBufferUi()
      const waiting = !!this._cineWaitingBuffer
      const atOldEnd =
        waiting ||
        (this.sliceIndex != null && this.sliceIndex >= Math.max(0, prevLen - 1))
      if (waiting || (atOldEnd && this._cineResumeOnBufferGrow)) {
        this._cineWaitingBuffer = false
        this._cineResumeOnBufferGrow = false
        if (this.state.visibleCinePlayer && !this.state.inPlay) {
          try {
            this.runCinePlayer('play')
          } catch (e) {
            /* ignore */
          }
        }
      }
    }

    syncCineBufferUi = () => {
      const max = this.getCineTotal()
      const idx = this.isMultiFrameCine()
        ? this.getMultiFrameIndex0()
        : this.sliceIndex || 0
      try {
        this.paintFrameCountersDom(idx + 1, max)
      } catch (e) {
        /* ignore */
      }
      this.syncCineScrollbar()
      if (this.state.visibleCinePlayer && !this.state.inPlay) {
        try {
          this.forceUpdate()
        } catch (e) {
          /* ignore */
        }
      }
    }

    stopStackCineTimer = () => {
      if (this._stackCineRaf != null) {
        try {
          cancelAnimationFrame(this._stackCineRaf)
        } catch (e) {
          /* ignore */
        }
        this._stackCineRaf = null
      }
      if (this._stackCineTimer) {
        clearInterval(this._stackCineTimer)
        this._stackCineTimer = null
      }
      if (this._cineBusyWatchdog) {
        clearTimeout(this._cineBusyWatchdog)
        this._cineBusyWatchdog = null
      }
      this._cineLastTs = 0
      this._cineAccMs = 0
      this._cinePaintBusy = false
    }

    notifyCineSliceChange = (index) => {
      if (typeof this.props.onCineSliceChange === 'function') {
        try {
          this.props.onCineSliceChange(index, this.props.index)
        } catch (err) {
          // ignore
        }
      }
    }

    mprCineSliceMax = () => {
      if (this.isMprGenerated && this.sliceMax > 1) return this.sliceMax
      return Math.max(
        1,
        this.sliceMax || 0,
        (this.files && this.files.length) || 0
      )
    }

    seekMprCineSlice = (idx, opts = {}) => {
      if (typeof this.props.onSliceSeek !== 'function') return false
      this.props.onSliceSeek(this.props.index, idx)
      const max = this.mprCineSliceMax()
      const lightUi = !!(opts.lightUi || this.state.inPlay)
      if (lightUi) {
        try {
          this.paintFrameCountersDom(idx + 1, max)
        } catch (e) {
          /* ignore */
        }
        this.syncCineScrollbar()
        if (typeof this.props.onScrollSlicePaint === 'function') {
          try {
            this.props.onScrollSlicePaint(this.props.index, idx)
          } catch (ePaint) {
            /* ignore */
          }
        }
      } else {
        this.notifyCineSliceChange(idx)
        this.forceUpdate()
      }
      return true
    }

    /**
     * Avanza/retrocede un corte del stack (modo cine multipase).
     * En MPR usa onSliceSeek para proyectar thin durante el play.
     * @param {number} delta
     * @param {{ lightUi?: boolean }} [opts]
     * @returns {boolean} false si loop off y llegó al límite
     */
    stackCineStep = (delta, opts = {}) => {
      const mprCine = !!this.props.mprLayoutActive || !!(this.isMprGenerated && this.sliceMax > 1)
      const max = mprCine
        ? this.mprCineSliceMax()
        : Math.max(
            this.sliceMax || 0,
            (this.files && this.files.length) || 0
          )
      if (!max) return false
      let idx = (this.sliceIndex || 0) + delta
      if (idx >= max) {
        if (!this.state.cineLoop) {
          // Fin del buffer actual: marcar para reanudar si llegan más imágenes
          this._cineWaitingBuffer = true
          this._cineResumeOnBufferGrow = true
          return false
        }
        idx = 0
      } else if (idx < 0) {
        if (!this.state.cineLoop) return false
        idx = max - 1
      } else {
        this._cineWaitingBuffer = false
      }
      if (mprCine && this.seekMprCineSlice(idx, opts)) return true
      this.sliceIndex = idx
      this.displayImageFromFiles(idx)

      const lightUi = !!(opts.lightUi || this.state.inPlay)
      if (lightUi) {
        try {
          this.paintFrameCountersDom(idx + 1, max)
        } catch (e) {
          /* ignore */
        }
        this.syncCineScrollbar()
        // Oviyam grilla / scout: mismo camino throttled que scroll (sin setState storm)
        if (typeof this.props.onScrollSlicePaint === 'function') {
          try {
            this.props.onScrollSlicePaint(this.props.index, idx)
          } catch (ePaint) {
            /* ignore */
          }
        }
      } else {
        this.notifyCineSliceChange(idx)
        this.forceUpdate()
      }
      return true
    }

    stackCineGoto = (index) => {
      const mprCine = !!this.props.mprLayoutActive || !!(this.isMprGenerated && this.sliceMax > 1)
      const max = mprCine
        ? this.mprCineSliceMax()
        : Math.max(
            this.sliceMax || 0,
            (this.files && this.files.length) || 0
          )
      if (!max) return
      const idx = Math.max(0, Math.min(max - 1, index))
      if (mprCine && this.seekMprCineSlice(idx)) return
      this.sliceIndex = idx
      this.displayImageFromFiles(idx)
      this.notifyCineSliceChange(idx)
      this.forceUpdate()
    }

    /**
     * Un paso de cine multi-frame (XA). Misma semántica que stackCineStep.
     * @param {number} delta
     * @param {{ lightUi?: boolean }} [opts]
     * @returns {boolean} false si loop off y llegó al límite
     */
    multiFrameCineStep = (delta, opts = {}) => {
      const max = this.numberOfFrames
      if (!(max > 1) || !delta) return false
      const element = this.dicomImage
      if (!element) return false

      let idx = this.getMultiFrameIndex0() + delta
      if (idx >= max) {
        if (!this.state.cineLoop) return false
        idx = 0
      } else if (idx < 0) {
        if (!this.state.cineLoop) return false
        idx = max - 1
      }

      try {
        scrollToIndex(element, idx)
      } catch (err) {
        console.warn('DicomViewer - multiFrameCineStep:', err)
        return false
      }

      const lightUi = !!(opts.lightUi || this.state.inPlay)
      if (lightUi) {
        try {
          this.paintFrameCountersDom(idx + 1, max)
        } catch (e) {
          /* ignore */
        }
        this.syncCineScrollbar()
        this.markMultiFrameReady(idx)
        if (typeof this.props.onScrollSlicePaint === 'function') {
          try {
            this.props.onScrollSlicePaint(this.props.index, idx)
          } catch (ePaint) {
            /* ignore */
          }
        }
      } else {
        this.paintFrameCountersDom(idx + 1, max)
        this.setState({ frame: idx + 1 })
        this.notifyMultiFrameIndex(idx)
      }
      return true
    }

    /**
     * Tras pausar cine: reactivar scroll y sincronizar índice (sin setState storm).
     */
    restoreNavigationAfterCine = () => {
      try {
        this.ensureToolsRegistered({ activateScroll: true })
      } catch (e) {
        /* ignore */
      }
      try {
        if (this.isMultiFrameCine()) {
          const idx = this.getMultiFrameIndex0()
          const max = this.numberOfFrames || 1
          this.paintFrameCountersDom(idx + 1, max)
          this.syncCineScrollbar()
          if (this.state.frame !== idx + 1) {
            this.setState({ frame: idx + 1 })
          }
          this.notifyMultiFrameIndex(idx)
        }
      } catch (e) {
        /* ignore */
      }
    }

    startStackCinePlay = () => {
      this.stopStackCineTimer()
      // Cancelar playClip de cornerstone (encola loadAndCacheImage en paralelo y
      // tras pause los then() siguen pintando → scroll/cine quedan muertos)
      try {
        if (this.dicomImage) cornerstoneTools.stopClip(this.dicomImage)
      } catch (e) {
        /* ignore */
      }

      const fps = Math.max(1, Math.min(60, this.state.cineFps || 15))
      const frameMs = 1000 / fps
      this.setState({ inPlay: true })
      this._cineLastTs = 0
      this._cineAccMs = 0

      const tick = (ts) => {
        if (!this.state.inPlay) {
          this._stackCineRaf = null
          return
        }
        if (!this._cineLastTs) this._cineLastTs = ts
        const dt = ts - this._cineLastTs
        this._cineLastTs = ts
        this._cineAccMs += dt

        // Como mucho 1 frame por vsync; espera onNewImage antes del siguiente
        // (scrollToIndex es async — si liberamos busy al toque, se encola decode)
        if (this._cineAccMs >= frameMs && !this._cinePaintBusy) {
          this._cineAccMs -= frameMs
          if (this._cineAccMs > frameMs) this._cineAccMs = 0
          this._cinePaintBusy = true
          let ok = true
          try {
            ok = this.isMultiFrameCine()
              ? this.multiFrameCineStep(1, { lightUi: true })
              : this.stackCineStep(1, { lightUi: true })
          } catch (eStep) {
            ok = false
            this._cinePaintBusy = false
          }
          if (!ok) {
            this._cinePaintBusy = false
            this.stopStackCineTimer()
            this.setState({ inPlay: false }, () => {
              if (this.isMultiFrameCine()) {
                this.notifyMultiFrameIndex(this.getMultiFrameIndex0())
              } else {
                this.notifyCineSliceChange(this.sliceIndex || 0)
              }
              this.restoreNavigationAfterCine()
            })
            return
          }
          // Safety: si newimage no llega (error de carga), no quedar trabado
          if (this._cineBusyWatchdog) clearTimeout(this._cineBusyWatchdog)
          this._cineBusyWatchdog = setTimeout(() => {
            this._cineBusyWatchdog = null
            if (this.state.inPlay) this._cinePaintBusy = false
          }, Math.max(120, frameMs * 3))
        }

        this._stackCineRaf = requestAnimationFrame(tick)
      }
      this._stackCineRaf = requestAnimationFrame(tick)
    }

    handleCineLoopChange = (loop) => {
      this.setState({ cineLoop: !!loop })
    }

    handleCineFpsChange = (fps) => {
      const next = Math.max(1, Math.min(60, Math.round(Number(fps) || 15)))
      this._cineFpsUserSet = true
      this._cineFpsSource = 'user'
      this.setState({ cineFps: next }, () => {
        if (!this.state.inPlay) return
        // Reiniciar a la nueva tasa (multi-frame y stack usan el mismo rAF)
        if (this.isMultiFrameCine() || this.isStackCine()) {
          this.startStackCinePlay()
        }
      })
    }

    runCinePlayer = (cmdName) => {
      const element = this.dicomImage
      const multi = this.isMultiFrameCine()
      const stack = this.isStackCine()

      switch (cmdName) {
        case 'firstframe': {
          if (multi) {
            this.setState({ frame: 1 })
            if (element) scrollToIndex(element, 0)
          } else if (stack) {
            this.stackCineGoto(0)
          }
          break
        }
        case 'previousframe': {
          if (multi) {
            if (this.state.frame > 1) {
              const frame = this.state.frame - 1
              this.setState({ frame })
              if (element) scrollToIndex(element, frame - 1)
            } else if (this.state.cineLoop) {
              const frame = this.numberOfFrames
              this.setState({ frame })
              if (element) scrollToIndex(element, frame - 1)
            }
          } else if (stack) {
            if (!(this.sliceIndex > 0) && !this.state.cineLoop) break
            this.stackCineStep(-1)
          }
          break
        }
        case 'play': {
          this._cineWaitingBuffer = false
          this._cineResumeOnBufferGrow = false
          if (multi || stack) {
            // Un solo camino rAF (no playClip): evita cola de decodes tras pause
            this.startStackCinePlay()
          }
          break
        }
        case 'pause': {
          this.stopStackCineTimer()
          if (element) {
            try {
              cornerstoneTools.stopClip(element)
            } catch (err) {
              // ignore
            }
          }
          this.setState({ inPlay: false }, () => {
            if (this.isStackCine()) {
              this.notifyCineSliceChange(this.sliceIndex || 0)
            }
            this.restoreNavigationAfterCine()
          })
          break
        }
        case 'nextframe': {
          if (multi) {
            if (this.state.frame < this.numberOfFrames) {
              const frame = this.state.frame + 1
              this.setState({ frame })
              if (element) scrollToIndex(element, frame - 1)
            } else if (this.state.cineLoop) {
              this.setState({ frame: 1 })
              if (element) scrollToIndex(element, 0)
            }
          } else if (stack) {
            this.stackCineStep(1)
          }
          break
        }
        case 'lastframe': {
          if (multi) {
            const frame = this.numberOfFrames
            this.setState({ frame })
            if (element) scrollToIndex(element, frame - 1)
          } else if (stack) {
            const max = Math.max(
              this.sliceMax || 0,
              (this.files && this.files.length) || 0
            )
            if (max > 0) this.stackCineGoto(max - 1)
          }
          break
        }
        default:
          break
      }
    }

    _resetFitRaf = null
    _doubleTapZoomed = false   // true = actualmente en zoom-in por doble tap

    /**
     * Toggle doble tap:
     *   - Si está en fit (o scale ≈ fitScale) → zoom 2× centrado en el punto tocado.
     *   - Si ya hay zoom → vuelve a fit animado.
     * @param {number} clientX
     * @param {number} clientY
     */
    toggleDoubleTapZoom = (clientX, clientY) => {
      if (this._suppressFitToggleUntil && Date.now() < this._suppressFitToggleUntil) {
        return
      }
      if (this._magnifyMode || this.props.tool === 'Magnify') {
        this.exitMagnifyToNoTool()
        return
      }

      const element = this.dicomImage
      if (!element || !this.image) return

      let fitViewport
      try {
        fitViewport = cornerstone.getDefaultViewportForImage(element, this.image)
      } catch (e) {
        fitViewport = null
      }
      let viewport
      try {
        viewport = cornerstone.getViewport(element)
      } catch (e) {
        return
      }
      if (!viewport) return

      const fitScale = fitViewport && fitViewport.scale != null ? fitViewport.scale : viewport.scale
      const fitTx = fitViewport && fitViewport.translation ? (fitViewport.translation.x || 0) : 0
      const fitTy = fitViewport && fitViewport.translation ? (fitViewport.translation.y || 0) : 0

      const curScale = viewport.scale != null ? viewport.scale : fitScale
      const curTx = viewport.translation ? (viewport.translation.x || 0) : 0
      const curTy = viewport.translation ? (viewport.translation.y || 0) : 0

      // Detecta "estoy realmente en fit" con tolerancias chicas.
      // Si NO estamos en fit (hay zoom/pan previo), doble tap vuelve a fit directo.
      const scaleEps = Math.max(0.001, fitScale * 0.02) // 2%
      const translationEps = Math.max(2, Math.abs(fitTx) * 0.02, Math.abs(fitTy) * 0.02)

      const atFit =
        Math.abs(curScale - fitScale) <= scaleEps &&
        Math.abs(curTx - fitTx) <= translationEps &&
        Math.abs(curTy - fitTy) <= translationEps

      if (atFit) {
        // Zoom 2× centrado en el punto tocado
        const ZOOM_FACTOR = 2.5
        const targetScale = fitScale * ZOOM_FACTOR

        // Calcular traslación para centrar el zoom en el punto tocado.
        // Cornerstone transform: canvasX = (imgX - w/2 + tx) * scale + canvasW/2
        // → El punto de imagen bajo el toque: imgPtX = offX/fitScale - fitTx + w/2
        //   (donde offX = clientX - canvasCenterX en px de canvas)
        // Para que ese punto quede centrado con targetScale: targetTx = -(imgPtX - w/2)
        //   → targetTx = fitTx - offX/fitScale
        const rect = element.getBoundingClientRect()
        const elCx = rect.left + rect.width / 2
        const elCy = rect.top + rect.height / 2
        // DPR: el canvas puede estar escalado respecto al CSS
        let dpr = 1
        try {
          const ce = cornerstone.getEnabledElement(element)
          if (ce && ce.canvas) dpr = ce.canvas.width / rect.width || 1
        } catch (e) { /* ignore */ }
        const offX = (clientX - elCx) * dpr
        const offY = (clientY - elCy) * dpr
        const targetTx = fitTx - offX / fitScale
        const targetTy = fitTy - offY / fitScale

        this._doubleTapZoomed = true
        this._animateFit(viewport, targetScale, targetTx, targetTy)
      } else {
        // Volver a fit
        this._doubleTapZoomed = false
        this._animateFit(viewport, fitScale, fitTx, fitTy)
      }
    }

    /**
     * Anima el viewport desde el estado actual hacia (targetScale, targetTx, targetTy).
     * Ease-out cúbico, 280 ms.
     */
    _animateFit = (snapshotViewport, targetScale, targetTx, targetTy) => {
      const element = this.dicomImage
      if (!element) return

      if (this._resetFitRaf != null) {
        cancelAnimationFrame(this._resetFitRaf)
        this._resetFitRaf = null
      }

      const startScale = snapshotViewport.scale
      const startTx = snapshotViewport.translation ? snapshotViewport.translation.x : 0
      const startTy = snapshotViewport.translation ? snapshotViewport.translation.y : 0

      const eps = 0.001
      if (
        Math.abs(startScale - targetScale) < eps &&
        Math.abs(startTx - targetTx) < eps &&
        Math.abs(startTy - targetTy) < eps
      ) return

      const DURATION = 280
      const startTime = performance.now()
      const easeOut = (t) => 1 - Math.pow(1 - t, 3)

      const animate = (now) => {
        const t = Math.min((now - startTime) / DURATION, 1)
        const e = easeOut(t)
        let vp
        try { vp = cornerstone.getViewport(element) } catch (err) { return }
        if (!vp) return
        vp.scale = startScale + (targetScale - startScale) * e
        vp.translation = {
          x: startTx + (targetTx - startTx) * e,
          y: startTy + (targetTy - startTy) * e,
        }
        try { cornerstone.setViewport(element, vp) } catch (err) { return }
        if (t < 1) {
          this._resetFitRaf = requestAnimationFrame(animate)
        } else {
          this._resetFitRaf = null
        }
      }
      this._resetFitRaf = requestAnimationFrame(animate)
    }

    resetFitOnly = () => {
      const element = this.dicomImage
      if (!element || !this.image) return
      let fitViewport
      try {
        fitViewport = cornerstone.getDefaultViewportForImage(element, this.image)
      } catch (e) {
        fitViewport = null
      }
      let viewport
      try {
        viewport = cornerstone.getViewport(element)
      } catch (e) {
        return
      }
      if (!viewport) return
      let targetScale = viewport.scale
      let targetTx = viewport.translation ? viewport.translation.x : 0
      let targetTy = viewport.translation ? viewport.translation.y : 0
      if (fitViewport) {
        if (fitViewport.scale != null) targetScale = fitViewport.scale
        targetTx = fitViewport.translation ? (fitViewport.translation.x || 0) : 0
        targetTy = fitViewport.translation ? (fitViewport.translation.y || 0) : 0
      } else {
        try {
          const fit = cornerstone.getDefaultViewport(element, this.image)
          if (fit) {
            if (fit.scale != null) targetScale = fit.scale
            if (fit.translation) { targetTx = fit.translation.x || 0; targetTy = fit.translation.y || 0 }
          }
        } catch (e) { /* usa valores actuales */ }
      }
      this._doubleTapZoomed = false
      this._animateFit(viewport, targetScale, targetTx, targetTy)
    }

    reset = () => {
        const element = this.dicomImage
        if (!element || !this.image) return

        // PREVIEW: WW/WC e invert son filtro CSS (render no usa VOI nativo)
        const useCssWwwc =
          (typeof this.shouldUseCssWwwc === 'function' && this.shouldUseCssWwwc()) ||
          this.getAppRenderMode() === RENDER_MODE.PREVIEW
        if (useCssWwwc) {
          this._previewWwwc = { brightness: 1, contrast: 1, invert: false }
          this._cssWwwcDragging = false
          this._cssWwwcMode = false
          try {
            this.clearPreviewWwwcCss()
          } catch (e) {
            /* ignore */
          }
          // Overlay WW/WC a default
          try {
            const mrbottomleft = document.getElementById(
              `mrbottomleft-${this.props.index}`
            )
            if (mrbottomleft) {
              mrbottomleft.textContent = 'WW/WC: 255/128'
            }
          } catch (e) {
            /* ignore */
          }
        }

        try {
          if (!cornerstone.getEnabledElement(element)) return
        } catch (e) {
          return
        }

        let defaultViewport
        try {
          defaultViewport = cornerstone.getDefaultViewportForImage(element, this.image)
        } catch (e) {
          console.warn('DicomViewer - reset: default viewport:', e)
          defaultViewport = null
        }
        let viewport
        try {
          viewport = cornerstone.getViewport(element)
        } catch (e) {
          return
        }
        if (!viewport) return

        if (defaultViewport && defaultViewport.voi) {
          viewport.voi.windowWidth = defaultViewport.voi.windowWidth
          viewport.voi.windowCenter = defaultViewport.voi.windowCenter
        } else if (this.image) {
          viewport.voi = viewport.voi || {}
          if (this.shouldUseCssWwwc()) {
            applyNeutralWebPreviewVoi(viewport)
          } else {
            viewport.voi.windowWidth =
              this.image.windowWidth != null ? this.image.windowWidth : 255
            viewport.voi.windowCenter =
              this.image.windowCenter != null ? this.image.windowCenter : 128
          }
        }
        viewport.invert = false
        if (defaultViewport) {
          if (defaultViewport.scale != null) viewport.scale = defaultViewport.scale
          if (defaultViewport.translation) {
            viewport.translation = {
              x: defaultViewport.translation.x || 0,
              y: defaultViewport.translation.y || 0,
            }
          } else {
            viewport.translation = { x: 0, y: 0 }
          }
          if (defaultViewport.rotation != null) viewport.rotation = defaultViewport.rotation
          else viewport.rotation = 0
          if (typeof defaultViewport.hflip === 'boolean') viewport.hflip = defaultViewport.hflip
          else viewport.hflip = false
          if (typeof defaultViewport.vflip === 'boolean') viewport.vflip = defaultViewport.vflip
          else viewport.vflip = false
        } else {
          // Fallback: fit-to-window simple
          try {
            const fit = cornerstone.getDefaultViewport(element, this.image)
            if (fit) {
              if (fit.scale != null) viewport.scale = fit.scale
              if (fit.translation) viewport.translation = fit.translation
            }
          } catch (e) {
            viewport.translation = { x: 0, y: 0 }
            viewport.rotation = 0
          }
        }
        try {
          cornerstone.setViewport(element, viewport)
        } catch (e) {
          console.warn('DicomViewer - reset setViewport:', e)
        }

        // Resetear el estado de las herramientas para la serie actual
        if (this.image) {
            const seriesUID =
              this.safeImageString(this.image, 'x0020000e', null) ||
              (typeof this.getActiveSeriesUidKey === 'function'
                ? this.getActiveSeriesUidKey()
                : null)
            if (seriesUID && this.toolState[seriesUID]) {
                delete this.toolState[seriesUID]
            }
            // Olvidar VOI de sesión (slot + global) para no reaplicar al reabrir
            if (
              seriesUID &&
              typeof this.props.onWwwcSessionClear === 'function'
            ) {
              try {
                this.props.onWwwcSessionClear(this.props.index, seriesUID)
              } catch (eClr) {
                /* ignore */
              }
            }
            try {
              const vpWw =
                defaultViewport && defaultViewport.voi
                  ? defaultViewport.voi.windowWidth
                  : null
              const vpWc =
                defaultViewport && defaultViewport.voi
                  ? defaultViewport.voi.windowCenter
                  : null
              if (vpWw != null && vpWc != null) {
                this._logicalWwwc = { ww: vpWw, wc: vpWc }
              }
            } catch (eLog) {
              /* ignore */
            }
        }

        // Limpiar las mediciones si existen (solo en DIAG típicamente)
        if (this.measurements && this.measurements.length > 0) {
            this.measurementClear()
            try {
              cornerstoneTools.clearToolState(element)
            } catch (e) {
              /* ignore */
            }
            if (this.sopInstanceUid) {
                try {
                  db.measurement.where('sopinstanceuid').equals(this.sopInstanceUid).delete()
                } catch (e) {
                  /* ignore */
                }
            }
            try {
              this.props.setActiveMeasurements([])
            } catch (e) {
              /* ignore */
            }
        }

        // Actualizar la imagen para reflejar los cambios
        try {
          cornerstone.updateImage(element)
        } catch (e) {
          /* ignore */
        }
        this._doubleTapZoomed = false
        try {
          if (typeof cornerstone.fitToWindow === 'function') {
            cornerstone.fitToWindow(element)
          }
        } catch (e) {
          /* ignore */
        }
        // Re-aplicar filtro neutro tras paint (canvas puede recrearse)
        if (useCssWwwc) {
          try {
            this.clearPreviewWwwcCss()
            this.applyPreviewWwwcCss({ redraw: true })
          } catch (e) {
            /* ignore */
          }
        }
    }

    // -------------------------------------------------------------------------------------------- MPR
    //#region MPR

    mprPlanePosition = () => {
      try {
        // Planos MPR reconstruidos: no inferir IOP del stack nativo (sería siempre axial)
        if (this.isMprGenerated && this.mprPlane) return this.mprPlane
        const files = this.files || []
        const f = files[this.sliceIndex] || files[0]
        const iop = readFileIop(f) || readFileIop({ image: this.image })
        const named = planeNameFromNormal(planeNormalFromIop(iop))
        if (named) {
          this.mprPlane = named
          return this.mprPlane
        }
        if (!this.isDicom) return this.mprPlane
        if (!this.files || !this.files[0] || !this.files[0].image || !this.files[0].image.data) {
          this.mprPlane = ''
          return this.mprPlane
        }
        const image = this.files[0].image
        const iopRaw = image.data.string('x00200037')
        if (!iopRaw) {
          this.mprPlane = ''
          return this.mprPlane
        }
        const imageOrientation = iopRaw.split('\\')
        let v = new Array(6).fill(0)
        v[0] = parseFloat(imageOrientation[0]) // the x direction cosines of the first row X
        v[1] = parseFloat(imageOrientation[1]) // the y direction cosines of the first row X
        v[2] = parseFloat(imageOrientation[2]) // the z direction cosines of the first row X
        v[3] = parseFloat(imageOrientation[3]) // the x direction cosines of the first column Y
        v[4] = parseFloat(imageOrientation[4]) // the y direction cosines of the first column Y
        v[5] = parseFloat(imageOrientation[5]) // the z direction cosines of the first column Y    
        v = v.map((x) => Math.round(x))
        let p = [v[1]*v[5] - v[2]*v[4], v[2]*v[3] - v[0]*v[5], v[0]*v[4] - v[1]*v[3]] // cross product of X x Y
        p = p.map((x) => Math.abs(x))
        if (p[0] === 1) {
          this.mprPlane = 'sagittal'
        } else if (p[1] === 1) {
          this.mprPlane = 'coronal'
        } else if (p[2] === 1) {
          this.mprPlane = 'axial'
        }
      } catch(error) { // it's not possible to build MPR
        this.mprPlane = ''
      } 
      return this.mprPlane 
    }

    transpose = (matrix) => {
      return Object.keys(matrix[0]).map(colNumber => matrix.map(rowNumber => rowNumber[colNumber]));
    }

    mprRenderYZPlane = (filename, origin, x, mprData) => {
      // Volumen en RAM (full) o files listos (light on-demand)
      const files = this.files === null ? this.props.files : this.files
      if ((!this.volume || !this.volume.length) && !(files && files.length)) return

      this.mprData = mprData || this.mprData || {}
      ensureMprStackGeometry(files, this.mprData)

      this.sliceIndex = x
      
      this.filename = filename
      this._mprOriginPlane = origin || 'axial'
      // No disable: evita flash negro en cada scroll

      if (origin === 'sagittal')
        this.mprPlane = 'coronal'
      else if (origin === 'axial')
        this.mprPlane = 'sagittal'
      else if (origin === 'coronal')
        this.mprPlane = 'sagittal'
      else this.mprPlane = 'sagittal'

      this._mprPlaneKind = 'yz'

      this.xSize = (files[0].columns != null ? files[0].columns : files[0].image.columns)
      this.ySize = (files[0].rows != null ? files[0].rows : files[0].image.rows)
      // Z = nº de cortes del stack (1:1), nunca matrix size (p.ej. 512)
      this.zSize = files.length
      if (this.mprData) this.mprData.zDim = files.length

      const i = Math.max(0, Math.min(files.length - 1, Math.round((x / Math.max(1, this.xSize - 1)) * (files.length - 1))))
      this.originImage = (files[i] && files[i].image) || (files[0] && files[0].image)
      if (!this.originImage) return

      const flipZ = shouldFlipMprZ(files, this.mprData)
      if (this.mprData) this.mprData.flipZ = flipZ
      const yzPlane = this.mprBuildYZPlane(x, flipZ)
      this.loadImageFromCustomObject(this.ySize, this.zSize, yzPlane, this.mprPlaneSpacing('yz'), {
        kind: 'yz',
        sliceIndex: x,
        files,
        mprData: this.mprData,
      })
    }

    mprBuildYZPlane = (x, flipZ = false) => {
      const files = this.files === null ? this.props.files : this.files
      const getSlice = this.getMprSliceGetter(files)
      const halfWidth = slabHalfWidthFromMeta(this.mprData, this.mprSlabAxisSpacing('yz'))
      const mode = (this.mprData && this.mprData.slabMode) || 'thin'
      const need = Math.max(1, this.ySize | 0) * Math.max(1, this.zSize | 0)
      if (!this._mprBufYzPair || this._mprBufYzPair[0].length !== need) {
        this._mprBufYzPair = [new Int16Array(need), new Int16Array(need)]
        this._mprBufYzFlip = 0
      }
      const dest = this._mprBufYzPair[this._mprBufYzFlip & 1]
      this._mprBufYzFlip = (this._mprBufYzFlip + 1) & 1
      return projectYzPlane({
        getSlice,
        xSize: this.xSize,
        ySize: this.ySize,
        zSize: this.zSize,
        xi: x,
        halfWidth,
        mode,
        flipZ,
        dest,
      })
    }

    /**
     * Plano MPR oblicuo (pixelData ya muestreado).
     * @param {{
     *   columns:number, rows:number, pixelData:Int16Array,
     *   spacing:{rowPixelSpacing:number,columnPixelSpacing:number},
     *   role:string, matrix?:number[],
     *   u?:number[], v?:number[], n?:number[],
     *   center?:{x:number,y:number,z:number},
     *   spacingMm?:{sx:number,sy:number,sz:number},
     *   planeModule?:object,
     * }} opts
     */
    mprRenderObliquePlane = (opts) => {
      const files = this.files === null ? this.props.files : this.files
      if (!opts || !opts.pixelData) return
      const cols = Math.max(1, Number(opts.columns) || 1)
      const rows = Math.max(1, Number(opts.rows) || 1)
      this.mprPlane = String(opts.role || this.mprPlane || 'axial')
      this._mprPlaneKind = 'oblique'
      this._mprObliqueMatrix = opts.matrix || this.props.mprObliqueMatrix || null
      this.isMprGenerated = true
      this.xSize = cols
      this.ySize = rows
      if (files && files.length) {
        const mid = Math.max(0, Math.min(files.length - 1, Math.round(files.length / 2)))
        this.originImage =
          (files[mid] && files[mid].image) ||
          (files[0] && files[0].image) ||
          this.originImage
      }
      this.loadImageFromCustomObject(cols, rows, opts.pixelData, opts.spacing || {}, {
        kind: 'oblique',
        role: this.mprPlane,
        files,
        mprData: this.mprData,
        u: opts.u,
        v: opts.v,
        n: opts.n,
        center: opts.center,
        spacingMm: opts.spacingMm,
        planeModule: opts.planeModule || null,
      })
      // Overlay tras paint (loadImage es async)
      requestAnimationFrame(() => {
        try {
          this.updateObliqueOverlay()
        } catch (e) {
          /* ignore */
        }
      })
    }

    mprRenderXZPlane = (filename, origin, y, mprData) => {
      const files = this.files === null ? this.props.files : this.files
      if ((!this.volume || !this.volume.length) && !(files && files.length)) return

      this.mprData = mprData || this.mprData || {}
      ensureMprStackGeometry(files, this.mprData)

      this.sliceIndex = y

      this.filename = filename
      this._mprOriginPlane = origin || 'axial'
      // No disable: evita flash negro en cada scroll

      if (origin === 'sagittal')
        this.mprPlane = 'axial'
      else if (origin === 'axial')
        this.mprPlane = 'coronal'
      else if (origin === 'coronal')
        this.mprPlane = 'axial'
      else this.mprPlane = 'coronal'

      this._mprPlaneKind = 'xz'

      this.xSize = (files[0].columns != null ? files[0].columns : files[0].image.columns)
      this.ySize = (files[0].rows != null ? files[0].rows : files[0].image.rows)
      // Z = nº de cortes del stack (1:1), nunca matrix size (p.ej. 512)
      this.zSize = files.length
      if (this.mprData) this.mprData.zDim = files.length

      const i = Math.max(0, Math.min(files.length - 1, Math.trunc((y / Math.max(1, this.ySize - 1)) * (files.length - 1))))
      this.originImage = (files[i] && files[i].image) || (files[0] && files[0].image)
      if (!this.originImage) return

      const flipZ = shouldFlipMprZ(files, this.mprData)
      if (this.mprData) this.mprData.flipZ = flipZ
      const xzPlane = this.mprBuildXZPlane(y, flipZ)
      this.loadImageFromCustomObject(this.xSize, this.zSize, xzPlane, this.mprPlaneSpacing('xz'), {
        kind: 'xz',
        sliceIndex: y,
        files,
        mprData: this.mprData,
      })
    }
  
    mprBuildXZPlane = (y, flipZ = false) => {
      const files = this.files === null ? this.props.files : this.files
      const getSlice = this.getMprSliceGetter(files)
      const halfWidth = slabHalfWidthFromMeta(this.mprData, this.mprSlabAxisSpacing('xz'))
      const mode = (this.mprData && this.mprData.slabMode) || 'thin'
      const need = Math.max(1, this.xSize | 0) * Math.max(1, this.zSize | 0)
      if (!this._mprBufXzPair || this._mprBufXzPair[0].length !== need) {
        this._mprBufXzPair = [new Int16Array(need), new Int16Array(need)]
        this._mprBufXzFlip = 0
      }
      const dest = this._mprBufXzPair[this._mprBufXzFlip & 1]
      this._mprBufXzFlip = (this._mprBufXzFlip + 1) & 1
      return projectXzPlane({
        getSlice,
        xSize: this.xSize,
        ySize: this.ySize,
        zSize: this.zSize,
        yi: y,
        halfWidth,
        mode,
        flipZ,
        dest,
      })
    }

    mprRenderAxialSlab = (filename, z, mprData) => {
      const files = this.files === null ? this.props.files : this.files
      if ((!this.volume || !this.volume.length) && !(files && files.length)) return

      this.mprData = mprData || this.mprData || {}
      ensureMprStackGeometry(files, this.mprData)
      this.sliceIndex = z
      this.filename = filename
      this.xSize = (files[0].columns != null ? files[0].columns : files[0].image.columns)
      this.ySize = (files[0].rows != null ? files[0].rows : files[0].image.rows)
      this.zSize = files.length
      if (this.mprData) this.mprData.zDim = files.length

      const zi = Math.max(0, Math.min(files.length - 1, Math.round(z)))
      this.originImage = (files[zi] && files[zi].image) || (files[0] && files[0].image)
      if (!this.originImage) return

      const getSlice = this.getMprSliceGetter(files)
      const halfWidth = slabHalfWidthFromMeta(this.mprData, this.mprSlabAxisSpacing('axial'))
      const mode = (this.mprData && this.mprData.slabMode) || 'thin'
      const plane = projectAxialPlane({
        getSlice,
        xSize: this.xSize,
        ySize: this.ySize,
        zSize: this.zSize,
        zi,
        halfWidth,
        mode,
      })
      this.loadImageFromCustomObject(this.xSize, this.ySize, plane, this.mprPlaneSpacing('axial'), {
        sliceIndex: zi,
        files,
        mprData: this.mprData,
        nativeAxial: true,
      })
    }

    getMprSliceGetter = (files) => {
      const vol = this.volume
      if (vol && vol.length && files && vol.length === files.length) {
        const zSize = vol.length
        return (z) => {
          let slice = vol[z]
          if (slice) return slice
          let n = z
          while (n > 0 && !vol[n]) n--
          if (vol[n]) return vol[n]
          n = z
          while (n < zSize - 1 && !vol[n]) n++
          return vol[n] || null
        }
      }
      return (z) => {
        const img = files && files[z] && files[z].image
        if (!img || typeof img.getPixelData !== 'function') return null
        try {
          return img.getPixelData()
        } catch (e) {
          return null
        }
      }
    }

    mprSlabAxisSpacing = (kind) => {
      const origin = this.originImage || {}
      const md = this.mprData || {}
      const files = this.files === null ? this.props.files : this.files
      const colSp = Number(
        md.columnPixelSpacing != null ? md.columnPixelSpacing : origin.columnPixelSpacing || 0
      )
      const rowSp = Number(
        md.rowPixelSpacing != null ? md.rowPixelSpacing : origin.rowPixelSpacing || 0
      )
      let zSp = Number(md.zSpacing != null ? md.zSpacing : 0)
      if (!(zSp > 0) && files && files.length >= 2) {
        try {
          zSp = Number(computeZSpacingForVolume(files)) || 0
        } catch (e) {
          zSp = 0
        }
      }
      if (kind === 'xz') return rowSp > 0 ? rowSp : 1
      if (kind === 'yz') return colSp > 0 ? colSp : 1
      return zSp > 0 ? zSp : colSp > 0 ? colSp : 1
    }  

    mprIsOrthogonalView = () => {
      return (this.mprPlane !== '' && this.props.layout[0] === 1 && this.props.layout[1] === 3)
    }

    // Líneas MPR custom desactivadas: solo CornerstoneTools ReferenceLines
    mprReferenceLines = () => {
      if (this.mpr) {
        this.mpr.sliceLocation = null
        this.mpr.isSliceLocation = false
      }
    }

    mprReferenceLines2 = () => {
      this.mprReferenceLines()
    }

    mprReferenceLines3 = () => {
      this.mprReferenceLines()
    }

    mprSliceLocationDraw = () => {
      // no-op (antes: líneas amarillas canvas)
    }

    //#endregion

    // -------------------------------------------------------------------------------------------- REFERENCE LINES
    //#region REFERENCE LINES

    // see https://stackoverflow.com/questions/10241062/how-to-draw-scout-reference-lines-in-dicom
    //     http://www.dclunie.com/dicom3tools/workinprogress/dcpost.cc
    // 
    referenceLinesBuild = () => {
      // Método personalizado desactivado: solo CornerstoneTools ReferenceLines
      if (this.referenceLines) {
        this.referenceLines.isReferenceLine = false
        this.referenceLines.isScoutDraw = false
      }
    }

    referenceLinesBuildLine = () => {
      const dst = this.referenceLines.dst
      const src = this.referenceLines.src

      const nP = dst.nrmDir.dotProduct(dst.topLeft)
      const nA = dst.nrmDir.dotProduct(src.topLeft)
      const nB = dst.nrmDir.dotProduct(src.topRight)
      const nC = dst.nrmDir.dotProduct(src.bottomRight)
      const nD = dst.nrmDir.dotProduct(src.bottomLeft)

      let list = []

      if (!areEqual(nB, nA)) {
        const t = (nP - nA) / (nB - nA)
        if (t > 0 && t <= 1) 
          list.push(src.topLeft.add((src.topRight.sub(src.topLeft)).mul(t)))
      }

      if (!areEqual(nC, nB)) { 
        const t = (nP - nB) / (nC - nB)
        if (t > 0 && t <= 1)
          list.push(src.topRight.add((src.bottomRight.sub(src.topRight)).mul(t)))
      }
        
      if (!areEqual(nD, nC)) { 
        const t = (nP - nC) / (nD - nC)
        if (t > 0 && t <= 1)
          list.push(src.bottomRight.add((src.bottomLeft.sub(src.bottomRight)).mul(t)))
      }

      if (!areEqual(nA, nD)) { 
        const t = (nP - nD) / (nA - nD)
        if (t > 0 && t <= 1)
          list.push(src.bottomLeft.add((src.topLeft.sub(src.bottomLeft)).mul(t)))
      }

      // the destinationplane should have been crossed exactly two times
      if (list.length !== 2)
        return 

      // now back from 3D patient space to 2D pixel space
      const p = {
        startPoint: this.transformDstPatientPointToImage(list[0]),
        endPoint:   this.transformDstPatientPointToImage(list[1])
      }
      return p      
    }

    transformDstPatientPointToImage = (p) => {
      const v = new Matrix(
        [p.x], 
        [p.y], 
        [p.z], 
        [1]
      )
      const transformed = this.referenceLines.dst.transformRcsToImage.multiply(v)
      // validation, if the point is within the image plane, then the z-component of the transformed point should be zero
      const point = new Point(Math.round(transformed.get(0,0)), Math.round(transformed.get(1,0)))
      return point
    }

    referenceLinesBuildPlane = () => {
      const dst = this.referenceLines.dst 
      const src = this.referenceLines.src 

      let pos = []

      // TLHC is what is in ImagePositionPatient
      pos[0] = src.topLeft
      // TRHC
      pos[1] = src.topLeft.add(src.rowDir.mul(src.lengthX))
      // BRHC
      pos[2] = src.topLeft.add((src.rowDir.mul(src.lengthX)).add(src.colDir.mul(src.lengthY)))
      // BLHC
      pos[3] = src.topLeft.add(src.colDir.mul(src.lengthY))

      let pixel = []

      let rotation = new Matrix(
        dst.rowDir.toArray(),
        dst.colDir.toArray(),
        dst.nrmDir.toArray()
      )

      for (let i = 0; i < 4; i++) {            
          // move everything to origin of target
          pos[i] = pos[i].add(Point.zero.sub(dst.topLeft))

          // The rotation is easy ... just rotate by the row, col and normal vectors ...
          const m = rotation.multiply(pos[i].toMatrix())
          pos[i] = new Point(Math.round(m.get(0,0)), Math.round(m.get(1,0)), Math.round(m.get(2,0))) 

          // DICOM coordinates are center of pixel 1\1
          pixel[i] = new Point(Math.trunc(pos[i].x / dst.spacingY + 0.5),
                               Math.trunc(pos[i].y / dst.spacingX + 0.5))
      }         

      //console.log('referenceLinesBuildPlane: ', pixel)
      return pixel
    }

    referenceLinesDraw = () => {
      // Método personalizado desactivado: solo CornerstoneTools ReferenceLines
    }
    
    //#endregion


    dicomImageRef = el => {
      this.dicomImage = el
    }

    onImageClick = () => {
      //console.log('onImageClick: ')
    }

    isLocalizer = () => {
      return isLocalizer(this.image)
    }

    findFirstSliceWithIppValue = (ippValue, ippPos) => {
      const increasing = this.files[0].sliceDistance - this.files[this.files.length-1].sliceDistance < 0
      //console.log('DicomViewer - findFirstSliceWithIppValue, ippValue: ', ippValue)
      for(let i=0; i < this.files.length; i++) {
        const ipp = getDicomIpp(this.files[i].image, ippPos)
        //console.log(`DicomViewer - findFirstSliceWithIppValue, i: ${i}, ipp: ${ipp}`)
        if (increasing) {
          if (ipp >= ippValue) return i          
        } else {
          if (ipp <= ippValue) return i          
        }
      }
      return -1
    }

    render() {

      const visible = this.props.visible ? 'visible' : 'hidden'
      const isOpen = this.props.isOpen[this.props.index]
      const visibleOpenUrlDlg = this.state.visibleOpenUrlDlg
      const errorOnOpenImage = this.state.errorOnOpenImage
      const progress = this.state.progress

      const styleContainer = {
        width: '100%', 
        height: '100%', 
        border: (this.props.activeDcmIndex === this.props.index && (this.props.layout[0] > 1 || this.props.layout[1] > 1)) ? 'solid 1px #AAAAAA' : null,
        position: 'relative',
      }

      const styleDicomImage = {
        width: '100%', 
        height: '100%', 
        position: 'relative',
        transition: 'opacity 0.1s ease-in-out', // Transición suave para cambios de imagen
      }

      const overlay = getSettingsOverlay() && this.props.overlay

      return ( 
        <div className="container" style={styleContainer} >

          {visibleOpenUrlDlg ? <OpenUrlDlg progress={progress} onClose={this.hideOpenUrlDlg} /> : null}

          <Dialog
            open={errorOnOpenImage !== null}
            onClose={this.onErrorOpenImageClose}
          >
            <DialogTitle id="alert-dialog-title">{"Error on opening image"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {this.state.errorOnOpenImage}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onErrorOpenImageClose} autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.errorOnCors}
            onClose={this.onErrorCorsClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Error on loading image"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Typography gutterBottom>
                  CORS or Cross Origin Resource Sharing is a browser security policy 
                  that prevents javascript from loading data from a server with a different base URL 
                  than the server that served up the javascript file. 
                </Typography> 
                <Typography gutterBottom>
                  See the &nbsp; 
                  <Link href="http://enable-cors.org/" target='_blank' color='textPrimary'>
                    Enable CORS site
                  </Link>
                  &nbsp; for information about CORS.                     
                </Typography>                                
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.onErrorCorsClose} autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>

          <div
            style={{
              width: '100%', 
              height: '100%', 
              position: "relative",
              color:  '#FFFFFF',
              fontSize: '1.00em',
              textShadow: '1px 1px #000000',
              visibility: visible,
              touchAction: 'none', // Importante para evitar el scroll nativo del navegador
              overflow: 'hidden', // Clip líneas oblicuas al viewport
            }}
            onContextMenu={() => false}
            className="cornerstone-enabled-image"
          >

            <div 
              id={`viewer-${this.props.index}`}
              ref={this.dicomImageRef}
              style={{
                ...styleDicomImage,
                cursor: this.props.mprCrosshairActive ? 'crosshair' : undefined,
              }}
              onDoubleClick={(e) => this.toggleDoubleTapZoom(e.clientX, e.clientY)}
            >
              {!this.image && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    pointerEvents: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    opacity: 0.22,
                  }}
                  aria-hidden="true"
                >
                  <Icon path={mdiImageMultipleOutline} size={2.25} color="#ffffff" />
                </div>
              )}
              <canvas
                ref={(n) => {
                  this._petFusionCanvas = n
                }}
                aria-hidden="true"
                style={{
                  display: 'none',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: 8,
                }}
              />
              <canvas
                ref={(n) => {
                  this._dsaGpuCanvas = n
                }}
                aria-hidden="true"
                style={{
                  display: 'none',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '100%',
                  height: '100%',
                  pointerEvents: 'none',
                  zIndex: 9,
                }}
              />
              <div
                ref={(n) => {
                  this._crosshairEl = n
                }}
                aria-hidden="true"
                style={{
                  display: 'none',
                  position: 'absolute',
                  width: 18,
                  height: 18,
                  marginLeft: -9,
                  marginTop: -9,
                  pointerEvents: 'none',
                  zIndex: 20,
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    left: 8,
                    top: 0,
                    width: 2,
                    height: 18,
                    background: '#FFEB3B',
                    boxShadow: '0 0 1px #000',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 8,
                    width: 18,
                    height: 2,
                    background: '#FFEB3B',
                    boxShadow: '0 0 1px #000',
                  }}
                />
              </div>
              <div
                ref={(n) => {
                  this._crosshairH = n
                }}
                aria-hidden="true"
                style={{
                  display: 'none',
                  position: 'absolute',
                  left: 0,
                  width: '100%',
                  height: 1,
                  marginTop: -0.5,
                  background: 'rgba(255, 235, 59, 0.85)',
                  boxShadow: '0 0 1px #000',
                  pointerEvents: 'none',
                  zIndex: 19,
                }}
              />
              <div
                ref={(n) => {
                  this._crosshairV = n
                }}
                aria-hidden="true"
                style={{
                  display: 'none',
                  position: 'absolute',
                  top: 0,
                  height: '100%',
                  width: 1,
                  marginLeft: -0.5,
                  background: 'rgba(255, 235, 59, 0.85)',
                  boxShadow: '0 0 1px #000',
                  pointerEvents: 'none',
                  zIndex: 19,
                }}
              />
              {this.props.mprObliqueActive && this.state.obliqueOverlay ? (
                <svg
                  aria-hidden="true"
                  style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 21,
                    overflow: 'hidden',
                  }}
                >
                  {(this.state.obliqueOverlay.lines || []).map((ln) => (
                    <g key={`obliq-line-${ln.role}`}>
                      <line
                        x1={ln.x1}
                        y1={ln.y1}
                        x2={ln.x2}
                        y2={ln.y2}
                        stroke={ln.color}
                        strokeWidth={2}
                        strokeOpacity={0.95}
                        style={{ filter: 'drop-shadow(0 0 1px #000)' }}
                      />
                      {(ln.handles || []).map((h, hi) => (
                        <circle
                          key={`obliq-h-${ln.role}-${hi}`}
                          cx={h.x}
                          cy={h.y}
                          r={7}
                          fill={ln.color}
                          stroke="#111"
                          strokeWidth={1.5}
                          opacity={0.95}
                        />
                      ))}
                    </g>
                  ))}
                  <circle
                    cx={this.state.obliqueOverlay.center.x}
                    cy={this.state.obliqueOverlay.center.y}
                    r={8}
                    fill={this.state.obliqueOverlay.centerColor || '#FFEB3B'}
                    stroke="#111"
                    strokeWidth={2}
                    opacity={0.95}
                  />
                </svg>
              ) : null}
            </div>

            <div
              id={`mrtopleft-${this.props.index}`}
              style={{ position: "absolute", top: 0, left: 3, display: isOpen && overlay ? "" : "none" }}
            >
             
            </div>
            <div
              id={`dsaLabel-${this.props.index}`}
              style={{
                position: 'absolute',
                top: 4,
                right: 8,
                zIndex: 12,
                pointerEvents: 'none',
                display: 'none',
                backgroundColor: 'rgba(0, 0, 0, 0.55)',
                color: '#76FF03',
                fontSize: 11,
                fontWeight: 600,
                padding: '2px 6px',
                borderRadius: 4,
              }}
            />
            {/* Contador: no atar a isOpen (en PREVIEW isOpen llega tarde vía Redux y el hilo se congela) */}
            <ViewportCineScrollbar
              ref={this._cineScrollRef}
              onActivate={this.handleCineScrollbarActivate}
              onSeek={this.handleCineScrollbarSeek}
            />
            {this.props.mprLayoutActive &&
            this.props.mprSlabMode &&
            this.props.mprSlabMode !== 'thin' &&
            Number(this.props.mprSlabMm) > 0 ? (
              <div
                style={{
                  position: 'absolute',
                  bottom: 28,
                  left: 6,
                  zIndex: 12,
                  pointerEvents: 'none',
                  backgroundColor: 'rgba(0, 0, 0, 0.55)',
                  color: '#81C784',
                  fontSize: 11,
                  fontWeight: 600,
                  padding: '2px 6px',
                  borderRadius: 4,
                  textShadow: '1px 1px 2px #000',
                }}
              >
                {`${slabModeLabel(this.props.mprSlabMode)} ${Number(this.props.mprSlabMm)} mm`}
              </div>
            ) : null}
            <div
              id={`image-counter-${this.props.index}`}
              style={{ 
                position: "absolute", 
                top: 0, 
                right: 20, 
                display: this.files && this.files.length > 0 ? "block" : "none",
                color: '#4caf50',
                fontSize: '0.9em',
                fontWeight: '600',
                textShadow: '1px 1px 2px #000',
                zIndex: 10,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                padding: '4px 6px',
                borderRadius: '4px',
                maxWidth: '200px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                lineHeight: '1.2',
                pointerEvents: 'none',
              }}
            >
              {/* El contenido se actualiza dinámicamente (updateImageInfoDisplay) */}
            </div>
            {this.props.seriesLinkOn ? (
              <div
                style={{
                  position: 'absolute',
                  top: 28,
                  right: 20,
                  zIndex: 12,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 4,
                  backgroundColor: 'rgba(0, 0, 0, 0.55)',
                  borderRadius: 4,
                  padding: '2px 4px',
                  pointerEvents: 'auto',
                }}
              >
                <button
                  type="button"
                  title={
                    this.props.seriesLinkMember
                      ? 'Quitar este viewport del Link Series'
                      : 'Incluir este viewport en el Link Series'
                  }
                  onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    if (this.props.onSeriesLinkToggleMember) {
                      this.props.onSeriesLinkToggleMember(this.props.index)
                    }
                  }}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    padding: 0,
                    cursor: 'pointer',
                    opacity: this.props.seriesLinkMember ? 1 : 0.4,
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Icon
                    path={mdiVectorLink}
                    size={0.62}
                    color={this.props.seriesLinkMember ? '#81C784' : '#fff'}
                  />
                </button>
                {this.props.seriesLinkMember ? (
                  <>
                    <button
                      type="button"
                      title="Offset −1"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        if (this.props.onSeriesLinkOffset) {
                          this.props.onSeriesLinkOffset(this.props.index, -1)
                        }
                      }}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: 12,
                        padding: '0 2px',
                      }}
                    >
                      −
                    </button>
                    <span
                      style={{
                        color: '#81C784',
                        fontSize: 11,
                        minWidth: 14,
                        textAlign: 'center',
                        textShadow: '1px 1px 2px #000',
                      }}
                    >
                      {(this.props.seriesLinkOffset || 0) > 0
                        ? `+${this.props.seriesLinkOffset}`
                        : this.props.seriesLinkOffset || 0}
                    </span>
                    <button
                      type="button"
                      title="Offset +1"
                      onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        if (this.props.onSeriesLinkOffset) {
                          this.props.onSeriesLinkOffset(this.props.index, 1)
                        }
                      }}
                      style={{
                        border: 'none',
                        background: 'transparent',
                        color: '#fff',
                        cursor: 'pointer',
                        fontSize: 12,
                        padding: '0 2px',
                      }}
                    >
                      +
                    </button>
                  </>
                ) : null}
              </div>
            ) : null}
            <div
              id={`mrtopright-${this.props.index}`}
              style={{ position: "absolute", top: 0, right: 3, display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>
            <div
              id={`mrbottomright-${this.props.index}`}
              style={{ position: "absolute", bottom: 0, right: 3, display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>
            <div
              id={`mrbottomleft-${this.props.index}`}
              style={{ position: "absolute", bottom: 0, left: 3, display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>   

            <div
              id={`mrtopcenter-${this.props.index}`}
              style={{ position: "absolute", top: 0, width: '60px', left: '50%', marginLeft: '0px', display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>

            <div
              id={`mrleftcenter-${this.props.index}`}
              style={{ position: "absolute", top: '50%', width: '30px', left: 3, marginLeft: '0px', display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>    

            <div
              id={`mrrightcenter-${this.props.index}`}
              style={{ position: "absolute", top: '50%', width: '30px', right: 3, marginRight: '-20px', display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>                

            <div
              id={`mrbottomcenter-${this.props.index}`}
              style={{ position: "absolute", bottom: 0, width: '60px', left: '50%', marginLeft: '0px', display: isOpen && overlay ? "" : "none" }}
            >
              
            </div>

            {this.state.dsaHud &&
            this.state.dsaHud.enabled &&
            (() => {
              const cineOn =
                this.state.visibleCinePlayer && this.canUseCine()
              const dsaDock =
                (this.state.dsaHudLayout && this.state.dsaHudLayout.dock) || 'free'
              const linked =
                cineOn && (dsaDock === 'left' || dsaDock === 'right')
              const showFree = !cineOn || dsaDock === 'free' || !linked
              return showFree
                ? this.getDsaHudElement({ forceFree: true })
                : null
            })()}

            { this.state.visibleCinePlayer && this.canUseCine() ? (
              (() => {
                const dsaDock =
                  (this.state.dsaHudLayout && this.state.dsaHudLayout.dock) ||
                  'free'
                const dsaLinked =
                  this.state.dsaHud &&
                  this.state.dsaHud.enabled &&
                  (dsaDock === 'left' || dsaDock === 'right')
                const frameLabel = (
                  <div
                    id={`frameLabel-${this.props.index}`}
                    style={{
                      width: '100%',
                      margin: '0 auto',
                      marginTop: -4,
                      paddingBottom: 8,
                      textAlign: 'center',
                      fontSize: 14,
                      fontWeight: 600,
                      letterSpacing: 0.3,
                      color: 'rgba(255,255,255,0.95)',
                      textShadow: '0 1px 2px rgba(0,0,0,0.6)',
                      userSelect: 'none',
                      pointerEvents: 'none',
                    }}
                  >
                    {this.getCinePosition()} / {this.getCineTotal()}
                  </div>
                )
                const cineShell = (
                  <CinePanelShell
                    layout={
                      this.state.cinePanelLayout || {
                        dock: 'free',
                        x: Math.max(
                          8,
                          Math.round((window.innerWidth || 360) / 2 - 150)
                        ),
                        y: Math.max(8, (window.innerHeight || 640) - 220),
                      }
                    }
                    inPlay={!!this.state.inPlay}
                    onLayoutChange={this.handleCinePanelLayoutChange}
                    onUncouple={this.uncoupleFloatingPanels}
                    stopPointer={this.stopCinePointer}
                    frameLabel={frameLabel}
                  >
                    <CinePlayer
                      runCinePlayer={this.runCinePlayer}
                      inPlay={this.state.inPlay}
                      loop={this.state.cineLoop}
                      fps={this.state.cineFps}
                      onLoopChange={this.handleCineLoopChange}
                      onFpsChange={this.handleCineFpsChange}
                    />
                  </CinePanelShell>
                )

                if (dsaLinked) {
                  const dsaEl = this.getDsaHudElement()
                  const linkedLayout =
                    this.state.linkedPanelsLayout &&
                    this.state.linkedPanelsLayout.mode === 'free' &&
                    Number.isFinite(Number(this.state.linkedPanelsLayout.x))
                      ? this.state.linkedPanelsLayout
                      : {
                          mode: 'free',
                          x:
                            (this.state.cinePanelLayout &&
                              this.state.cinePanelLayout.x) ||
                            8,
                          y:
                            (this.state.cinePanelLayout &&
                              this.state.cinePanelLayout.y) ||
                            8,
                        }
                  return (
                    <LinkedPanelsGroup
                      layout={linkedLayout}
                      inPlay={!!this.state.inPlay}
                      onLayoutChange={this.handleLinkedPanelsLayoutChange}
                      onUncouple={this.uncoupleFloatingPanels}
                      stopPointer={this.stopCinePointer}
                      dsaSide={dsaDock === 'right' ? 'right' : 'left'}
                      dsaPanel={dsaEl}
                      cinePanel={cineShell}
                    />
                  )
                }

                return cineShell
              })()
              ) : null
            }
          </div>
        </div>
      )
    }
  }
  
const mapStateToProps = (state) => {
  return {
    files: state.files,
    series: state.series,
    url: state.url,
    isOpen: state.isOpen,
    tool: state.tool,
    activeDcmIndex: state.activeDcmIndex,
    activeDcm: state.activeDcm,
    explorerActiveSeriesIndex: state.explorerActiveSeriesIndex,
    measurements: state.measurements,
    layout: state.layout,
    fsCurrentDir: state.fsCurrentDir,
    fsCurrentList: state.fsCurrentList,
    volume: state.volume,
    dcmEnableTool: state.dcmEnableTool,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearingStore: () => dispatch(clearStore()),
    setIsOpenStore: (value) => dispatch(dcmIsOpen(value)),
    toolStore: (tool) => dispatch(dcmTool(tool)),
    setActiveDcm: (dcm) => dispatch(activeDcm(dcm)),
    setActiveMeasurements: (measurements) => dispatch(activeMeasurements(measurements)),
    makeFsRefresh: (dcm) => dispatch(doFsRefresh()),
    setDcmEnableToolStore: (value) => dispatch(setDcmEnableTool(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DicomViewer)
